import { W3E_LIST, createSelectList, MODULE_TYPE_OBJ, currencyList, PLASTIC_LIST } from '../enum/env'
import { VAT_SERVICE_TYPE, COMMON_SERVICE_TYPE } from '../enum/commonServiceType'

import { COMMON_COUNTRY } from '../enum/commonCountry'
import GenerateEnum from '../generateEnum'
import { globalThis, getLabelText } from '../utils.js'
import Decimal from 'decimal.js'
import { getConversionAfterName } from './fn.js'

const NB_TEST_CATEGORY_OPTIONS = [
  { label: '电子电器', value: '2' },
  { label: '化妆品', value: '4' },
  { label: '食品接触', value: '5' },
  { label: '婴童产品', value: '9' },
  { label: '饰品', value: '3' },
  { label: '轻工杂货', value: '7' },
  { label: '服装纺织', value: '6' },
  { label: '箱包/鞋材皮革', value: '8' },
  { label: '玩具', value: '1' }
]

const NB_TEST_COUNTRY_OPTIONS = [
  { label: '加拿大', value: '106' },
  { label: '美国', value: '101' },
  { label: '欧盟', value: '99' },
  { label: '中国', value: '298' },
  { label: '英国', value: '0' },
  { label: '其他国家', value: '600' }
]

const NB_TEST_PLATFORM_OPTIONS = [
  { label: '亚马逊', value: '0' },
  { label: 'Temu', value: '88' },
  { label: '希音', value: '7' },
  { label: 'Tiktok', value: '110' }
]

const NB_TEST_BRAND_OPTIONS = [
  { label: 'GANZ', value: '1' },
  { label: '瑞华', value: '2' },
  { label: 'A stepping stones', value: '3' },
  { label: '跨世', value: '4' },
  { label: 'NEXT', value: '5' },
  { label: '瑞幸', value: '6' }
]

const NB_TEST_SOURCE_TYPE = {
  PLATFORM: 'platform',
  BRAND: 'brand',
  OTHER: 'other'
}

const NB_TEST_SOURCE_TYPE_OPTIONS = [
  { label: '平台货源', value: NB_TEST_SOURCE_TYPE.PLATFORM },
  { label: '品牌货源', value: NB_TEST_SOURCE_TYPE.BRAND },
  { label: '非平台/品牌货源', value: NB_TEST_SOURCE_TYPE.OTHER }
]

const NB_TEST_CATEGORY_VALUE = {
  ELECTRICAL: '2',
  COSMETICS: '4',
  FOOD_CONTACT: '5',
  TEXTILE: '6',
  TOY: '1'
}

const NB_TEST_COUNTRY_VALUE = {
  CANADA: '106',
  UNITED_STATES: '101',
  EUROPEAN_UNION: '99'
}

const NB_TEST_PLATFORM_VALUE = {
  AMAZON: '0',
  TEMU: '88',
  SHEIN: '7',
  TIKTOK: '110'
}

const NB_TEST_BASIC_INFO_FIELD_CONFIG = {
  category: { label: '检测类别', options: NB_TEST_CATEGORY_OPTIONS },
  countryList: { label: '检测报告国家', options: NB_TEST_COUNTRY_OPTIONS },
  sourceType: { label: '检测产品货源类型', options: NB_TEST_SOURCE_TYPE_OPTIONS },
  platformList: { label: '产品销售平台', options: NB_TEST_PLATFORM_OPTIONS },
  brand: { label: '产品供货品牌', options: NB_TEST_BRAND_OPTIONS },
  applicationType: { label: '申请表类型', options: [] }
}

const NB_TEST_BASIC_INFO_COUNTRY_LIST_FIELD = 'testBasicInfoCountryList'

function parseNbTestBasicInfoFormData(value) {
  if (!value) return {}
  if (typeof value === 'object') {
    return value.changeTestServiceFormJson ? parseNbTestBasicInfoFormData(value.changeTestServiceFormJson) : value
  }

  try {
    const parsedValue = JSON.parse(value)
    return parsedValue && typeof parsedValue === 'object' ? parseNbTestBasicInfoFormData(parsedValue) : {}
  } catch (e) {
    return {}
  }
}

function getNbTestBasicInfoCountryList(value) {
  const countryList = parseNbTestBasicInfoFormData(value).countryList
  const countryValues = Array.isArray(countryList) ? countryList : typeof countryList === 'string' ? countryList.split(',') : []

  return Array.from(new Set(countryValues.map((item) => String(item).trim()).filter(Boolean))).join(',')
}

function getNbTestBasicInfoDisplayList(value, applicationTypeOptions = []) {
  const formData = parseNbTestBasicInfoFormData(value)
  const fieldKeys = ['category', 'countryList', 'sourceType']
  const sourceTypeFieldKeyMap = {
    [NB_TEST_SOURCE_TYPE.PLATFORM]: 'platformList',
    [NB_TEST_SOURCE_TYPE.BRAND]: 'brand',
    [NB_TEST_SOURCE_TYPE.OTHER]: 'applicationType'
  }
  const sourceTypeFieldKey = sourceTypeFieldKeyMap[formData.sourceType]

  if (sourceTypeFieldKey) fieldKeys.push(sourceTypeFieldKey)

  return fieldKeys
    .map((key) => {
      const config = NB_TEST_BASIC_INFO_FIELD_CONFIG[key] || {}
      const optionValues = Array.isArray(formData[key]) ? formData[key] : [formData[key]]
      const valueText = optionValues
        .filter((item) => item !== undefined && item !== null && item !== '')
        .map((item) => {
          if (key === 'applicationType' && formData.applicationTypeLabel) return formData.applicationTypeLabel
          const options = key === 'applicationType' && applicationTypeOptions.length ? applicationTypeOptions : config.options || []
          const option = options.find((optionItem) => String(optionItem.value) === String(item))
          return option ? option.label : item
        })
        .join(',')

      return {
        label: config.label || key,
        value: valueText
      }
    })
    .filter((item) => item.value)
}

// 获取指定属性值，name属性名称，list属性数组
function getAttributeVal(list, name, val) {
  let data = list.find((x) => x.attributeSign == name)
  return data ? data[val] : ''
}

function getPriceSymbol(orderCurrency, type) {
  switch (type) {
    case 1:
      // 获取货币名称
      return (
        currencyList.find((item) => item.value == orderCurrency)?.label ||
        getLabelText({
          key: 'remote.common.rmb',
          text: getLabelText({ key: 'remote.common.rmb', text: '人民币' })
        })
      )
    default:
      // 获取货币符号
      return currencyList.find((item) => item.value == orderCurrency)?.symbol || '￥'
  }
}

const TAX_TYPE_LIST = [
  { value: 'VAT', label: 'VAT' },
  { value: 'JCT', label: 'JCT' },
  { value: 'RFC', label: 'RFC' },
  { value: 'GST', label: 'GST' },
  {
    value: 'CT',
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeChemicalTax',
      text: '化学税'
    })
  },
  { value: 'VOEC', label: 'VOEC' },
  { value: 'IOSS', label: 'IOSS' },
  { value: 'OSS', label: 'OSS' }
  // { value: 'PMT', label: '塑料税' },
]
const BATTERY_WEIGHT_LIST = [
  {
    value: 0,
    label: '1-50' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 1,
    label: '51-150' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 2,
    label: '151-250' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 3,
    label: '251-500' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 4,
    label: '501-750' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 5,
    label: '751-1000' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 6,
    label: getLabelText({
      key: 'remote.common.buttonBattery',
      text: '纽扣电池'
    })
  },
  {
    value: 7,
    label: '1001-2000' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  // 只有申报有 订单 服务资料没有
  {
    value: 8,
    label: '1-15' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 9,
    label: '16-30' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 10,
    label: '31-50' + getLabelText({ key: 'remote.common.gram', text: '克' })
  },
  {
    value: 11,
    label: '2001-4000' + getLabelText({ key: 'remote.common.gram', text: '克' })
  }
]

// 申报多平台授权状态，是由AWS衍生
export const PLAT_AUTH_STATUS_ENUM_PRODUCT = new GenerateEnum({
  // 授权过期
  EXPIRED: {
    value: -1,
    label: getLabelText({ key: 'remote.common.expired' })
  },
  // 未授权
  PROCESS: {
    value: 0,
    label: getLabelText({ key: 'remote.common.notAuthorized' }),
    showLabel: getLabelText({ key: 'remote.declare.multiPlatform.authorizingInProgress' })
  },
  // 已授权
  SUCCESS: {
    value: 1,
    label: getLabelText({ key: 'remote.enumerate.inEffect2' }),
    className: 'text-success',
    color: '#27C688',
    linkIcon: 'shouquanchenggong'
  },
  // 失败
  FAIL: {
    value: 2,
    label: getLabelText({ key: 'remote.common.authorizationFailed' }),
    className: 'text-danger',
    color: '#F5222D',
    linkIcon: 'shouquanshixiao'
  },
  // 已取消授权 已取消
  CANCEL: {
    value: 3,
    label: getLabelText({ key: 'remote.common.cancelled' })
  },
  // 授权失效 已失效
  INVALIDITY: {
    value: 4,
    label: getLabelText({ key: 'remote.common.expired3' })
  }
})

// 多平台授权经营模式

export const COOPERATION_MODEL = new GenerateEnum({
  SEMI_MANAGED: {
    value: 'semi-managed',
    label: getLabelText({ key: 'remote.declare.multiPlatformAuth.semiManaged' })
  },
  SELF_OPERATION: {
    value: 'self-operation',
    label: getLabelText({
      key: 'remote.declare.multiPlatformAuth.selfOperation'
    })
  },
  FULL_MANAGED_DESC: {
    value: 'full-managed',
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.fullManagedDescription'
    })
  }
})

const BATTERY_TYPE_INFO = {
  3001: getLabelText({ key: 'remote.common.lithium', text: '锂' }),
  3002: getLabelText({ key: 'remote.common.nickelAndZinc', text: '镍锌' }),
  3003: getLabelText({ key: 'remote.common.zincAir', text: '锌空气' }),
  3004: getLabelText({ key: 'remote.common.alkaliManganese', text: '碱锰' }),
  3005: getLabelText({ key: 'remote.common.zincCarbon', text: '锌碳' }),
  3006: getLabelText({ key: 'remote.common.silverOxide', text: '氧化银' }),
  // 3007: '氧化汞',
  3008: getLabelText({ key: 'remote.common.lead', text: '铅' }),
  3009: getLabelText({ key: 'remote.common.nickelHydrogen', text: '镍氢' }),
  3010: getLabelText({ key: 'remote.common.lithiumIon', text: '锂离子' }),
  3011: getLabelText({ key: 'remote.common.nickelCadmium', text: '镍镉' }),
  3012: getLabelText({ key: 'remote.common.lithiumPolymer', text: '锂聚合物' })
}

const BATTERY_TYPE_OPTIONS = Object.keys(BATTERY_TYPE_INFO).map((key) => {
  return {
    label: BATTERY_TYPE_INFO[key],
    value: String(key),
    name: BATTERY_TYPE_INFO[key],
    type: false
  }
})

const taxCountryList = [
  {
    id: 0,
    name: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    icon: 'yingguo'
  },
  {
    id: 2,
    name: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    icon: 'deguo'
  },
  {
    id: 1,
    name: getLabelText({ key: 'remote.common.france', text: '法国' }),
    icon: 'faguo'
  },
  {
    id: 3,
    name: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    icon: 'yidali'
  },
  {
    id: 4,
    name: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    icon: 'xibanya'
  },
  {
    id: 5,
    name: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    icon: 'bolan'
  },
  {
    id: 6,
    name: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
    icon: 'jieke'
  },
  {
    id: 7,
    name: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
    icon: 'helan'
  },
  {
    id: 11,
    name: getLabelText({ key: 'remote.common.saudiArabia', text: '沙特' }),
    icon: 'shate'
  },
  {
    id: 12,
    name: getLabelText({
      key: 'remote.common.unitedArabEmirates',
      text: '阿联酋'
    }),
    icon: 'alianqiu'
  }
]

const serviceItems = [
  {
    label: getLabelText({
      key: 'remote.common.shareholderChange',
      text: '股东变更'
    }),
    value: '1'
  },
  {
    label: getLabelText({
      key: 'remote.common.directorChange',
      text: '董事变更'
    }),
    value: '2'
  },
  {
    label: getLabelText({
      key: 'remote.common.directorAndShareholderChange',
      text: '董事股东变更'
    }),
    value: '3'
  },
  {
    label: getLabelText({
      key: 'remote.common.companyNameChange',
      text: '公司名称变更'
    }),
    value: '4'
  },
  {
    label: getLabelText({
      key: 'remote.common.businessScopeChange',
      text: '经营范围变更'
    }),
    value: '5'
  },
  {
    label: getLabelText({
      key: 'remote.common.BRAddressChange',
      text: 'BR地址变更'
    }),
    value: '6'
  },
  {
    label: getLabelText({
      key: 'remote.common.CPAVerificationCopy',
      text: 'CPA核实本'
    }),
    value: '7'
  },
  {
    label: getLabelText({ key: 'remote.common.capitalIncrease', text: '增资' }),
    value: '9'
  },
  {
    label: getLabelText({
      key: 'remote.common.articlesOfAssociation2',
      text: '章程'
    }),
    value: '10'
  },
  {
    label: getLabelText({ key: 'remote.common.companySeal', text: '印章' }),
    value: '11'
  },
  {
    label: getLabelText({ key: 'remote.common.fileTransfer', text: '调档' }),
    value: '12'
  },
  {
    label: `${getLabelText({
      key: 'remote.common.sNotarization',
      text: '律师公证'
    })}(${getLabelText({ key: 'remote.common.halfSet', text: '半套' })})`,
    value: '13'
  },
  {
    label: `${getLabelText({
      key: 'remote.common.sNotarization',
      text: '律师公证'
    })}(${getLabelText({ key: 'remote.common.fullSet', text: '半套' })})`,
    value: '14'
  },
  {
    label: getLabelText({
      key: 'remote.common.HongKongBarcode',
      text: '香港条形码'
    }),
    value: '15'
  },
  {
    label: getLabelText({
      key: 'remote.common.DUNSNumber',
      text: '邓白氏编码'
    }),
    value: '16'
  },
  {
    label: getLabelText({
      key: 'remote.common.taxPaymentOnBehalf',
      text: '代缴税'
    }),
    value: '17'
  },
  {
    label: getLabelText({ key: 'remote.common.ODIFiling', text: 'ODI备案' }),
    value: '18'
  },
  {
    label: getLabelText({ key: 'remote.common.hkBranch', text: '香港分行' }),
    value: '19'
  },
  {
    label: getLabelText({
      key: 'remote.common.purchaseRegistrationCertificate',
      text: '购买注册证书'
    }),
    value: '20'
  },
  {
    label: getLabelText({
      key: 'remote.common.salaryTaxReturn',
      text: '薪俸税实报'
    }),
    value: '21'
  },
  {
    label: getLabelText({
      key: 'remote.admin.odiCancellation',
      text: 'ODI注销'
    }),
    value: '28'
  },
  {
    label: getLabelText({
      key: 'remote.admin.changeDIrectiorOrShareholderInfo',
      text: '董事/股东信息变更'
    }),
    value: '23'
  },
  {
    label: getLabelText({
      key: 'remote.admin.otherServices',
      text: '其他服务'
    }),
    value: '24'
  },
  {
    label: getLabelText({
      key: 'remote.common.independentAddrNotSuitableForOfficeUse',
      text: '独立地址(不可办公)'
    }),
    value: '25'
  },
  {
    label: getLabelText({
      key: 'remote.common.independentAddrSuitableForOfficeUse',
      text: '独立地址(可办公)'
    }),
    value: '26'
  },
  {
    label: getLabelText({
      key: 'remote.common.staffInsuranceAndTaxDeclaration',
      text: '职员保险及个税申报'
    }),
    value: '29'
  },
  {
    label: getLabelText({
      key: 'remote.common.coupangPayNextDayPayment',
      text: 'Coupang Pay隔日回款'
    }),
    value: '30'
  },
  {
    label: getLabelText({
      key: 'remote.common.reissueMobileCardLgu',
      text: '增加/补办手机卡（仅LGU+）'
    }),
    value: '31'
  },
  {
    label: getLabelText({
      key: 'remote.common.reissueOtp',
      text: '补办OTP'
    }),
    value: '32'
  },
  {
    label: getLabelText({
      key: 'remote.common.reissueOfficialSeal',
      text: '补办公章'
    }),
    value: '33'
  },
  {
    label: getLabelText({
      key: 'remote.common.applyForeignExchange',
      text: '申请外汇'
    }),
    value: '34'
  },
  {
    label: getLabelText({
      key: 'remote.common.updateInformation',
      text: '更新资料'
    }),
    value: '35'
  },
  {
    label: getLabelText({
      key: 'remote.common.bankCreditLimitIncrease',
      text: '银行提额'
    }),
    value: '36'
  },
  {
    label: getLabelText({
      key: 'remote.common.reissueCorporateCard',
      text: '补办法人卡'
    }),
    value: '37'
  },
  {
    label: getLabelText({
      key: 'remote.common.changeOfLegalRepresentative',
      text: '法人代表变更'
    }),
    value: '38'
  },
  {
    label: getLabelText({
      key: 'remote.common.iorService',
      text: 'IOR服务'
    }),
    value: '39'
  },
  {
    label: getLabelText({
      key: 'remote.common.electronicTaxFilingAccountApplication',
      text: '香港电子报税账号申请'
    }),
    value: '40'
  },
  {
    label: getLabelText({
      key: 'remote.common.koreaCompanyReappointment',
      text: '韩国公司续任'
    }),
    value: '45'
  },
  {
    label: getLabelText({
      key: 'remote.common.naverStoreOnboarding',
      text: 'NAVER店铺入驻'
    }),
    value: '42'
  },
  {
    label: getLabelText({
      key: 'remote.common.bankKycVerification',
      text: '银行KYC认证'
    }),
    value: '43'
  },
  {
    label: getLabelText({
      key: 'remote.common.bankAccountUnblocking',
      text: '银行账户解封'
    }),
    value: '44'
  },
  {
    label: getLabelText({
      key: 'remote.common.iorAgencyFee',
      text: 'IOR代理费'
    }),
    value: '41'
  }
]

// 西班牙的W3E
const ES_W3E_LIST2 = [
  {
    key: '${"key":"1864608935336423424","name":"温度交换设备"}',
    name: getLabelText({
      key: 'remote.common.heatExchanger1NewVersion',
      text: '温度交换设备'
    }),
    value: '5001',
    type: false,
    status: '5001',
    id: '0'
  },
  {
    key: '${"key":"1864609263029006336","name":"屏幕面积大于100平方厘米的显示器、屏幕和设备"}',
    name: getLabelText({
      key: 'remote.common.displayOrScreenNewVersion',
      text: '屏幕面积大于100平方厘米的显示器、屏幕和设备'
    }),
    value: '5002',
    type: false,
    status: '5002',
    id: '1'
  },
  {
    key: '${"key":"1864609373452447744","name":"照明设备"}',
    name: getLabelText({
      key: 'remote.common.lightingEquipment',
      text: '照明设备'
    }),
    value: '5003',
    type: false,
    status: '5003',
    id: '2'
  },
  {
    key: '${"key":"1864609466133983232","name":"大型设备（尺寸大于50厘米）"}',
    name: getLabelText({
      key: 'remote.common.largeElectronicEquipmentNewVersion',
      text: '大型设备（尺寸大于50厘米）'
    }),
    value: '5004',
    type: false,
    status: '5004',
    id: '3'
  },
  {
    key: '${"key":"1864609809001558016","name":"小型电器（任何外部尺寸均不超过50厘米）"}',
    name: getLabelText({
      key: 'remote.common.smallElectronicAndElectricalEquipmentNewVersion',
      text: '小型电器（任何外部尺寸均不超过50厘米）'
    }),
    value: '5005',
    type: false,
    status: '5005',
    id: '4'
  },
  {
    key: '${"key":"1864609874751467520","name":"小型IT和电信通信设备"}',
    name: getLabelText({
      key: 'remote.common.smallITAndTelecommunicationEquipmentNewVersion',
      text: '小型IT和电信通信设备'
    }),
    value: '5006',
    type: false,
    status: '5006',
    id: '5'
  },
  {
    key: '${"key":"1864609960873111552","name":"大型光伏面板（尺寸大于50厘米）"}',
    name: getLabelText({
      key: 'remote.common.largePhotovoltaicPanelsNewVersion',
      text: '大型光伏面板（尺寸大于50厘米）'
    }),
    value: '5007',
    type: false,
    status: '5007',
    id: '6'
  }
]

// 西班牙的电池大类
const ES_BATTERY_LIST = [
  {
    label: getLabelText({
      key: 'remote.common.buttonBattery',
      text: '纽扣电池'
    }),
    value: '6001',
    configId: '6001',
    categoryName: getLabelText({
      key: 'remote.common.buttonBattery',
      text: '纽扣电池'
    })
  },
  {
    label: getLabelText({
      key: 'remote.common.alkalineBattery',
      text: '碱性电池'
    }),
    value: '6002',
    configId: '6002',
    categoryName: getLabelText({
      key: 'remote.common.alkalineBattery',
      text: '碱性电池'
    })
  },
  {
    label: getLabelText({
      key: 'remote.common.carbonBattery',
      text: '碳性电池'
    }),
    value: '6003',
    configId: '6003',
    categoryName: getLabelText({
      key: 'remote.common.carbonBattery',
      text: '碳性电池'
    })
  },
  {
    label: getLabelText({
      key: 'remote.common.lithiumBattery',
      text: getLabelText({
        key: 'remote.common.lithiumBattery',
        text: '锂电池'
      })
    }),
    value: '6004',
    configId: '6004',
    categoryName: getLabelText({
      key: 'remote.common.lithiumBattery',
      text: getLabelText({
        key: 'remote.common.lithiumBattery',
        text: '锂电池'
      })
    })
  },
  {
    label: getLabelText({
      key: 'remote.common.lithiumIonBattery',
      text: '锂离子电池'
    }),
    value: '6005',
    configId: '6005',
    categoryName: getLabelText({
      key: 'remote.common.lithiumIonBattery',
      text: '锂离子电池'
    })
  },
  {
    label: getLabelText({ key: 'remote.common.battery2', text: '蓄电池' }),
    value: '6006',
    configId: '6006',
    categoryName: getLabelText({
      key: 'remote.common.battery2',
      text: '蓄电池'
    })
  }
]

// 西班牙的电池规格
const ES_BATTERY_SPEC = [
  {
    label: getLabelText({ key: 'remote.common.alkaline', text: '碱性' }),
    value: '7001',
    configId: '7001',
    categoryName: getLabelText({ key: 'remote.common.alkaline', text: '碱性' }),
    show: ['6001']
  },
  {
    label: getLabelText({ key: 'remote.common.lithium', text: '锂' }),
    value: '7002',
    configId: '7002',
    categoryName: getLabelText({ key: 'remote.common.lithium', text: '锂' }),
    show: ['6001']
  },
  {
    label: `2A（${getLabelText({
      key: 'remote.common.batteryNo5',
      text: '5号电池'
    })}）`,
    value: '7003',
    configId: '7003',
    categoryName: `2A（${getLabelText({
      key: 'remote.common.batteryNo5',
      text: '5号电池'
    })}）`,
    show: ['6002', '6003', '6004']
  },
  {
    label: `3A（${getLabelText({
      key: 'remote.common.batteryNo7',
      text: '7号电池'
    })}）`,
    value: '7004',
    configId: '7004',
    categoryName: `3A（${getLabelText({
      key: 'remote.common.batteryNo7',
      text: '7号电池'
    })}）`,
    show: ['6002', '6003', '6004']
  },
  {
    label: `C（${getLabelText({
      key: 'remote.common.batteryNo2',
      text: '2号电池'
    })}）`,
    value: '7005',
    configId: '7005',
    categoryName: `C（${getLabelText({
      key: 'remote.common.batteryNo2',
      text: '2号电池'
    })}）`,
    show: ['6002', '6003']
  },
  {
    label: `9V(${getLabelText({
      key: 'remote.common.laminatedBattery',
      text: '叠层电池'
    })})`,
    value: '7006',
    configId: '7006',
    categoryName: `9V(${getLabelText({
      key: 'remote.common.laminatedBattery',
      text: '叠层电池'
    })})`,
    show: ['6002', '6003']
  },
  {
    label: `Petaca（${getLabelText({
      key: 'remote.common.fannyPackBattery',
      text: '腰包电池'
    })}）`,
    value: '7007',
    configId: '7007',
    categoryName: `Petaca（${getLabelText({
      key: 'remote.common.fannyPackBattery',
      text: '腰包电池'
    })}）`,
    show: ['6002', '6003']
  },
  {
    label: `D（${getLabelText({
      key: 'remote.common.batteryNo1',
      text: '1号电池'
    })}）`,
    value: '7008',
    configId: '7008',
    categoryName: `D（${getLabelText({
      key: 'remote.common.batteryNo1',
      text: '1号电池'
    })}）`,
    show: ['6002', '6003']
  },
  {
    label: getLabelText({
      key: 'remote.common.forMobilePhones',
      text: '手机用'
    }),
    value: '7009',
    configId: '7009',
    categoryName: getLabelText({
      key: 'remote.common.forMobilePhones',
      text: '手机用'
    }),
    show: ['6005']
  },
  {
    label: getLabelText({
      key: 'remote.common.forTheNotebook',
      text: '笔记本用'
    }),
    value: '7010',
    configId: '7010',
    categoryName: getLabelText({
      key: 'remote.common.forTheNotebook',
      text: '笔记本用'
    }),
    show: ['6005']
  },
  {
    label: getLabelText({ key: 'remote.common.forFlatPanel', text: '平板用' }),
    value: '7011',
    configId: '7011',
    categoryName: getLabelText({
      key: 'remote.common.forFlatPanel',
      text: '平板用'
    }),
    show: ['6005']
  },
  {
    label: getLabelText({ key: 'remote.common.industrialUse', text: '工业用' }),
    value: '7012',
    configId: '7012',
    categoryName: getLabelText({
      key: 'remote.common.industrialUse',
      text: '工业用'
    }),
    show: ['6006']
  }
]

// 法国电池法应用类型
const FR_APP_TYPE = [
  {
    label: getLabelText({
      key: 'remote.common.hearingHealthcare',
      text: '听力保健方面'
    }),
    value: 'Hearing care'
  },
  { label: 'DIY', value: 'DIY' },
  {
    label: getLabelText({
      key: 'remote.common.cookingSeries',
      text: '烹饪系列'
    }),
    value: 'Cooking'
  },
  {
    label: getLabelText({
      key: 'remote.common.lightingSeries',
      text: '照明系列'
    }),
    value: 'Lighting'
  },
  {
    label: getLabelText({
      key: 'remote.common.InCarEquipmentSeries',
      text: '车载设备系列'
    }),
    value: 'Car equipment'
  },
  {
    label: getLabelText({
      key: 'remote.common.audioEquipmentSeries',
      text: '音响设备系列'
    }),
    value: 'Hi-fi'
  },
  {
    label: getLabelText({ key: 'remote.common.toySeries', text: '玩具系列' }),
    value: 'Toys'
  },
  {
    label: getLabelText({
      key: 'remote.common.medicalSeries',
      text: '医用系列'
    }),
    value: 'Medical'
  },
  {
    label: getLabelText({
      key: 'remote.common.computerOrITSeries',
      text: '电脑/IT系列'
    }),
    value: 'Computer/IT'
  },
  {
    label: getLabelText({ key: 'remote.common.toolSeries', text: '工具系列' }),
    value: 'Tools'
  },
  {
    label: getLabelText({
      key: 'remote.common.photographySeries',
      text: '摄影系列'
    }),
    value: 'Photo'
  },
  {
    label: getLabelText({
      key: 'remote.common.securitySeries',
      text: '安保系列'
    }),
    value: 'Safety/Security'
  },
  {
    label: getLabelText({
      key: 'remote.common.sportsSeries',
      text: '运动系列'
    }),
    value: 'Sport'
  },
  {
    label: getLabelText({
      key: 'remote.common.personalCareSeries',
      text: '个人护理系列'
    }),
    value: 'Personal care'
  },
  {
    label: getLabelText({
      key: 'remote.common.mobilePhoneSeries',
      text: '手机系列'
    }),
    value: 'Phone'
  },
  {
    label: getLabelText({ key: 'remote.common.videoSeries', text: '视频系列' }),
    value: 'Video'
  },
  {
    label: getLabelText({ key: 'remote.common.other', text: '其他' }),
    value: 'Other'
  }
]

// 法国电池法集成方式
const FR_INTEGRATE_MODE = [
  {
    label: getLabelText({
      key: 'remote.common.integratedIntoTheDevice',
      text: '集成在设备中'
    }),
    value: 'Integrated into appliance'
  },
  {
    label: getLabelText({
      key: 'remote.common.separateFromEquipment',
      text: '与设备分离'
    }),
    value: 'Sold separately from appliance'
  }
]

const keepGrain = [
  {
    value: 'Amazon Fulfillment Center Amazonstr.1 Bad Hersfeld/Obere Kühnbach 36251 DE(FRA3)',
    label: 'Amazon Fulfillment Center Amazonstr.1 Bad Hersfeld/Obere Kühnbach 36251 DE(FRA3)'
  },
  {
    value: 'Amazon Fulfillment Center Amazonstr.1 Bad Hersfeld/Obere Kühnbach 36251 DE(FRA1）',
    label: 'Amazon Fulfillment Center Amazonstr.1 Bad Hersfeld/Obere Kühnbach 36251 DE(FRA1）'
  },
  {
    value: 'Amazon Fulfilment Center KTW1 via:Amm GmbH&Co KG Spedition Hamburger Str.99 Nuemberg Bavaria 90451 DE(KTW1)',
    label: 'Amazon Fulfilment Center KTW1 via:Amm GmbH&Co KG Spedition Hamburger Str.99 Nuemberg Bavaria 90451 DE(KTW1)'
  },
  {
    value: 'Amazon Fulfillment Center Amazonstrasse 1  Pforzheim 75177  DE(STR1)',
    label: 'Amazon Fulfillment Center Amazonstrasse 1  Pforzheim 75177  DE(STR1)'
  },
  {
    value: 'Amazon Fulfillment Center AMAZONSTRASSE1 Leipzig,Saxong 04347 DE(LEJ1)',
    label: 'Amazon Fulfillment Center AMAZONSTRASSE1 Leipzig,Saxong 04347 DE(LEJ1)'
  },
  {
    value: 'Amazon Fulfillment Center Amazonstrasse 1 Kobem-Gondorf 56330 DE(CGN1)',
    label: 'Amazon Fulfillment Center Amazonstrasse 1 Kobem-Gondorf 56330 DE(CGN1)'
  },
  {
    value: 'Amazon Fulfillment Center Wahrbrink 23Werne/Lippe Building59368 DE(EDE5)',
    label: 'Amazon Fulfillment Center Wahrbrink 23Werne/Lippe Building59368 DE(EDE5)'
  },
  {
    value: 'Amazon Fulfilment Center WRO5 via:Amm GmbH&Co KG Spedition Hamburger Str.99 Nuemberg Bavaria 90451 DE(WRO5)',
    label: 'Amazon Fulfilment Center WRO5 via:Amm GmbH&Co KG Spedition Hamburger Str.99 Nuemberg Bavaria 90451 DE(WRO5)'
  },
  {
    value: 'Amazon Fulfilment Center Kaltbandstrasse 4 Dortmeund, North Rhine-Westphalia, 44145 DE（DTM2）',
    label: 'Amazon Fulfilment Center Kaltbandstrasse 4 Dortmeund, North Rhine-Westphalia, 44145 DE（DTM2）'
  },
  {
    value: 'Amazon Fulfillment Center Amazonstrasse 1  Rheinberg 47495 DE(DUS2)',
    label: 'Amazon Fulfillment Center Amazonstrasse 1  Rheinberg 47495 DE(DUS2)'
  },
  {
    value: 'Amazon Fulfillment Center Aurea 10 Oelde,Nordrhein-Westfalen 59302 DE(PDA1)',
    label: 'Amazon Fulfillment Center Aurea 10 Oelde,Nordrhein-Westfalen 59302 DE(PDA1)'
  },
  {
    value: 'Amazon Fulfillment Center CarI-Zeiss-Straβe 3 Werne,Nordrhein-WestfaIen/Amsberg 59368 DE(DTM1)',
    label: 'Amazon Fulfillment Center CarI-Zeiss-Straβe 3 Werne,Nordrhein-WestfaIen/Amsberg 59368 DE(DTM1)'
  },
  {
    value: 'Amazon Fulfillment Center Aurea 10 Oelde, Nordrhein-Westfalen 59302 DE (PAD1)',
    label: 'Amazon Fulfillment Center Aurea 10 Oelde, Nordrhein-Westfalen 59302 DE (PAD1)'
  },
  {
    value: 'Amazon Fulfillment Center Amazonstrasse 1 Graben 86836 DE (MUC3)',
    label: 'Amazon Fulfillment Center Amazonstrasse 1 Graben 86836 DE (MUC3)'
  },
  {
    value: 'Amazon Fulfillment Center Bielefelder Str.9 Sulzetal,Saxony-Anhalt 39171 DE(LEJ3)',
    label: 'Amazon Fulfillment Center Bielefelder Str.9 Sulzetal,Saxony-Anhalt 39171 DE(LEJ3)'
  },
  {
    value: 'Amazon Fulfillment Center Hamburgring 10 Rheindahlen,Monchengladbach 41179 DE(DUS4)',
    label: 'Amazon Fulfillment Center Hamburgring 10 Rheindahlen,Monchengladbach 41179 DE(DUS4)'
  },
  {
    value: 'Amazon Fulfillment Center Borgwardstrasse 10 Winsen an der Luhe, Lower Saxony 21423 DE (HAM2)',
    label: 'Amazon Fulfillment Center Borgwardstrasse 10 Winsen an der Luhe, Lower Saxony 21423 DE (HAM2)'
  },
  {
    value: 'Amazon Fulfillment Center Zum Haarstrauch 9-15 Hammersbach,Hesse 63546 DE(XFR1)',
    label: 'Amazon Fulfillment Center Zum Haarstrauch 9-15 Hammersbach,Hesse 63546 DE(XFR1)'
  },
  {
    value: 'Amazon Fulfillment Center Am Römig 5 Frankenthal (Pfalz), Rhineland-Palatinate 67227 DE (FRA7)',
    label: 'Amazon Fulfillment Center Am Römig 5 Frankenthal (Pfalz), Rhineland-Palatinate 67227 DE (FRA7)'
  }
]

const genderArr = {
  0: getLabelText({ key: 'remote.common.male', text: '男' }),
  1: getLabelText({ key: 'remote.common.female', text: '女' })
}

const taxPeriodArr = {
  0: getLabelText({
    key: 'remote.common.monthlyDeclaration',
    text: '月度申报'
  }),
  1: getLabelText({
    key: 'remote.common.quarterlyDeclaration',
    text: '季度申报'
  })
}

const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const applyEoriObj = {
  0: getLabelText({ key: 'remote.common.yes', text: '是' }),
  1: getLabelText({ key: 'remote.common.no.text', text: '否' })
}

const vatTerminationOptions = [
  {
    value: '1',
    label: getLabelText({ key: 'remote.common.authorization', text: '授权' }),
    children: [
      {
        value: '0',
        label: getLabelText({
          key: 'remote.common.notAuthorized',
          text: '未授权'
        })
      },
      {
        value: '1',
        label: getLabelText({
          key: 'remote.common.authorizationInProgress',
          text: '授权中'
        })
      },
      {
        value: '4',
        label: getLabelText({
          key: 'remote.common.authorized',
          text: '已授权'
        }),
        children: [
          {
            value: 'stop',
            label: getLabelText({
              key: 'remote.common.inTheProcessOfTerminationConfirmation',
              text: '终止确认中'
            })
          },
          {
            value: 'other',
            label: getLabelText({ key: 'remote.common.other', text: '其他' })
          }
        ]
      }
    ]
  },
  {
    value: '2',
    label: getLabelText({ key: 'remote.common.termination', text: '终止' }),
    children: [
      {
        value: '11',
        label: getLabelText({
          key: 'remote.common.terminating',
          text: '终止中'
        })
      },
      {
        value: '12',
        label: getLabelText({ key: 'remote.common.terminated', text: '已终止' })
      }
    ]
  },
  {
    value: '8',
    label: getLabelText({ key: 'remote.common.revoked', text: '已撤销' })
  },
  {
    value: '5',
    label: getLabelText({ key: 'remote.common.toBeRenewed', text: '待续费' })
  }
]

const payMentLabel = [
  {
    id: 2,
    name: getLabelText({ key: 'remote.common.toBePaid3', text: '待支付' })
  },
  {
    id: 3,
    name: getLabelText({ key: 'remote.common.toBeConfirmed', text: '待确认' })
  }
]

const authorizeMTD = [
  {
    id: -1,
    name: getLabelText({ key: 'remote.common.expired', text: '已过期' })
  },
  {
    id: 1,
    name: getLabelText({
      key: 'remote.common.expiresWithinDays60',
      text: '60天内过期'
    })
  },
  {
    id: 2,
    name: getLabelText({
      key: 'remote.common.expiresWithinDays120',
      text: '120天内过期'
    })
  }
]

// 法国电池法：因为对填写的电池重量有限制，所以需要在枚举这里添加一个属性max，vatAI由于使用的value也是中文，所以可以直接用vatAI的枚举，将对应的max加上即可
const BATTERY_TYPE_LIST = [
  {
    label: getLabelText({
      key: 'remote.common.alkalineBattery',
      text: '碱性电池'
    }),
    value: '碱性电池',
    code: '10480'
  },
  {
    label: getLabelText({
      key: 'remote.common.alkalineButtonCell',
      text: '碱性纽扣电池'
    }),
    value: '碱性纽扣电池',
    max: 15,
    code: '10481'
  },
  {
    label: getLabelText({
      key: 'remote.common.lithiumPolymerBattery',
      text: '锂聚合物电池'
    }),
    value: '锂聚合物电池',
    code: '10475'
  },
  {
    label: getLabelText({
      key: 'remote.common.lithiumIonBattery',
      text: '锂离子电池'
    }),
    value: '锂离子电池',
    code: '10476'
  },
  {
    label: getLabelText({
      key: 'remote.common.lithiumButtonCell',
      text: '锂纽扣电池'
    }),
    value: '锂纽扣电池',
    max: 15,
    code: '10483'
  },
  {
    label: getLabelText({
      key: 'remote.common.lithiumPrimaryBattery',
      text: '锂原电池'
    }),
    value: '锂原电池',
    max: 500,
    code: '10485'
  },
  {
    label: getLabelText({
      key: 'remote.common.cadmiumBattery',
      text: '镍镉电池'
    }),
    value: '镍镉电池',
    code: '10477'
  },
  {
    label: getLabelText({
      key: 'remote.common.nickelMetalHydrideBattery',
      text: '镍氢电池'
    }),
    value: '镍氢电池',
    code: '10478'
  },
  {
    label: getLabelText({
      key: 'remote.common.carbon-zincBattery',
      text: '碳锌电池'
    }),
    value: '碳锌电池',
    code: '10486'
  },
  {
    label: getLabelText({
      key: 'remote.common.zinc-airBattery',
      text: '锌空气电池'
    }),
    value: '锌空气电池',
    code: '10487'
  },
  {
    label: getLabelText({
      key: 'remote.common.zinc-airButtonCell',
      text: '锌空气纽扣电池'
    }),
    value: '锌空气纽扣电池',
    max: 5,
    code: '10484'
  },
  {
    label: getLabelText({
      key: 'remote.common.silverOxideButtonCell',
      text: '氧化银纽扣电池'
    }),
    value: '氧化银纽扣电池',
    max: 30,
    code: '10482'
  },
  {
    label: getLabelText({
      key: 'remote.common.lead-acidBattery',
      text: '铅酸蓄电池'
    }),
    value: '铅酸蓄电池',
    code: '10479'
  }
]

// 法国电池法电池大类/小类
const FrBatteryEnum = new GenerateEnum({
  PORTABLE_BATTERY: {
    value: '6',
    label: getLabelText({
      key: 'remote.common.portableBatteryType',
      text: '便携式电池（PBA）'
    }),
    labelEn: 'Portable Batteries(PBA)',
    children: new GenerateEnum({
      PORTABLE_ALKALINE_BATTERIES: {
        value: '10480',
        label: getLabelText({
          key: 'remote.common.alkalineBattery',
          text: '碱性电池'
        }),
        labelEn: 'Alkaline Batteries (Stick, Farm, Block)',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_ZINC_AIR_BATTERIES: {
        value: '10487',
        label: getLabelText({
          key: 'remote.common.zinc-airBattery',
          text: '锌空气电池'
        }),
        labelEn: 'Zinc Air Batteries',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_ZINC_CARBON_BATTERIES: {
        value: '10486',
        label: getLabelText({
          key: 'remote.common.carbon-zincBattery',
          text: '碳锌电池'
        }),
        labelEn: 'Zinc Carbon Batteries (Stick, Farm, Block)',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_ALKALINE_BUTTON_CELLS: {
        value: '10481',
        label: getLabelText({
          key: 'remote.common.alkalineButtonCell',
          text: '碱性纽扣电池'
        }),
        labelEn: 'Alkaline Button Cells',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_SILVER_OXYDE_BUTTON_CELLS: {
        value: '10482',
        label: getLabelText({
          key: 'remote.common.silverOxideButtonCell',
          text: '氧化银纽扣电池'
        }),
        labelEn: 'Silver Oxyde Button Cells',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_ZINC_AIR_BUTTON_CELLS: {
        value: '10484',
        label: getLabelText({
          key: 'remote.common.zinc-airButtonCell',
          text: '锌空气纽扣电池'
        }),
        labelEn: 'Zinc Air Button Cells',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_LITHIUM_BUTTON_CELLS: {
        value: '10483',
        label: getLabelText({
          key: 'remote.common.lithiumButtonCell',
          text: '锂纽扣电池'
        }),
        labelEn: 'Lithium Button Cells',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_LITHIUM_STICK_BATTERIES: {
        value: '10485',
        label: getLabelText({
          key: 'remote.common.lithiumPrimaryBattery',
          text: '锂原电池'
        }),
        labelEn: 'Litihum Stick batteries',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_LITHIUM_POLYMER_WITHOUT_COBALT_ACCUMULATORS: {
        value: '10475',
        label: getLabelText({
          key: 'remote.common.lithiumPolymerBattery',
          text: '锂聚合物电池'
        }),
        labelEn: 'Lithium Polymer without Cobalt Accumulators',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_LITHIUM_ION_WITH_COBALT_ACCUMULATORS: {
        value: '10476',
        label: getLabelText({
          key: 'remote.common.frBatteryPortableLithiumIonWithCobaltAccumulators',
          text: '锂离子电池'
        }),
        labelEn: 'Lithium Ion with Cobalt Accumulators',
        parent: '6',
        categoryCode: '6'
      },
      PORTABLE_NI_MH_ACCUMULATORS: {
        value: '10478',
        label: getLabelText({
          key: 'remote.common.frBatteryPortableNiMhAccumulators',
          text: '镍氢电池'
        }),
        labelEn: 'Ni-MH Accumulators',
        parent: '6',
        categoryCode: '6'
      }
    })
  },
  LIGHT_MEANS_TRANSPORT_BATTERY: {
    value: '4',
    label: getLabelText({
      key: 'remote.common.deBatteryLightVehicleBattery',
      text: '轻型交通工具电池（LMT）'
    }),
    labelEn: 'Light Means of Transport Batteries(LMT)',
    children: new GenerateEnum({
      LIGHT_MEANS_TRANSPORT_LITHIUM_LT_2KG: {
        value: '10488',
        label: getLabelText({
          key: 'remote.common.frBatteryLithiumIonPolymerLessThan2Kg',
          text: '锂（离子聚合物）<2kg'
        }),
        labelEn: 'Lithium (Ion- Polymer) < 2 kg',
        parent: '4',
        categoryCode: '4'
      },
      LIGHT_MEANS_TRANSPORT_LITHIUM_GTE_2KG_LT_5KG: {
        value: '10489',
        label: getLabelText({
          key: 'remote.common.frBatteryLithiumIonPolymer2KgTo5Kg',
          text: '锂（离子聚合物）2kg-5kg'
        }),
        labelEn: 'Lithium (Ion- Polymer) ≥2kg,<5kg',
        parent: '4',
        categoryCode: '4'
      },
      LIGHT_MEANS_TRANSPORT_LITHIUM_GTE_5KG_LT_10KG: {
        value: '10490',
        label: getLabelText({
          key: 'remote.common.frBatteryLithiumIonPolymer5KgTo10Kg',
          text: '锂（离子聚合物）5kg-10kg'
        }),
        labelEn: 'Lithium (Ion- Polymer) ≥5kg,<10kg',
        parent: '4',
        categoryCode: '4'
      },
      LIGHT_MEANS_TRANSPORT_LITHIUM_GTE_10KG_LTE_25KG: {
        value: '10491',
        label: getLabelText({
          key: 'remote.common.frBatteryLithiumIonPolymer10KgTo25Kg',
          text: '锂（离子聚合物）10kg-25kg'
        }),
        labelEn: 'Lithium (Ion- Polymer) ≥10kg,≤25kg',
        parent: '4',
        categoryCode: '4'
      },
      LIGHT_MEANS_TRANSPORT_NI_MH_LEAD: {
        value: '10492',
        label: getLabelText({
          key: 'remote.common.frBatteryNiMhAndLead',
          text: '镍氢和铅'
        }),
        labelEn: 'Ni-MH & Lead',
        parent: '4',
        categoryCode: '4'
      }
    })
  },
  STARTING_LIGHTING_IGNITION_BATTERY: {
    value: '5',
    label: getLabelText({
      key: 'remote.common.deBatteryStartingBattery',
      text: '启动电池（SLI）'
    }),
    labelEn: 'Starting, lighting and ignition Batteries (SLI)',
    children: new GenerateEnum({
      STARTING_LIGHTING_IGNITION_LI_ION_BATTERIES: {
        value: '10508',
        label: getLabelText({
          key: 'remote.common.frBatteryStartingLightingIgnitionLiIonBatteries',
          text: '锂离子电池'
        }),
        labelEn: 'Li-ion Batteries',
        parent: '5',
        categoryCode: '5'
      },
      STARTING_LIGHTING_IGNITION_LEAD_BATTERIES: {
        value: '10509',
        label: getLabelText({
          key: 'remote.common.frBatteryStartingLightingIgnitionLeadBatteries',
          text: '铅酸蓄电池'
        }),
        labelEn: 'Lead Batteries',
        parent: '5',
        categoryCode: '5'
      }
    })
  },
  INDUSTRIAL_BATTERY: {
    value: '3',
    label: getLabelText({
      key: 'remote.common.industrialBatteryType',
      text: '工业电池（IND）'
    }),
    labelEn: 'Industrial Batteries(IND)',
    children: new GenerateEnum({
      INDUSTRIAL_NICD_BATTERIES: {
        value: '10496',
        label: getLabelText({
          key: 'remote.common.cadmiumBattery',
          text: '镍镉电池'
        }),
        labelEn: 'NiCd Batteries',
        parent: '3',
        categoryCode: '3'
      },
      INDUSTRIAL_NIMH_BATTERIES: {
        value: '10497',
        label: getLabelText({
          key: 'remote.common.frBatteryIndustrialNimhBatteries',
          text: '镍氢电池'
        }),
        labelEn: 'NiMH Batteries',
        parent: '3',
        categoryCode: '3'
      },
      INDUSTRIAL_PRIMARY_LITHIUM_BATTERIES: {
        value: '10498',
        label: getLabelText({
          key: 'remote.common.frBatteryPrimaryLithiumBatteries',
          text: '一次锂电池'
        }),
        labelEn: 'Primary Lithium Batteries',
        parent: '3',
        categoryCode: '3'
      },
      INDUSTRIAL_LFP_LMO_LTO_BATTERIES: {
        value: '10499',
        label: getLabelText({
          key: 'remote.common.frBatteryLfpLmoLtoBatteries',
          text: 'LFP/LMO/LTO电池'
        }),
        labelEn: 'LFP/LMO/LTO Batteries',
        parent: '3',
        categoryCode: '3'
      },
      INDUSTRIAL_NMC_NCA_LCO_BATTERIES: {
        value: '10500',
        label: getLabelText({
          key: 'remote.common.frBatteryNmcNcaLcoBatteries',
          text: 'NMC/NCA/LCO电池'
        }),
        labelEn: 'NMC/NCA/LCO Batteries',
        parent: '3',
        categoryCode: '3'
      },
      INDUSTRIAL_SODIUM_ION_BATTERIES: {
        value: '10517',
        label: getLabelText({
          key: 'remote.common.frBatterySodiumIonBatteries',
          text: '钠离子电池'
        }),
        labelEn: 'Sodium-Ion Batteries',
        parent: '3',
        categoryCode: '3'
      },
      INDUSTRIAL_LEAD_BATTERIES: {
        value: '10501',
        label: getLabelText({
          key: 'remote.common.frBatteryIndustrialLeadBatteries',
          text: '铅酸蓄电池'
        }),
        labelEn: 'Lead Batteries',
        parent: '3',
        categoryCode: '3'
      }
    })
  },
  ELECTRIC_VEHICLE_BATTERY: {
    value: '2',
    label: getLabelText({
      key: 'remote.enumerate.electricVehiclesEVs',
      text: '电动汽车电池（EHV）'
    }),
    labelEn: 'Electric vehicle batteries(EHV)',
    children: new GenerateEnum({
      ELECTRIC_VEHICLE_L_CLASS_LFP_LMO_LTO_BATTERIES: {
        value: '10493',
        label: getLabelText({
          key: 'remote.common.frBatteryLClassLfpLmoLtoBatteries',
          text: 'LFP/LMO/LTO 电池-L类车辆'
        }),
        labelEn: 'LFP/LMO/LTO Batteries',
        parent: '2',
        categoryCode: '2'
      },
      ELECTRIC_VEHICLE_L_CLASS_NIMH_BATTERIES: {
        value: '10494',
        label: getLabelText({
          key: 'remote.common.frBatteryLClassNimhBatteries',
          text: '镍氢电池-L类车辆'
        }),
        labelEn: 'NiMH Batteries',
        parent: '2',
        categoryCode: '2'
      },
      ELECTRIC_VEHICLE_L_CLASS_NMC_NCA_LCO_BATTERIES: {
        value: '10495',
        label: getLabelText({
          key: 'remote.common.frBatteryLClassNmcNcaLcoBatteries',
          text: 'NMC/NCA/LCO电池-L类车辆'
        }),
        labelEn: 'NMC/NCA/LCO Batteries',
        parent: '2',
        categoryCode: '2'
      },
      ELECTRIC_VEHICLE_MNO_CLASS_LFP_LMO_LTO_BATTERIES: {
        value: '10510',
        label: getLabelText({
          key: 'remote.common.frBatteryMnoClassLfpLmoLtoBatteries',
          text: 'LFP/LMO/LTO 电池-M、N或O车辆'
        }),
        labelEn: 'LFP/LMO/LTO Batteries',
        parent: '2',
        categoryCode: '2'
      },
      ELECTRIC_VEHICLE_MNO_CLASS_NIMH_BATTERIES: {
        value: '10511',
        label: getLabelText({
          key: 'remote.common.frBatteryMnoClassNimhBatteries',
          text: '镍氢电池-M、N或O车辆'
        }),
        labelEn: 'NiMH Batteries',
        parent: '2',
        categoryCode: '2'
      },
      ELECTRIC_VEHICLE_MNO_CLASS_NMC_NCA_LCO_BATTERIES: {
        value: '10512',
        label: getLabelText({
          key: 'remote.common.frBatteryMnoClassNmcNcaLcoBatteries',
          text: 'NMC/NCA/LCO电池-M、N或O车辆'
        }),
        labelEn: 'NMC/NCA/LCO Batteries',
        parent: '2',
        categoryCode: '2'
      }
    })
  }
})

const DECLARE_TYPE_OPTIONS = [
  {
    label: getLabelText({ key: 'remote.common.whole', text: '全部' }),
    value: ''
  },
  {
    label: getLabelText({
      key: 'remote.common.vatDeclaration',
      text: 'VAT申报'
    }),
    value: '0'
  },
  {
    label: getLabelText({
      key: 'remote.common.summarizeTheAnnualReport',
      text: '汇总年报'
    }),
    value: '10'
  },
  {
    label: getLabelText({
      key: 'remote.common.vatBbDeclaration',
      text: 'VAT+B2B申报'
    }),
    value: '3'
  },
  {
    label: getLabelText({
      key: 'remote.common.bbDeclaration',
      text: 'B2B申报'
    }),
    value: '4'
  },
  {
    label: getLabelText({
      key: 'remote.declare.calculateTaxModalRevisionV2.prepayment',
      text: '预缴纳'
    }),
    value: '11'
  }
]

const shareholderIdCardType = {
  1: getLabelText({ key: 'remote.common.idCard', text: '身份证' }),
  2: getLabelText({ key: 'remote.common.passport', text: '护照' })
}

const OtherInfoTypeEnum = {
  1: getLabelText({ key: 'remote.common.wechat', text: '微信' }),
  2: getLabelText({ key: 'remote.common.mailbox', text: '邮箱' })
}

const shareholderProveFileType = {
  1: getLabelText({
    key: 'remote.common.propertyOwnershipCertificate',
    text: '房产证'
  }),
  2:
    getLabelText({
      key: 'remote.common.legalRepresentative.sDriver.sLicense',
      text: '驾驶证'
    }) +
    '/' +
    getLabelText({ key: 'remote.common.drivingLicense', text: '行驶证' }),
  3: getLabelText({
    key: 'remote.common.houseLeaseContract',
    text: '房屋租赁合同'
  }),
  4: getLabelText({
    key: 'remote.common.threeWater',
    text: '近三个月的水电燃气账单'
  }),
  5:
    getLabelText({
      key: 'remote.common.threeBank',
      text: '近三个月的银行月结单'
    }) +
    '/' +
    getLabelText({ key: 'remote.common.creditCardBills', text: '信用卡账单' })
}

const shareholderProveFileType1 = {
  1: getLabelText({
    key: 'remote.common.invoicesForWater',
    text: '近三个月的水电网费发票'
  }),
  2: getLabelText({
    key: 'remote.common.paymentReceipts',
    text: '近三个月的水电网费缴费单'
  }),
  3: getLabelText({
    key: 'remote.common.gasBills',
    text: '近三个月的煤气单'
  }),
  4: getLabelText({
    key: 'remote.common.phoneBills',
    text: '近三个月的话费单'
  }),
  5: getLabelText({
    key: 'remote.common.bankStatements',
    text: '近三个月的银行账单'
  })
}

const shareholderProveOtherFileType = {
  1: getLabelText({ key: 'remote.common.passCheck', text: '通行证' }),
  2: getLabelText({ key: 'remote.common.passport', text: '护照' })
}

const orderSourceArr = [
  getLabelText({ key: 'remote.common.officialWebsite2', text: '官方网站' }),
  getLabelText({
    key: 'remote.common.wechatTheOfficialAccount',
    text: '微信公众号'
  }),
  getLabelText({ key: 'remote.common.systemBackground', text: '系统后台' }),
  getLabelText({ key: 'remote.common.miniProgram', text: '小程序' }),
  getLabelText({
    key: 'remote.common.massCreationOfLargeCustomers',
    text: '大客户批量创建'
  }),
  getLabelText({ key: 'remote.common.complianceHelper', text: '合规帮手' }),
  getLabelText({
    key: 'remote.common.placeOrdersOnBehalfOfCustomers',
    text: '代客户加购'
  }),
  getLabelText({ key: 'remote.common.universalOrder', text: '万能订单' }),
  getLabelText({ key: 'remote.common.makeUpTheDifference', text: '补差价' }),
  getLabelText({
    key: 'remote.common.importOrdersPurchased',
    text: '导入订单_外部平台订单'
  }),
  getLabelText({
    key: 'remote.common.importOrdersReceivables',
    text: '导入订单_应收款订单'
  }),
  getLabelText({
    key: 'remote.common.historicalOrders',
    text: '历史订单'
  }),
  getLabelText({
    key: 'remote.common.complianceMargin',
    text: '合规保证金'
  }),
  getLabelText({
    key: 'remote.common.sixDegreeMigration',
    text: '六度迁移'
  }),
  getLabelText({
    key: 'remote.admin.importOrderPlatformSourceInternal',
    text: '导入订单_本平台订单'
  }),
  // 订单来源编码 15 与后端枚举保持一致，避免筛选项和订单列表展示名称不一致。
  getLabelText({ key: 'remote.admin.xiaoOAgentOrderSource', text: '小O-Agent' })
]

const legalEntityCardTypeMap = {
  1: getLabelText({ key: 'remote.common.idCard', text: '身份证' }),
  2: getLabelText({ key: 'remote.common.passport', text: '护照' }),
  3: getLabelText({ key: 'remote.common.householdRegister', text: '户口本' })
}

// 海外服务国家
const advCountryList = [
  {
    country: getLabelText({ key: 'remote.common.ireland', text: '爱尔兰' }),
    value: '17'
  },
  {
    country: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    value: '3'
  },
  {
    country: getLabelText({ key: 'remote.common.france', text: '法国' }),
    value: '1'
  },
  {
    country: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    value: '4'
  },
  {
    country: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    value: '5'
  },
  {
    country: getLabelText({ key: 'remote.common.turkey', text: '土耳其' }),
    value: '33'
  },
  {
    country: getLabelText({ key: 'remote.common.cyprus', text: '塞浦路斯' }),
    value: '26'
  },
  {
    country: getLabelText({ key: 'remote.common.lithuania', text: '立陶宛' }),
    value: '21'
  }
]

const vatTaxStatusList = [
  getLabelText({ key: 'remote.common.notAuthorized', text: '未授权' }),
  getLabelText({
    key: 'remote.common.authorizationInProgress',
    text: '授权中'
  }),
  getLabelText({ key: 'remote.common.frozen', text: '已冻结' }),
  getLabelText({ key: 'remote.common.loggedOut', text: '已注销' }),
  getLabelText({ key: 'remote.common.authorized', text: '已授权' }),
  getLabelText({ key: 'remote.common.toBeRenewed', text: '待续费' }),
  getLabelText({ key: 'remote.common.loggingOut', text: '注销中' }),
  getLabelText({ key: 'remote.common.taxInspection', text: '查税中' }),
  getLabelText({ key: 'remote.common.revoked', text: '已撤销' }),
  getLabelText({ key: 'remote.common.unpaid', text: '未付费' }),
  getLabelText({
    key: 'remote.common.inTheProcessOfTerminationConfirmation',
    text: '终止确认中'
  }),
  getLabelText({ key: 'remote.common.terminating', text: '终止中' }),
  getLabelText({ key: 'remote.common.terminated', text: '已终止' })
]

const newEprTaxStatusList = [
  '',
  getLabelText({ key: 'remote.common.toBeAuthorized', text: '待授权' }),
  getLabelText({ key: 'remote.common.authorized', text: '已授权' }),
  getLabelText({ key: 'remote.common.expired', text: '已过期' }),
  getLabelText({ key: 'remote.common.terminated', text: '已终止' })
]

//报税记录处理轨迹状态
const taxDeclaraData = [
  {
    value: '0',
    label: getLabelText({
      key: 'remote.common.submitADeclaration',
      text: '提交申报'
    })
  },
  {
    value: '1',
    label: getLabelText({
      key: 'remote.common.approvedThroughReview',
      text: '通过审核'
    })
  },
  {
    value: '2',
    label: getLabelText({
      key: 'remote.common.rejectTheDeclarationForm',
      text: '驳回申报单'
    })
  },
  {
    value: '3',
    label:
      'VAT' +
      getLabelText({
        key: 'remote.common.automaticDeclaration',
        text: '自动申报'
      })
  },
  {
    value: '4',
    label: 'VAT' + getLabelText({ key: 'remote.common.manualDeclaration', text: '手动申报' })
  },
  {
    value: '5',
    label: getLabelText({
      key: 'remote.common.paperDeclaration',
      text: '纸质申报'
    })
  },
  {
    value: '6',
    label: getLabelText({
      key: 'remote.common.updateDeclarationReceipt',
      text: '更新申报回执'
    })
  },
  {
    value: '7',
    label: getLabelText({
      key: 'remote.common.updateOperationTrajectory',
      text: '更新操作轨迹'
    })
  },
  {
    value: '8',
    label: getLabelText({
      key: 'remote.common.revocationOfDeclaration',
      text: '撤销申报'
    })
  },
  {
    value: '9',
    label: getLabelText({
      key: 'remote.common.returnToTypeOfTaxReportingOperationToBeDeclared',
      text: '回到待申报报税操作类型'
    })
  },
  {
    value: '10',
    label: getLabelText({
      key: 'remote.common.downloadApplicationMaterials',
      text: '下载申报资料'
    })
  },
  {
    value: '11',
    label: getLabelText({
      key: 'remote.common.throughDataReview',
      text: '通过数据审核'
    })
  },
  {
    value: '12',
    label: getLabelText({
      key: 'remote.common.rejectDataReview',
      text: '驳回数据审核'
    })
  },
  {
    value: '13',
    label: getLabelText({
      key: 'remote.common.uploadTheTaxPaymentVoucher',
      text: '上传缴税凭证'
    })
  },
  {
    value: '14',
    label: getLabelText({
      key: 'remote.common.manuallyConfirmSuccessfulDeclaration',
      text: '手动确认申报成功'
    })
  },
  {
    value: '15',
    label: getLabelText({
      key: 'remote.common.createDeclarationForm',
      text: '创建申报单'
    })
  },
  {
    value: '17',
    label: getLabelText({
      key: 'remote.common.B2BAutomaticDeclaration',
      text: 'B2B自动申报'
    })
  },
  {
    value: '18',
    label: getLabelText({
      key: 'remote.common.downloadAnnualReport',
      text: '下载年报'
    })
  },
  {
    value: '19',
    label: getLabelText({
      key: 'remote.common.uploadAnnualReportReceipt',
      text: '上传年报回执'
    })
  },
  {
    value: '20',
    label:
      getLabelText({
        key: 'remote.common.manual',
        text: '手动'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.turnOnTheDeclarationEntranceSwitch',
        text: '打开申报入口开关'
      })
  },
  {
    value: '21',
    label:
      getLabelText({
        key: 'remote.common.manual',
        text: '手动'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.closeTheDeclarationEntranceSwitch',
        text: '关闭申报入口开关'
      })
  },
  {
    value: '22',
    label: getLabelText({
      key: 'remote.common.resumeDeclaration',
      text: '恢复申报'
    })
  },
  {
    value: '23',
    label: getLabelText({
      key: 'remote.common.B2BManualDeclaration',
      text: 'B2B手动申报'
    })
  },
  {
    value: '24',
    label:
      getLabelText({
        key: 'remote.common.automatic',
        text: '自动'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.turnOnTheDeclarationEntranceSwitch',
        text: '打开申报入口开关'
      })
  },
  {
    value: '25',
    label:
      getLabelText({
        key: 'remote.common.automatic',
        text: '自动'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.closeTheDeclarationEntranceSwitch',
        text: '关闭申报入口开关'
      })
  },
  {
    value: '26',
    label: getLabelText({
      key: 'remote.common.downloadB2BDetails',
      text: '下载B2B明细'
    })
  },
  {
    value: '27',
    label: getLabelText({
      key: 'remote.common.downloadVATDeclarationReceipt',
      text: '下载VAT申报回执'
    })
  },
  {
    value: '28',
    label: getLabelText({
      key: 'remote.common.downloadB2BDeclarationReceipt',
      text: '下载B2B申报回执'
    })
  },
  {
    value: '29',
    label: getLabelText({
      key: 'remote.common.downloadSalesReport',
      text: '下载销售报告'
    })
  },
  {
    value: '30',
    label: getLabelText({
      key: 'remote.common.generateNewDeclarationDocuments',
      text: '重新生成申报文件'
    })
  },
  {
    value: '31',
    label: getLabelText({
      key: 'remote.common.downFilesHaveNotBeenWithheldAndPaidBehalfOth',
      text: '下载未代扣代缴文件'
    })
  },
  {
    value: '32',
    label: getLabelText({
      key: 'remote.common.downloadTheTaxPaymentCertificate',
      text: '下载缴税凭证'
    })
  },
  {
    value: '33',
    label: getLabelText({
      key: 'remote.common.downVATDeclaraDocExcludB2B',
      text: '下载VAT申报文件（不含B2B）'
    })
  },
  {
    value: '34',
    label: getLabelText({
      key: 'remote.common.downVATDeclaraDocIncludB2B',
      text: '下载VAT申报文件（含B2B）'
    })
  },
  {
    value: '35',
    label: getLabelText({
      key: 'remote.common.vatApiDeclaraIncludb2bBD',
      text: 'VAT-API申报（含B2B）-批量申报'
    })
  },
  {
    value: '36',
    label: getLabelText({
      key: 'remote.common.vatApiDeclaraExcludb2bBD',
      text: 'VAT-API申报（不含B2B）-批量申报'
    })
  },
  {
    value: '37',
    label: getLabelText({
      key: 'remote.common.vatApiDeclaraIncludb2bID',
      text: 'VAT-API申报（含B2B）-单个申报'
    })
  },
  {
    value: '38',
    label: getLabelText({
      key: 'remote.common.vatApiDeclaraExcludb2bID',
      text: 'VAT-API申报（不含B2B）-单个申报'
    })
  },
  {
    value: '51',
    label: getLabelText({
      key: 'remote.common.generateB2BDecReceiptForSys',
      text: '生成系统B2B申报回执'
    })
  },
  {
    value: '74',
    label: getLabelText({
      key: 'remote.common.serviceOrderRejectedOrFrozen',
      text: '服务单驳回/冻结'
    })
  },
  {
    value: '400',
    label: getLabelText({
      key: 'remote.common.declarationRiskMarking',
      text: '申报风险打标'
    })
  },
  {
    value: '401',
    label: getLabelText({
      key: 'remote.common.declareRiskRemoveBids',
      text: '申报风险去标'
    })
  }
]

const taxRuleList = [{ id: '6.5' }, { id: '7.5' }, { id: '16.5' }, { id: '20' }]

const spinRange = [
  {
    label: getLabelText({
      key: 'remote.common.specialGoods',
      text: '特制商品'
    }),
    value: '特制商品'
  },
  {
    label: getLabelText({
      key: 'remote.common.baby36',
      text: '婴儿(0-36个月)'
    }),
    value: '婴儿(0-36个月)'
  },
  {
    label: getLabelText({
      key: 'remote.common.children414',
      text: '儿童(4-14岁)'
    }),
    value: '儿童 (4-14岁)'
  },
  {
    label: getLabelText({
      key: 'remote.common.adultFemale15',
      text: '成年女性(≥15岁)'
    }),
    value: '成年女性(≥15岁)'
  },
  {
    label: getLabelText({
      key: 'remote.common.adultMale15',
      text: '成年男性(≥15岁)'
    }),
    value: '成年男性(≥15岁)'
  },
  {
    label: getLabelText({ key: 'remote.common.human', text: '男士-女士-儿童' }),
    value: '男士-女士-儿童'
  },
  {
    label: getLabelText({
      key: 'remote.common.childShoes',
      text: '儿童 (鞋码 27 - 36)'
    }),
    value: '儿童 (鞋码 27 - 36)'
  },
  {
    label: getLabelText({
      key: 'remote.common.femaleShoes',
      text: '成年女性(鞋码≥37)'
    }),
    value: '成年女性(鞋码≥37)'
  },
  {
    label: getLabelText({
      key: 'remote.common.maleShoes',
      text: '成年男性(鞋码≥37)'
    }),
    value: '成年男性(鞋码≥37)'
  },
  {
    label: getLabelText({
      key: 'remote.common.babyShoes',
      text: '婴儿 (鞋码 19 - 26)'
    }),
    value: '婴儿 (鞋码 19 - 26)'
  },
  {
    label: getLabelText({
      key: 'remote.common.madeAccordingToStandard',
      text: '按标准制成的'
    }),
    value: '按标准制成的'
  },
  {
    label: getLabelText({
      key: 'remote.common.cleaningClothAndOtherFabricProducts',
      text: '清洁布和其他织物产品'
    }),
    value: '清洁布和其他织物产品'
  },
  {
    label:
      getLabelText({
        key: 'remote.common.forTheBath',
        text: '浴用'
      }) +
      '/' +
      getLabelText({
        key: 'remote.common.fabricForKitchenUse',
        text: '厨用的织物'
      }),
    value: '浴用/厨用的织物'
  },
  {
    label: getLabelText({ key: 'remote.common.bathFabric', text: '浴用织物' }),
    value: '浴用织物'
  },
  {
    label: getLabelText({ key: 'remote.common.bedFabric', text: '床用织物' }),
    value: '床用织物'
  },
  {
    label: getLabelText({ key: 'remote.common.tableFabric', text: '桌用织物' }),
    value: '桌用织物'
  },
  {
    label: getLabelText({
      key: 'remote.common.babyFabric36',
      text: '婴儿织物 (0-36月)'
    }),
    value: '婴儿织物 (0-36月)'
  }
]

const baseRuleList = [
  {
    value: '0',
    name: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    label: 'GB',
    length: 9,
    rule: {
      pattern: /^[0-9]{9}$/,
      message: getLabelText({
        key: 'remote.common.ukVatRexMsg',
        text: '英国税号只能输入9位数字'
      })
    }
  },
  {
    value: '1',
    name: getLabelText({ key: 'remote.common.france', text: '法国' }),
    label: 'FR',
    length: 11,
    rule: {
      pattern: /^([0-9a-zA-Z]{11})+$/,
      message: getLabelText({
        key: 'remote.common.frVatRexMsg',
        text: '法国欧盟税号只能输入11位数字和字母'
      })
    }
  },
  {
    value: '2',
    name: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    label: 'DE',
    length: 9,
    rule: {
      pattern: /^(\d{9})+$/,
      message: getLabelText({
        key: 'remote.common.deVatRexMsg',
        text: '德国欧盟税号只能输入9位数字'
      })
    }
  },
  {
    value: '3',
    name: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    label: 'IT',
    length: 11,
    rule: {
      pattern: /^(\d{11})+$/,
      message: getLabelText({
        key: 'remote.common.italyVatRexMsg',
        text: '意大利欧盟税号只能输入11位数字'
      })
    }
  },
  {
    value: '4',
    name: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    label: 'ES',
    length: 9,
    rule: {
      pattern: /^[0-9a-zA-Z]{9}$/,
      message: getLabelText({
        key: 'remote.common.spainVatRexMsg',
        text: '西班牙欧盟税号只能输入9位数字和字母组合'
      })
    }
  },
  {
    value: '5',
    name: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    label: 'PL',
    length: 10,
    rule: {
      pattern: /^(\d{10})+$/,
      message: getLabelText({
        key: 'remote.common.plVatRexMsg',
        text: '波兰欧盟税号只能输入10位数字'
      })
    }
  },
  {
    value: '6',
    name: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
    label: 'CZ',
    length: 9,
    rule: {
      pattern: /^(\d{9})+$/,
      message: getLabelText({
        key: 'remote.common.czVatRexMsg',
        text: '捷克欧盟税号只能输入9位数字'
      })
    }
  },
  {
    value: '7',
    name: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
    label: 'NL',
    length: 12,
    rule: {
      pattern: /^[0-9a-zA-Z]{12}$/,
      message: getLabelText({
        key: 'remote.common.nlVatRexMsg',
        text: '荷兰欧盟税号只能输入12位数字或字母'
      })
    }
  },
  {
    value: '8',
    name: getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
    label: 'AT',
    length: 9,
    rule: {
      pattern: /^U[0-9]{8}$/,
      message: getLabelText({
        key: 'remote.common.atVatRexMsg',
        text: '奥地利欧盟税号只能输入U+8位数字'
      })
    }
  },
  {
    value: '9',
    name: getLabelText({ key: 'remote.common.belgium', text: '比利时' }),
    label: 'BE',
    length: 10,
    rule: {
      pattern: /^(\d{10})+$/,
      message: getLabelText({
        key: 'remote.common.beVatRexMsg',
        text: '比利时欧盟税号只能输入10位数字'
      })
    }
  },
  {
    value: '10',
    name: getLabelText({ key: 'remote.common.sweden', text: '瑞典' }),
    label: 'SE',
    length: 12,
    rule: {
      pattern: /^(\d{12})+$/,
      message: getLabelText({
        key: 'remote.common.seVatRexMsg',
        text: '瑞典欧盟税号只能输入12位数字'
      })
    }
  }
]

const WORK_MARK_STATUS = {
  NOTAG: 0, //无标记
  STOPSYSTEM: 1, // 终止服务（系统终止）
  STOPUSER: 2, // 终止服务（用户终止）
  CANCEL: 3, // 注销
  REPEATVAT: 4, // 已终止重复
  CYCLECHANGE: 5, // 授权周期变更
  VATSELL: 6, // 税号转让
  SPECIALOVER: 7, // 特殊原因关闭
  PROHIBITED: 8, // 禁用
  OVERLABEL: 9, //供应商提前截止续费
  UNFINISHEDREPETITION: 10, //未终止重复
  CANCELING: 11, //注销中
  NONEEDRENEWALTASK: 12 //无需生成续费任务
}

const WORK_MARK_STATUS_MAP = {
  [WORK_MARK_STATUS.NOTAG]: getLabelText({
    key: 'remote.admin.unmarked',
    text: '无标记'
  }),
  [WORK_MARK_STATUS.PROHIBITED]: getLabelText({
    key: 'remote.common.disable',
    text: '禁用'
  }),
  [WORK_MARK_STATUS.STOPUSER]: `${getLabelText({
    key: 'remote.common.terminationOfService',
    text: '终止服务'
  })}（${getLabelText({
    key: 'remote.common.userTermination',
    text: '用户终止'
  })}）`,
  [WORK_MARK_STATUS.STOPSYSTEM]: `${getLabelText({
    key: 'remote.common.terminationOfService',
    text: '终止服务'
  })}（${getLabelText({
    key: 'remote.common.systemTerminated',
    text: '系统终止'
  })}）`,
  [WORK_MARK_STATUS.CANCEL]: getLabelText({
    key: 'remote.common.loggedOut',
    text: '注销'
  }),
  [WORK_MARK_STATUS.REPEATVAT]: getLabelText({
    key: 'remote.common.terminatedDuplicate',
    text: '已终止重复'
  }),
  [WORK_MARK_STATUS.CYCLECHANGE]: getLabelText({
    key: 'remote.common.changeOfAuthorizationPeriod',
    text: '授权周期变更'
  }),
  [WORK_MARK_STATUS.VATSELL]: getLabelText({
    key: 'remote.common.taxIdTransfer',
    text: '税号转让'
  }),
  [WORK_MARK_STATUS.SPECIALOVER]: getLabelText({
    key: 'remote.common.closedForSpecialReasons',
    text: '特殊原因关闭'
  }),
  [WORK_MARK_STATUS.OVERLABEL]: getLabelText({ key: 'remote.common.suppliersEarlyRenewalClose' }, '供应商提前截止续费'),
  [WORK_MARK_STATUS.UNFINISHEDREPETITION]: getLabelText({
    key: 'remote.common.unterminatedRepetition',
    text: '未终止重复'
  }),
  [WORK_MARK_STATUS.CANCELING]: getLabelText({
    key: 'remote.common.loggingOut',
    text: '注销中'
  }),
  [WORK_MARK_STATUS.NONEEDRENEWALTASK]: getLabelText({
    key: 'remote.admin.isConfigNoNeedToGenerateTasks',
    text: '配置为无需生成续费任务'
  })
}

const WORK_MARK_STATUS_LIST = createSelectList({
  constants: WORK_MARK_STATUS,
  map: WORK_MARK_STATUS_MAP
})

const exampleList = [
  {
    id: 1,
    title: `${getLabelText({
      key: 'remote.common.idCard',
      text: '身份证'
    })}（${getLabelText({
      key: 'remote.common.portraitFace',
      text: '人像面'
    })}）`,
    imgUrl: 'https://cdn.evatmaster.com/ost/2111229d43551d138b4991ac7e13262f074734.png'
  },
  {
    id: 2,
    title: `${getLabelText({
      key: 'remote.common.idCard',
      text: '身份证'
    })}（${getLabelText({
      key: 'remote.common.faceOfTheNationalEmblem',
      text: '国徽面'
    })}）`,
    imgUrl: 'https://cdn.evatmaster.com/ost/211122d483cf8c102d4b40a87a14a78c830eca.png'
  },
  {
    id: 3,
    title: getLabelText({
      key: 'remote.common.passportOfLegalRepresentative',
      text: '法人代表护照'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/2111221aa3191acc234ab58b970bc404a5054f.png'
  },
  {
    id: 4,
    title: `${getLabelText({
      key: 'remote.common.idCard',
      text: '身份证'
    })}/${getLabelText({ key: 'remote.common.passport', text: '护照' })}`,
    imgUrl: 'https://cdn.evatmaster.com/ost/220114a42150dc0a9e410191d00251aca08eb6.jpg'
  },
  {
    id: 5,
    title: getLabelText({
      key: 'remote.common.individualOrCompanyBusinessLicense',
      text: '个体/公司营业执照'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115491f4b1d4b324653be1e3ab1b1437f13.png'
  },
  {
    id: 6,
    title: getLabelText({
      key: 'remote.common.incorporationForm',
      text: '香港公司章程NNC1'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115f2f0154e21d04a2699371f5a22c086c0.jpg'
  },
  {
    id: 7,
    title: getLabelText({
      key: 'remote.common.hkCoic',
      text: '香港公司注册证书CR'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/2201152aaf1a57e2a94c7d8993985fc3ce6b0c.jpg'
  },
  {
    id: 8,
    title: getLabelText({
      key: 'remote.common.hkCbrcBR',
      text: '香港公司商业登记证BR'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115af3cc04535e2488b850138f7478684a6.jpg'
  },
  {
    id: 9,
    title: getLabelText({
      key: 'remote.common.screenshotOfTheStoreBackstage',
      text: '店铺后台截图'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115a0d362b0c48043de9efc6cabd768bb35.png'
  },
  {
    id: 10,
    title: getLabelText({
      key: 'remote.common.bankAccountOpeningCertificate',
      text: '银行开户证明'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115738418bb1842443fbc26c63331464299.jpg'
  },
  {
    id: 11,
    title:
      getLabelText({
        key: 'remote.common.czechRepublic',
        text: '捷克'
      }) +
      getLabelText({
        key: 'remote.common.receiptOfTheLastThreeDeclarations',
        text: '最近三次申报回执'
      }),
    imgUrl: 'https://cdn.evatmaster.com/ost/2201150243ed7d80ef4051af064daf0d33a32b.jpg'
  },
  {
    id: 12,
    title:
      getLabelText({
        key: 'remote.common.czechRepublic',
        text: '捷克'
      }) +
      getLabelText({
        key: 'remote.common.certificateOfVatNumber',
        text: 'VAT税号证书'
      }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115294107fe81b24519b3c3257835a2b38f.jpg'
  },
  {
    id: 13,
    title: getLabelText({
      key: 'remote.common.signatureOfLegalPerson',
      text: '法人签名'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/21081329c7daaa76334f02b73dafdcacec5879.jpg'
  },
  {
    id: 14,
    title:
      getLabelText({
        key: 'remote.common.france',
        text: '法国'
      }) +
      getLabelText({
        key: 'remote.common.receiptOfTheLastThreeDeclarations',
        text: '最近三次申报回执'
      }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115f89741a16d5244bbb8ef94d96bec254e.jpg'
  },
  {
    id: 15,
    title:
      getLabelText({
        key: 'remote.common.france',
        text: '法国'
      }) +
      getLabelText({
        key: 'remote.common.certificateOfVatNumber',
        text: 'VAT税号证书'
      }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220115310f716077114dbd9d4412a8f8c47061.png'
  },
  {
    id: 16,
    title: getLabelText({
      key: 'remote.common.businessLicenseOrRegistrationCertificateOfTheCompany',
      text: '公司营业执照或注册证明'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/220118ad4ad4ae314c44f6ad0f1a730fd7074a.png'
  },
  {
    id: 17,
    title: getLabelText({ key: 'remote.common.the8802Form', text: '8802表格' }),
    imgUrl: 'https://cdn.evatmaster.com/ost/210813dc6584a4c373420b873bfde5da8dddcb.png'
  },
  {
    id: 18,
    title: getLabelText({ key: 'remote.common.irsFile', text: 'IRS文件' }),
    imgUrl: 'https://cdn.evatmaster.com/ost/2108130e5f24994ebb40b89e53b45efb85c6a9.png'
  },
  {
    id: 19,
    title: 'FBA' + getLabelText({ key: 'remote.common.stockCertificate', text: '库存证明' }),
    imgUrl: 'https://user.evatmaster.com/img/germanyStock.c923b6bb.jpg'
  },
  {
    id: 20,
    title: getLabelText({
      key: 'remote.common.certificateOfDeliveryAndStorage',
      text: '发货仓储证明'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/210813f9b7aa4a0e1149dfa9769a60ba4b09af.png'
  },
  {
    id: 21,
    title: getLabelText({
      key: 'remote.common.warehousingContract',
      text: '仓储合同'
    }),
    imgUrl: 'https://user.evatmaster.com/img/germanyStock.c923b6bb.jpg'
  },
  {
    id: 22,
    title: getLabelText({
      key: 'remote.common.germanTaxCertificate',
      text: '德国税务证明'
    }),
    imgUrl: 'https://user.evatmaster.com/img/1.935e1453.png'
  },
  {
    id: 23,
    title: getLabelText({
      key: 'remote.common.VItIC',
      text: 'VAT税号/增值税税号证书'
    }),
    imgUrl: 'https://user.evatmaster.com/img/2.fdd80912.png'
  },
  {
    id: 24,
    title: getLabelText({
      key: 'remote.common.CoTINTN',
      text: '税务识别号/本土税号证书'
    }),
    imgUrl: 'https://user.evatmaster.com/img/3.9fe35637.png'
  },
  {
    id: 25,
    title: getLabelText({
      key: 'remote.common.RoLVD',
      text: '最后一次VAT申报回执'
    }),
    imgUrl: 'https://user.evatmaster.com/img/4.6e858f84.png'
  },
  //XM
  {
    id: 26,
    title: `${getLabelText({
      key: 'remote.common.idCard',
      text: '身份证'
    })}（${getLabelText({
      key: 'remote.common.portraitFace',
      text: '人像面'
    })}）`,
    imgUrl: 'https://cdn.xmsail.com/xm/2404257188b386055d4096b8926635fed62c23.png'
  },
  {
    id: 27,
    title: `${getLabelText({
      key: 'remote.common.idCard',
      text: '身份证'
    })}（${getLabelText({
      key: 'remote.common.faceOfTheNationalEmblem',
      text: '国徽面'
    })}）`,
    imgUrl: 'https://cdn.xmsail.com/xm/2404254deeb4786c214c9f994980869dfbf14c.png'
  },
  {
    id: 28,
    title: getLabelText({
      key: 'remote.common.passportOfLegalRepresentative',
      text: '法人代表护照'
    }),
    imgUrl: 'https://cdn.xmsail.com/xm/2503305c28504efad94efbaf85269e533fa26e.png'
  },
  {
    id: 29,
    title: `${getLabelText({
      key: 'remote.common.handIdCard',
      text: '手持身份证'
    })}（${getLabelText({ key: 'remote.common.passport', text: '护照' })}）`,
    imgUrl: 'https://cdn.xmsail.com/xm/25033000637eee303a40d7953662a915ad6c76.jpg'
  }
]

const registeredUrbanAreaObj = {
  0: getLabelText({ key: 'remote.common.province', text: '省' }),
  1: getLabelText({ key: 'remote.common.city', text: '市' }),
  2: getLabelText({ key: 'remote.common.district', text: '区' }),
  3: getLabelText({ key: 'remote.common.county', text: '县' })
}

let weeeProductType = {}
W3E_LIST.map((item) => {
  weeeProductType[item.value] = item.name
})

const applyTypeObj = {
  1: getLabelText({
    key: 'remote.common.thereIsAlreadyFrenchVAT',
    text: '已有法国VAT'
  }),
  2: getLabelText({
    key: 'remote.common.vatInOtherCountries',
    text: '其他国家VAT'
  }),
  3: getLabelText({
    key: 'remote.common.frVatApplicationInProgress',
    text: '法国VAT申请中'
  })
}

const imgObjList = [
  {
    id: 'businessLicensePdf',
    title: getLabelText({
      key: 'remote.common.businessLicenseOfTheCompany',
      text: '公司营业执照'
    })
  },
  {
    id: 'lawNamePdf',
    title: getLabelText({
      key: 'remote.common.corporatePassport',
      text: '法人护照'
    })
  },
  {
    id: 'behindLawLicense',
    title: getLabelText({
      key: 'remote.common.Icolps',
      text: '法人身份证(反面)'
    })
  },
  {
    id: 'frontLawLicense',
    title: getLabelText({
      key: 'remote.common.Icolp',
      text: '法人身份证(正面)'
    })
  },
  {
    id: 'autographUrl',
    title: getLabelText({
      key: 'remote.common.signaturePhoto',
      text: '签名照片'
    })
  },
  {
    id: 'shopLinkPdf',
    title: getLabelText({
      key: 'remote.common.screenshotOfStoreLink',
      text: '店铺链接截图'
    })
  },
  {
    id: 'fbaInventoryPdf',
    title: getLabelText({
      key: 'remote.common.fbaInventoryScreenshot',
      text: 'FBA库存截图'
    })
  },
  {
    id: 'storageCertificatePdf',
    title: getLabelText({
      key: 'remote.common.certificateOfDeliveryAndStorage',
      text: '发货仓储证明'
    })
  },
  {
    id: 'deProvePdf',
    title: getLabelText({
      key: 'remote.common.germanTaxCertificate',
      text: '德国税务证明'
    })
  },
  {
    id: 'electrCertifyPdf',
    title: getLabelText({
      key: 'remote.common.VItIC',
      text: 'VAT税号/增值税税号证书'
    })
  },
  {
    id: 'taxNumber',
    title: getLabelText({
      key: 'remote.common.CoTINTN',
      text: '税务识别号/本土税号证书'
    })
  },
  {
    id: 'lastReceiptPdf',
    title: getLabelText({
      key: 'remote.common.RoLVD',
      text: '最后一次VAT申报回执'
    })
  },
  {
    id: 'taxResidentIdentificationExc',
    title: getLabelText({ key: 'remote.common.the8802Form', text: '8802表格' })
  },
  {
    id: 'irsEmployerFile',
    title: getLabelText({ key: 'remote.common.irsFile', text: 'IRS文件' })
  },
  {
    id: 'otherTaxCertifyUrl',
    title: getLabelText({
      key: 'remote.common.certificateOfEuTaxNumber',
      text: '欧盟税号证书'
    })
  },
  {
    id: 'houseLeasingContract',
    title:
      getLabelText({
        key: 'remote.common.companyOrLegalRepresentative',
        text: '公司/法人代表'
      }) +
      '-' +
      getLabelText({
        key: 'remote.common.houseLeaseContractOrPropertyOwnershipCertificate',
        text: '房屋租赁合同或房产证'
      })
  },
  {
    id: 'passport',
    title: getLabelText({
      key: 'remote.common.legalRepresentativepassport',
      text: '法人代表-护照'
    })
  },
  {
    id: 'drivingLicence',
    title: getLabelText({ key: 'remote.common.Lrl', text: '法人代表-驾驶证' })
  }
]

const batchOperationDeclare = [
  {
    id: '3',
    name:
      'VAT' +
      getLabelText({
        key: 'remote.common.automaticDeclaration',
        text: '自动申报'
      }),
    showName:
      'VAT' +
      getLabelText({
        key: 'remote.common.automaticDeclaration',
        text: '自动申报'
      })
  },
  {
    id: '6',
    name: 'VAT' + getLabelText({ key: 'remote.common.paperDeclaration', text: '纸质申报' }),
    showName: 'VAT' + getLabelText({ key: 'remote.common.paperDeclaration', text: '纸质申报' })
  },
  {
    id: '4',
    name: getLabelText({
      key: 'remote.common.downloadTheTaxPaymentCertificate',
      text: '下载缴税凭证'
    }),
    showName: getLabelText({
      key: 'remote.common.taxPaymentCertificate',
      text: '缴税凭证'
    })
  },
  {
    id: '5',
    name: getLabelText({
      key: 'remote.common.completeTheCollectionApproval',
      text: '完成收款审核'
    }),
    showName: getLabelText({
      key: 'remote.common.completeTheCollectionApproval',
      text: '完成收款审核'
    })
  },
  {
    id: '7',
    name: getLabelText({
      key: 'remote.common.returnToTheStatusOfPendingDeclaration',
      text: '回到待申报状态'
    }),
    showName: getLabelText({
      key: 'remote.common.returnToTheStatusOfPendingDeclaration',
      text: '回到待申报状态'
    })
  },
  {
    id: '8',
    name: getLabelText({
      key: 'remote.common.downloadTheDeclarationDocuments',
      text: '下载申报文件'
    }),
    showName: getLabelText({
      key: 'remote.common.downloadTheDeclarationDocuments',
      text: '下载申报文件'
    })
  },
  {
    id: '45',
    name: getLabelText({
      key: 'remote.common.downSalesData',
      text: '下载销售数据'
    }),
    showName: getLabelText({ key: 'remote.common.salesData', text: '销售数据' })
  },
  {
    id: '47',
    name: getLabelText({
      key: 'remote.common.dowWithoutSalesVoucher',
      text: '下载无销售凭证'
    }),
    showName: getLabelText({
      key: 'remote.common.noProofOfSale',
      text: '无销售凭证'
    })
  },
  {
    id: '48',
    name: getLabelText({
      key: 'remote.common.generateDeclarationReceipt',
      text: '生成申报回执'
    }),
    showName: ''
  },
  {
    id: '49',
    name: getLabelText({
      key: 'remote.common.downloadUnwithheldAndRemittedDocuments',
      text: '下载未代扣代缴文件'
    }),
    showName: getLabelText({
      key: 'remote.common.downloadUnwithheldAndRemittedDocuments',
      text: '下载未代扣代缴文件'
    })
  },
  {
    id: '50',
    name: getLabelText({
      key: 'remote.common.completeB2BDeclaration',
      text: '完成B2B申报'
    }),
    showName: getLabelText({
      key: 'remote.common.completeB2BDeclaration',
      text: '完成B2B申报'
    })
  },
  {
    id: '51',
    name: getLabelText({
      key: 'remote.common.dowB2BDeclarationDetails',
      text: '下载B2B申报明细'
    }),
    showName: getLabelText({
      key: 'remote.common.dowB2BDeclarationDetails',
      text: '下载B2B申报明细'
    })
  },
  {
    id: '311',
    name: getLabelText({
      key: 'remote.common.downPolishB2BxmlFile',
      text: '下载波兰B2B XML文件'
    }),
    showName: getLabelText({
      key: 'remote.common.downPolishB2BxmlFile',
      text: '下载波兰B2B XML文件'
    })
  }
]

const businessTypes_4kyx = [
  {
    label: 'VAT',
    value: 'VAT',
    show: (c) => !['34', '100', '101', '99', '999', '900', '901'].includes(c)
  },
  {
    label: getLabelText({ key: 'remote.common.chemicalTax', text: '化学税' }),
    value: '化学税',
    show: (c) => ['10'].includes(c)
  },
  {
    label: getLabelText({ key: 'remote.common.plasticTax', text: '塑料税' }),
    value: '塑料税',
    show: (c) => ['0', '2'].includes(c)
  },
  { label: 'RFC', value: 'RFC', show: (c) => ['34'].includes(c) },
  { label: 'JCT', value: 'JCT', show: (c) => ['100'].includes(c) },
  { label: 'IOSS', value: 'IOSS', show: (c) => ['99'].includes(c) },
  { label: 'GST', value: 'GST', show: (c) => ['105', '106'].includes(c) },
  { label: 'VOEC', value: 'VOEC', show: (c) => ['245'].includes(c) },

  {
    label: 'OSS',
    value: 'OSS',
    show: (c) => ['1', '2', '3', '4', '7', '26'].includes(c)
  },
  {
    label: 'WEEE',
    value: 'WEEE',
    show: (c) => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '14', '17', '20', '0', '15'].includes(c)
  },
  {
    label: getLabelText({
      key: 'remote.common.packagingMethod',
      text: '包装法'
    }),
    value: '包装法',
    show: (c) => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '14', '17', '20', '15'].includes(c)
  },
  {
    label: getLabelText({ key: 'remote.common.textileMethod', text: '纺织法' }),
    value: '纺织法',
    show: (c) => ['1', '7'].includes(c)
  },
  {
    label: getLabelText({ key: 'remote.common.batteryMethod', text: '电池法' }),
    value: '电池法',
    show: (c) => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '14', '15', '17', '0', '20'].includes(c)
  },
  {
    label: getLabelText({
      key: 'remote.common.theFurnitureAct',
      text: '家具法'
    }),
    value: '家具法',
    show: (c) => ['1'].includes(c)
  },
  {
    label: getLabelText({ key: 'remote.common.toyLaw', text: '玩具法' }),
    value: '玩具法',
    show: (c) => ['1'].includes(c)
  },
  {
    label: getLabelText({ key: 'remote.common.tireMethod', text: '轮胎法' }),
    value: '轮胎法',
    show: (c) => ['1'].includes(c)
  },
  {
    label: getLabelText({ key: 'remote.common.paperMethod', text: '纸张法' }),
    value: '纸张法',
    show: (c) => ['1'].includes(c)
  },
  {
    label: getLabelText({
      key: 'remote.common.sportsAndRecreationalSports',
      text: '体育和休闲运动'
    }),
    value: '体育和休闲运动',
    show: (c) => ['1'].includes(c)
  },
  {
    label: getLabelText({
      key: 'remote.common.diyAndGardeningTools',
      text: 'DIY和园艺工具'
    }),
    value: 'DIY和园艺工具',
    show: (c) => ['1'].includes(c)
  },

  {
    label: getLabelText({
      key: 'remote.common.authorizedRepresentative',
      text: '授权代表'
    }),
    value: '授权代表',
    show: (c) => ['0', '100', '101', '99', '33', '11'].includes(c)
  },
  {
    label: getLabelText({
      key: 'remote.common.testingAndCertification',
      text: '检测认证'
    }),
    value: '检测认证',
    show: (c) => ['0', '34', '99', '100', '101', '106', '600', '900', '901', '999'].includes(c)
  },
  {
    label: getLabelText({
      key: 'remote.common.productRegistration',
      text: '产品注册'
    }),
    value: '产品注册',
    show: (c) => ['0', '99', '101'].includes(c)
  }
]

export const swedenPackingMaterialEnum = new GenerateEnum({
  HOME_PACKAGING: {
    value: '1',
    label: getLabelText({ key: 'remote.common.swedenPackaingHomePackaging', text: '家庭包装' }),
    children: [
      {
        value: '1.1',
        label: getLabelText({ key: 'remote.common.swedenPackaingPaperPackaging', text: '纸皮包装' }),
        children: [
          { value: '1.1.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true },
          { value: '1.1.2', label: getLabelText({ key: 'remote.common.swedenPackaingPartialRecyclableOrNot', text: '部分可回收或不可回收' }), isLeaf: true }
        ]
      },
      {
        value: '1.2',
        label: getLabelText({ key: 'remote.common.swedenPackaingPlasticPackaging', text: '塑料包装' }),
        children: [
          { value: '1.2.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true },
          { value: '1.2.2', label: getLabelText({ key: 'remote.common.swedenPackaingPartialRecyclable', text: '部分可回收' }), isLeaf: true },
          { value: '1.2.3', label: getLabelText({ key: 'remote.common.swedenPackaingNotRecyclable', text: '不可回收' }), isLeaf: true }
        ]
      },
      {
        value: '1.3',
        label: getLabelText({ key: 'remote.common.swedenPackaingAluminumPackaging', text: '铝包装' }),
        children: [{ value: '1.3.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true }]
      },
      {
        value: '1.4',
        label: getLabelText({ key: 'remote.common.swedenPackaingSteelIronPackaging', text: '钢、铁包装' }),
        children: [{ value: '1.4.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true }]
      },
      {
        value: '1.5',
        label: getLabelText({ key: 'remote.common.swedenPackaingGlassPackaging', text: '玻璃包装' }),
        children: [{ value: '1.5.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true }]
      },
      { value: '1.6', label: getLabelText({ key: 'remote.common.swedenPackaingDisposableWoodenPackaging', text: '一次性木质包装' }) },
      { value: '1.7', label: getLabelText({ key: 'remote.common.swedenPackaingReusableWoodenPackaging', text: '可重复利用的木质包装' }) },
      { value: '1.8', label: getLabelText({ key: 'remote.common.swedenPackaingTextilePackaging', text: '纺织品包装' }) },
      { value: '1.9', label: getLabelText({ key: 'remote.common.swedenPackaingCeramicPackaging', text: '陶瓷包装' }) },
      { value: '1.10', label: getLabelText({ key: 'remote.common.swedenPackaingOtherMaterialPackaging', text: '其他材料包装' }) }
    ]
  },
  NON_HOME_PACKAGING: {
    value: '2',
    label: getLabelText({ key: 'remote.common.swedenPackaingNonHomePackaging', text: '非家庭包装' }),
    children: [
      {
        value: '2.1',
        label: getLabelText({ key: 'remote.common.swedenPackaingPaperPackaging', text: '纸皮包装' }),
        children: [
          { value: '2.1.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true },
          { value: '2.1.2', label: getLabelText({ key: 'remote.common.swedenPackaingPartialRecyclableOrNot', text: '部分可回收或不可回收' }), isLeaf: true }
        ]
      },
      {
        value: '2.2',
        label: getLabelText({ key: 'remote.common.swedenPackaingPlasticPackaging', text: '塑料包装' }),
        children: [
          { value: '2.2.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true },
          { value: '2.2.2', label: getLabelText({ key: 'remote.common.swedenPackaingPartialRecyclableOrNot', text: '部分可回收或不可回收' }), isLeaf: true }
        ]
      },
      { value: '2.3', label: getLabelText({ key: 'remote.common.swedenPackaingReusablePlasticPackaging', text: '塑料包装-可重复利用' }) },
      {
        value: '2.4',
        label: getLabelText({ key: 'remote.common.swedenPackaingAluminumPackaging', text: '铝包装' }),
        children: [{ value: '2.4.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true }]
      },
      {
        value: '2.5',
        label: getLabelText({ key: 'remote.common.swedenPackaingSteelIronPackaging', text: '钢、铁包装' }),
        children: [{ value: '2.5.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true }]
      },
      {
        value: '2.6',
        label: getLabelText({ key: 'remote.common.swedenPackaingGlassPackaging', text: '玻璃包装' }),
        children: [{ value: '2.6.1', label: getLabelText({ key: 'remote.common.swedenPackaingRecyclable', text: '可回收' }), isLeaf: true }]
      },
      { value: '2.7', label: getLabelText({ key: 'remote.common.swedenPackaingDisposableWoodenPackaging', text: '一次性木质包装' }) },
      { value: '2.8', label: getLabelText({ key: 'remote.common.swedenPackaingReusableWoodenPackaging', text: '可重复利用的木质包装' }) },
      { value: '2.9', label: getLabelText({ key: 'remote.common.swedenPackaingTextilePackaging', text: '纺织品包装' }) },
      { value: '2.10', label: getLabelText({ key: 'remote.common.swedenPackaingCeramicPackaging', text: '陶瓷包装' }) },
      { value: '2.11', label: getLabelText({ key: 'remote.common.swedenPackaingOtherMaterialPackaging', text: '其他材料包装' }) }
    ]
  }
})

const CzechCountryList = [
  {
    name: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
    img: 'jieke',
    country: 'CZ',
    value: 6,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    img: 'deguo',
    country: 'DE',
    value: 2,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.france', text: '法国' }),
    img: 'faguo',
    country: 'FR',
    value: 1,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    img: 'yidali',
    country: 'IT',
    value: 3,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    // src\public\json\areaCode.js叫这个
    name2:
      getLabelText({
        key: 'remote.common.spain',
        text: '西班牙'
      }) +
      '/' +
      getLabelText({ key: 'remote.common.islasCanarias', text: '加那利群岛' }),
    img: 'xibanya',
    country: 'ES',
    value: 4,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
    img: 'aodili',
    country: 'AT',
    value: 8,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    img: 'bolan',
    country: 'PL',
    value: 5,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
    img: 'helan',
    country: 'NL',
    value: 7,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.belgium', text: '比利时' }),
    img: 'bilishi',
    country: 'BE',
    value: 9,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.sweden', text: '瑞典' }),
    img: 'ruidian',
    country: 'SE',
    value: 10,
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.finland', text: '芬兰' }),
    img: 'fenlan',
    country: 'FI',
    value: '13',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.denmark', text: '丹麦' }),
    img: 'danmai',
    country: 'DK',
    value: '14',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.greece', text: '希腊' }),
    img: 'xila',
    // src\public\json\areaCode.js叫这个
    country2: 'GR',
    country: 'EL',
    value: '15',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.hungary', text: '匈牙利' }),
    img: 'xiongyali',
    country: 'HU',
    value: '16',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.ireland', text: '爱尔兰' }),
    img: 'aierlan',
    country: 'IE',
    value: '17',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.luxembourg', text: '卢森堡' }),
    img: 'lusenbao',
    country: 'LU',
    value: '18',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.malta', text: '马耳他' }),
    img: 'maerta',
    country: 'MT',
    value: '19',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.portugal', text: '葡萄牙' }),
    img: 'putaoya',
    country: 'PT',
    value: '20',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.lithuania', text: '立陶宛' }),
    img: 'litaowan',
    country: 'LT',
    value: '21',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.romania', text: '罗马尼亚' }),
    img: 'luomaniya',
    country: 'RO',
    value: '22',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.slovakia', text: '斯洛伐克' }),
    img: 'siluofake',
    country: 'SK',
    value: '23',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.slovenia', text: '斯洛文尼亚' }),
    img: 'siluowenniya',
    country: 'SI',
    value: '24',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.bulgaria', text: '保加利亚' }),
    img: 'baojialiya',
    country: 'BG',
    value: '25',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.cyprus', text: '塞浦路斯' }),
    img: 'saipulusi',
    country: 'CY',
    value: '26',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.croatia', text: '克罗地亚' }),
    img: 'keluodiya',
    country: 'HR',
    value: '27',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.estonia', text: '爱沙尼亚' }),
    img: 'aishaniya',
    country: 'EE',
    value: '28',
    checked: false,
    vatNumber: '',
    status: undefined
  },
  {
    name: getLabelText({ key: 'remote.common.latvia', text: '拉脱维亚' }),
    img: 'latuoweiya',
    country: 'LV',
    value: '29',
    checked: false,
    vatNumber: '',
    status: undefined
  }
]

let standardList = []
let standardMap = {}
let serverTypeCopyList = []
let standardServiceTypeList = []
let userStandardList = []
VAT_SERVICE_TYPE.enumArray.forEach((item) => {
  standardList.push({
    ...item,
    value: item.serverType,
    label: item.serverDetailName
  })
  standardMap[item.serverType] = item.serverDetailName
  if (item.copyData && item.inAdmin != 1) {
    serverTypeCopyList.push(item.serviceType)
  }
  if (item.inAdmin != 1) {
    standardServiceTypeList.push(item)
  }
  if (item.inAdmin != 1) {
    userStandardList.push({
      ...item,
      value: item.serverType,
      label: item.serverDetailName
    })
  }
})
const primaryServiceList = standardList.filter((item) => item.primaryService)
const renewalServiceList = standardList.filter((item) => item.isRenewal)

const countryList = [
  {
    country: '0',
    countryName: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    checkStatus: 0,
    vatText: 'GB',
    vatVal: 'GB',
    length: 9,
    pattern: /^(\d{9})+$/,
    message: getLabelText({
      key: 'remote.common.ukVATNumberCanOnlyBeEnteredWith9digits',
      text: '英国VAT税号只能输入9位数字'
    })
  },

  {
    country: '2',
    countryName: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    checkStatus: 0,
    vatText: 'DE',
    vatVal: 'DE',
    length: 9,
    pattern: /^(\d{9})+$/,
    message: getLabelText({
      key: 'remote.common.OdcbefGVn',
      text: '德国VAT税号只能输入9位数字'
    })
  },
  {
    country: '3',
    countryName: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    checkStatus: 0,
    vatText: 'IT',
    vatVal: 'IT',
    length: 11,
    pattern: /^(\d{11})+$/,
    message: getLabelText({
      key: 'remote.common.OdcbeftIVn',
      text: '意大利VAT税号只能输入11位数字'
    })
  },
  {
    country: '4',
    countryName: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    checkStatus: 0,
    vatText: 'ES',
    vatVal: 'ES',
    length: 28
  },
  {
    country: '5',
    countryName: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    checkStatus: 0,
    vatText: 'PL',
    vatVal: 'PL',
    length: 15,
    pattern: /^(\d{10,15})+$/,
    message: getLabelText({
      key: 'remote.common.Odcbe',
      text: '只能输入10-15位数字'
    })
  },
  {
    country: '6',
    countryName: getLabelText({
      key: 'remote.common.czechRepublic',
      text: '捷克'
    }),
    checkStatus: 0,
    vatText: 'CZ',
    vatVal: 'CZ',
    length: 50
  },
  {
    country: '7',
    countryName: getLabelText({
      key: 'remote.common.netherlands',
      text: '荷兰'
    }),
    checkStatus: 0,
    vatText: 'NL',
    vatVal: 'NL',
    length: 12,
    pattern: /^[0-9a-zA-Z]{12}$/,
    message: getLabelText({
      key: 'remote.common.Tvtnconlahalod',
      text: 'vat税号由数字+字母且长度为12位组成'
    })
  },
  {
    country: '8',
    countryName: getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
    checkStatus: 0,
    vatText: 'ATU',
    vatVal: 'AT',
    length: 50
  },
  {
    country: '9',
    countryName: getLabelText({ key: 'remote.common.belgium', text: '比利时' }),
    checkStatus: 0,
    vatText: 'BE',
    vatVal: 'BE',
    length: 50
  },
  {
    country: '10',
    countryName: getLabelText({ key: 'remote.common.sweden', text: '瑞典' }),
    checkStatus: 0,
    vatText: 'SE',
    vatVal: 'SE',
    length: 50
  }
]

const options = [
  {
    value: '1',
    label: getLabelText({ key: 'remote.common.authorization', text: '授权' }),
    children: [
      {
        value: '0',
        label: getLabelText({
          key: 'remote.common.notAuthorized',
          text: '未授权'
        })
      },
      {
        value: '1',
        label: getLabelText({
          key: 'remote.common.authorizationInProgress',
          text: '授权中'
        })
      },
      {
        value: '4',
        label: getLabelText({
          key: 'remote.common.authorized',
          text: '已授权'
        }),
        children: [
          {
            value: 'stop',
            label: getLabelText({
              key: 'remote.common.inTheProcessOfTerminationConfirmation',
              text: '终止确认中'
            })
          },
          {
            value: 'other',
            label: getLabelText({ key: 'remote.common.other', text: '其他' })
          }
        ]
      }
    ]
  },
  {
    value: '2',
    label: getLabelText({ key: 'remote.common.termination', text: '终止' }),
    children: [
      {
        value: '11',
        label: getLabelText({
          key: 'remote.common.terminating',
          text: '终止中'
        })
      },
      {
        value: '12',
        label: getLabelText({ key: 'remote.common.terminated', text: '已终止' })
      }
    ]
  },
  {
    value: '3',
    label: getLabelText({ key: 'remote.common.logoff', text: '注销' }),
    children: [
      {
        value: '6',
        label: getLabelText({ key: 'remote.common.loggingOut', text: '注销中' })
      },
      {
        value: '3',
        label: getLabelText({ key: 'remote.common.loggedOut', text: '已注销' })
      }
    ]
  },
  {
    value: '8',
    label: getLabelText({ key: 'remote.common.revoked', text: '已撤销' })
  },
  {
    value: '5',
    label: getLabelText({ key: 'remote.common.toBeRenewed', text: '待续费' })
  }
]

const selectOptions = [
  {
    value: '0',
    label: getLabelText({ key: 'remote.common.notAuthorized', text: '未授权' })
  },
  {
    value: '1',
    label: getLabelText({
      key: 'remote.common.authorizationInProgress',
      text: '授权中'
    })
  },
  {
    value: '4',
    label: getLabelText({ key: 'remote.common.authorized', text: '已授权' })
  },
  {
    value: 'stop',
    label:
      getLabelText({
        key: 'remote.common.authorized',
        text: '已授权'
      }) +
      '(' +
      getLabelText({
        key: 'remote.common.inTheProcessOfTerminationConfirmation',
        text: '终止确认中'
      }) +
      ')'
  },
  {
    value: 'other',
    label:
      getLabelText({
        key: 'remote.common.authorized',
        text: '已授权'
      }) +
      '(' +
      getLabelText({
        key: 'remote.common.non-derecognized',
        text: '非终止确认中'
      }) +
      ')'
  },
  {
    value: '11',
    label: getLabelText({ key: 'remote.common.terminating', text: '终止中' })
  },
  {
    value: '12',
    label: getLabelText({ key: 'remote.common.terminated', text: '已终止' })
  },
  {
    value: '6',
    label: getLabelText({ key: 'remote.common.loggingOut', text: '注销中' })
  },
  {
    value: '3',
    label: getLabelText({ key: 'remote.common.loggedOut', text: '已注销' })
  },
  {
    value: '8',
    label: getLabelText({ key: 'remote.common.revoked', text: '已撤销' })
  },
  {
    value: '5',
    label: getLabelText({ key: 'remote.common.toBeRenewed', text: '待续费' })
  }
]

const selectVatTerminationOptions = [
  {
    value: '0',
    label: getLabelText({ key: 'remote.common.notAuthorized', text: '未授权' })
  },
  {
    value: '1',
    label: getLabelText({
      key: 'remote.common.authorizationInProgress',
      text: '授权中'
    })
  },
  {
    value: '4',
    label: getLabelText({ key: 'remote.common.authorized', text: '已授权' })
  },
  {
    value: 'stop',
    label:
      getLabelText({
        key: 'remote.common.authorized',
        text: '已授权'
      }) +
      '(' +
      getLabelText({
        key: 'remote.common.inTheProcessOfTerminationConfirmation',
        text: '终止确认中'
      }) +
      ')'
  },
  {
    value: 'other',
    label:
      getLabelText({
        key: 'remote.common.authorized',
        text: '已授权'
      }) +
      '(' +
      getLabelText({
        key: 'remote.common.non-derecognized',
        text: '非终止确认中'
      }) +
      ')'
  },
  {
    value: '11',
    label: getLabelText({ key: 'remote.common.terminating', text: '终止中' })
  },
  {
    value: '12',
    label: getLabelText({ key: 'remote.common.terminated', text: '已终止' })
  },
  {
    value: '8',
    label: getLabelText({ key: 'remote.common.revoked', text: '已撤销' })
  },
  {
    value: '5',
    label: getLabelText({ key: 'remote.common.toBeRenewed', text: '待续费' })
  }
]

const taxPeriodList = [
  {
    label: getLabelText({
      key: 'remote.common.monthlyDeclaration',
      text: '月度申报'
    }),
    value: '0'
  },
  {
    label: getLabelText({
      key: 'remote.common.quarterlyDeclaration',
      text: '季度申报'
    }),
    value: '1'
  },
  {
    label: getLabelText({
      key: 'remote.common.annualDeclaration',
      text: '年度申报'
    }),
    value: '2'
  },
  {
    label: getLabelText({
      key: 'remote.common.two-monthDeclaration',
      text: '两月申报'
    }),
    value: '3'
  },
  {
    label: getLabelText({
      key: 'remote.common.non-naturalQuarterlyFiling',
      text: '非自然季度申报'
    }),
    value: '4'
  },
  {
    label: getLabelText({
      key: 'remote.common.non-naturalYearDeclaration',
      text: '非自然年度申报'
    }),
    value: '5'
  },
  {
    label: getLabelText({
      key: 'remote.common.semi-annualDeclaration',
      text: '半年申报'
    }),
    value: '6'
  }
]

const serviceInformationTaxPeriodList = [
  {
    label: getLabelText({
      key: 'remote.common.monthlyDeclaration',
      text: '月度申报'
    }),
    value: '0'
  },
  {
    label: getLabelText({
      key: 'remote.common.quarterlyDeclaration',
      text: '季度申报'
    }),
    value: '1'
  },
  {
    label: getLabelText({
      key: 'remote.common.annualDeclaration',
      text: '年度申报'
    }),
    value: '2'
  },
  {
    label: getLabelText({
      key: 'remote.common.summaryDeclaration',
      text: '汇总申报'
    }),
    value: '3'
  },
  {
    label: getLabelText({
      key: 'remote.common.pre-declaration',
      text: '预申报'
    }),
    value: '4'
  },
  {
    label: getLabelText({
      key: 'remote.common.semi-annualDeclaration',
      text: '半年申报'
    }),
    value: '5'
  },
  {
    label: getLabelText({
      key: 'remote.common.mid-yearDeclaration',
      text: '年中申报'
    }),
    value: '6'
  }
]

const EPR_REPORT_UPLOAD_STATUS = new GenerateEnum({
  HAS_UPLOAD: {
    label: getLabelText({ key: 'remote.common.uploaded', text: '已上传' }),
    value: true
  },
  NOT_UPLOAD: {
    label: getLabelText({ key: 'remote.common.notUploaded', text: '未上传' }),
    value: false
  }
})

//  getLabelText({ key: 'remote.common.expired', text: '已过期' })
// 申报周期

const DECLARE_PERIOD_MAP = {
  0: getLabelText({
    key: 'remote.common.monthlyDeclaration',
    text: '月度申报'
  }),
  1: getLabelText({
    key: 'remote.common.quarterlyDeclaration',
    text: '季度申报'
  }),
  2: getLabelText({
    key: 'remote.common.annualDeclaration',
    text: '年度申报'
  }),
  3: getLabelText({
    key: 'remote.common.two-monthDeclaration',
    text: '两月申报'
  }),
  6: getLabelText({
    key: 'remote.common.semi-annualDeclaration',
    text: '半年申报'
  })
}

const DECLARE_PERIOD = Object.keys(DECLARE_PERIOD_MAP).map((value) => ({
  value,
  label: DECLARE_PERIOD_MAP[value]
}))

const COUNTRYLISTALL = [
  {
    id: '0',
    name: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    contains: ['ost', 'XM']
  },
  {
    id: '1',
    name: getLabelText({ key: 'remote.common.france', text: '法国' }),
    contains: ['ost', 'XM']
  },
  {
    id: '2',
    name: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    contains: ['ost', 'XM']
  },
  {
    id: '3',
    name: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    contains: ['ost']
  },
  {
    id: '4',
    name: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    contains: ['ost']
  },
  {
    id: '5',
    name: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    contains: ['ost']
  },
  {
    id: '6',
    name: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
    contains: ['ost']
  },
  {
    id: '7',
    name: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
    contains: ['ost']
  },
  {
    id: '8',
    name: getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
    contains: ['ost']
  },
  {
    id: '9',
    name: getLabelText({ key: 'remote.common.belgium', text: '比利时' }),
    contains: ['ost']
  },
  {
    id: '10',
    name: getLabelText({ key: 'remote.common.sweden', text: '瑞典' }),
    contains: ['ost']
  },
  {
    id: '11',
    name: getLabelText({ key: 'remote.common.saudiArabia', text: '沙特' }),
    contains: ['ost']
  },
  {
    id: '12',
    name: getLabelText({
      key: 'remote.common.unitedArabEmirates',
      text: '阿联酋'
    }),
    contains: ['ost']
  },
  {
    id: '99',
    name: getLabelText({ key: 'remote.common.europeanUnion', text: '欧盟' }),
    contains: ['ost']
  },
  {
    id: '100',
    name: getLabelText({ key: 'remote.common.japan.text', text: '日本' }),
    contains: ['ost', 'XM']
  },
  {
    id: '101',
    name: getLabelText({ key: 'remote.common.america', text: '美国' }),
    contains: ['ost', 'XM']
  },
  {
    id: '17',
    name: getLabelText({ key: 'remote.common.ireland', text: '爱尔兰' }),
    contains: ['ost']
  },
  {
    id: '31',
    name: getLabelText({ key: 'remote.common.egypt', text: '埃及' }),
    contains: ['ost']
  },
  {
    id: '32',
    name: getLabelText({ key: 'remote.common.switzerland', text: '瑞士' }),
    contains: ['ost']
  },
  {
    id: '33',
    name: getLabelText({ key: 'remote.common.turkey', text: '土耳其' }),
    contains: ['ost']
  },
  {
    id: '34',
    name: getLabelText({ key: 'remote.common.mexico', text: '墨西哥' }),
    contains: ['ost']
  },
  {
    id: '102',
    name: getLabelText({ key: 'remote.common.korea', text: '韩国' }),
    contains: ['XM']
  },
  {
    id: '105',
    name: getLabelText({ key: 'remote.common.australia', text: '澳大利亚' }),
    contains: ['ost']
  },
  {
    id: '106',
    name: getLabelText({ key: 'remote.common.canada', text: '加拿大' }),
    contains: ['ost']
  },
  {
    id: '120',
    name: getLabelText({ key: 'remote.common.singapore', text: '新加坡' }),
    contains: ['XM']
  },
  {
    id: '122',
    name: getLabelText({ key: 'remote.common.macaoChina', text: '中国澳门' }),
    contains: ['XM']
  },
  {
    id: '131',
    name: getLabelText({ key: 'remote.common.hongKong', text: '中国香港' }),
    contains: ['XM']
  },
  {
    id: '245',
    name: getLabelText({ key: 'remote.common.norway', text: '挪威' }),
    contains: ['ost']
  },
  {
    id: '254',
    name: getLabelText({ key: 'remote.common.seychelles', text: '塞舌尔' }),
    contains: ['XM']
  },
  {
    id: '30',
    name: getLabelText({
      key: 'remote.common.northernIreland',
      text: '北爱尔兰'
    }),
    contains: ['XM']
  },
  { id: '400', name: 'BVI', contains: ['XM'] },

  {
    id: '131',
    name: getLabelText({
      key: 'remote.common.hongKongCompany',
      text: '香港公司'
    }),
    contains: ['ost']
  },
  {
    id: '999',
    name: getLabelText({ key: 'remote.common.global', text: '全球' }),
    contains: ['ost']
  },
  {
    id: '298',
    name: getLabelText({ key: 'remote.common.china.text', text: '中国' }),
    contains: ['XM']
  }
]
const COUNTRYLIST = COUNTRYLISTALL.filter((item) => {
  return item.contains.includes('ost')
})

//我的服务国家展示
let serviceContryList = COMMON_COUNTRY.getEnumFilter('CUSTOM_UNIVERSAL').enumArray.map((item) => ({
      ...item,
      country: item.label
}))

// 获取到全球的index位置
let wholeWorleIndex = serviceContryList.findIndex((item) => item.value == '999')
// 将全球进行移动至最后
serviceContryList = serviceContryList.concat(serviceContryList.splice(wholeWorleIndex, 1))

const IPR_ORDER_TYPE_LIST = [
  getLabelText({ key: 'remote.common.serviceOrders', text: '服务订单' }),
  getLabelText({ key: 'remote.common.officialFeeOrder', text: '官费订单' }),
  getLabelText({
    key: 'remote.common.replyToReviewComments',
    text: '审查意见答复'
  }),
  getLabelText({
    key: 'remote.common.approveTheRegistrationOrder',
    text: '核准注册订单'
  }),
  getLabelText({
    key: 'remote.common.intentionToApplyForAnOrder',
    text: '意向申请订单'
  }),
  '',
  getLabelText({ key: 'remote.common.rechargeBalance', text: '充值余额' }),
  getLabelText({
    key: 'remote.common.authorizedOfficialFeeOrder',
    text: '授权费用订单'
  }),
  getLabelText({ key: 'remote.common.replyToObjection', text: '异议答辩' })
]

const orderTypeStatus = [
  getLabelText({ key: 'remote.common.salesOrder', text: '销售订单' }),
  getLabelText({ key: 'remote.common.afterSalesOrder', text: '售后订单' }),
  getLabelText({ key: 'remote.common.exchangeOrder', text: '兑换订单' })
]

const taxRuleObj = {
  0: getLabelText({
    key: 'remote.common.countryOfDestination',
    text: '目的国'
  }),
  1: getLabelText({ key: 'remote.common.countryOfShipment', text: '发货国' })
}

const spinProduct = [
  {
    label: getLabelText({ key: 'remote.common.clothing', text: '服装' }),
    value: '服装'
  },
  {
    label: getLabelText({ key: 'remote.common.footwear', text: '鞋类' }),
    value: '鞋类'
  },
  {
    label: getLabelText({ key: 'remote.common.homeTextiles', text: '家纺' }),
    value: '家纺'
  }
]

const ruleStatus = [
  {
    label: getLabelText({ key: 'remote.common.enable', text: '启用' }),
    value: '1',
    adminValue: true
  },
  {
    label: getLabelText({ key: 'remote.common.disable', text: '禁用' }),
    value: '0',
    adminValue: false
  }
]

const MERCH_LABEL_OPTIONS = [
  {
    label: getLabelText({ key: 'remote.common.whole', text: '全部' }),
    value: ''
  },
  {
    label: getLabelText({
      key: 'remote.common.ordinaryMerchants',
      text: '普通商户'
    }),
    value: '0'
  },
  {
    label: getLabelText({ key: 'remote.common.taxAgency', text: '税务代理' }),
    value: '1'
  },
  {
    label:
      'VAT+' +
      getLabelText({
        key: 'remote.common.partnerSupplier',
        text: '合作供应商'
      }),
    value: '3'
  },
  {
    label: getLabelText({
      key: 'remote.common.offlineMerchants',
      text: '线下商户'
    }),
    value: '4'
  },
  {
    label: getLabelText({
      key: 'remote.common.otherServiceProviders',
      text: '其他服务商'
    }),
    value: '5'
  }
]

const selectSearch = {
  allowClear: true,
  showSearch: true,
  filterOption(input, option) {
    input = input.toLowerCase().trim()
    let label = option.componentOptions.children[0].text.toLowerCase()
    return label.includes(input) || input.includes(label)
  }
}

const enum_9s6q = {
  file: 1,
  service: 0
}

const enum_k6u9 = {
  epr: 'EPR',
  rsp: 'RsP',
  vat: 'VAT',
  trademark: 'TRADEMARK',
  patent: 'PATENT'
}

const payTypeList = [
  {
    value: '0',
    text: getLabelText({
      key: 'remote.common.corporateTransfer',
      text: '对公转账'
    })
  },
  {
    value: '1',
    text: getLabelText({
      key: 'remote.common.communicationWechat',
      text: '通联-微信'
    })
  },
  {
    value: '2',
    text: getLabelText({
      key: 'remote.common.communicationAlipay',
      text: '通联-支付宝'
    })
  },
  {
    value: '3',
    text: getLabelText({
      key: 'remote.common.thereIsACollectionOfPraise',
      text: '有赞收款'
    })
  },
  {
    value: '4',
    text: getLabelText({
      key: 'remote.common.wechatCollection',
      text: '微信收款'
    })
  },
  {
    value: '5',
    text: getLabelText({
      key: 'remote.common.channelSettlement',
      text: '渠道结算'
    })
  },
  {
    value: '6',
    text: getLabelText({ key: 'remote.common.cashReceipts', text: '现金收款' })
  },
  {
    value: '7',
    text: getLabelText({ key: 'remote.common.operationGift', text: '运营赠送' })
  },
  {
    value: '8',
    text: getLabelText({
      key: 'remote.common.voucherDeduction',
      text: '代金券抵扣'
    })
  },
  {
    value: '9',
    text: getLabelText({
      key: 'remote.common.deductionOfServiceVouchers',
      text: '服务兑换券抵扣'
    })
  },
  {
    value: '10',
    text: getLabelText({ key: 'remote.common.weChatPay', text: '微店支付' })
  },
  {
    value: '11',
    text: getLabelText({
      key: 'remote.common.chinaMerchantsBankWechat',
      text: '招商银行-微信'
    })
  },
  {
    value: '12',
    text: getLabelText({
      key: 'remote.common.chinaMerchantsBankAlipay',
      text: '招商银行-支付宝'
    })
  },
  {
    value: '13',
    text: getLabelText({
      key: 'remote.common.chinaMerchantsBankWechatCollection',
      text: '招商银行-微信收款'
    })
  },
  {
    value: '14',
    text: getLabelText({
      key: 'remote.common.chinaMerchantsBankUnionpay',
      text: '招商银行-银联'
    })
  },
  {
    value: '15',
    text: getLabelText({
      key: 'remote.common.balancePayment2',
      text: '余额付款'
    })
  },
  {
    value: '16',
    text: getLabelText({
      key: 'remote.common.enterpriseAlipay',
      text: '企业支付宝'
    })
  },
  {
    value: '17',
    text: getLabelText({ key: 'remote.common.aliPaysLater', text: '阿里后付' })
  },
  {
    value: '18',
    text: '招商-CBS'
  },
  {
    value: '19',
    text: getLabelText({
      key: 'remote.common.smttdPaysLater',
      text: '速卖通结算支付'
    })
  },
  {
    value: '20',
    text: getLabelText({
      key: 'remote.common.TEMUforBusinesses',
      text: 'TEMU对公'
    })
  },
  {
    value: '21',
    text: getLabelText({
      key: 'remote.common.aliPreApprovalOrderGuidanceMode',
      text: '阿里预授信（导单模式）'
    })
  },
  {
    value: '23',
    text: getLabelText({
      key: 'remote.common.masterCardEnumMastercardDomesticCardPayment',
      text: '万事达国内卡支付'
    })
  },
  {
    value: '103',
    text: getLabelText({
      key: 'remote.common.lianlianWechat',
      text: '连连-微信'
    })
  },
  {
    value: '104',
    text: getLabelText({
      key: 'remote.common.lianlianAlipay',
      text: '连连-支付宝'
    })
  },
  {
    value: '105',
    text: getLabelText({
      key: 'remote.common.communicationWechatCollection',
      text: '通联-微信收款'
    })
  },
  {
    value: '106',
    text: getLabelText({
      key: 'remote.common.inviteInvestmentCorporateOnlineBanking',
      text: '招商-企业网银'
    })
  },
  {
    value: '107',
    text: getLabelText({
      key: 'remote.common.communicationCorporateOnlineBanking',
      text: '通联-企业网银'
    })
  },
  {
    value: '108',
    text: getLabelText({
      key: 'remote.common.cloudsInTheSky',
      text: '空中云汇'
    })
  },
  {
    value: '109',
    text:
      'PingPong' +
      getLabelText({
        key: 'remote.common.internationalPayments',
        text: '国际支付'
      })
  },
  {
    value: '110',
    text: getLabelText({ key: 'remote.common.creditPayment', text: '信用支付' })
  },
  { value: '111', text: 'Stripe' },
  { value: '112', text: 'PayPal' },
  { value: '113', text: 'Zelle' }
]

const salesPlatformArr = {
  0: getLabelText({ key: 'remote.common.amazon.text', text: '亚马逊' }),
  2: 'eBay',
  100: getLabelText({ key: 'remote.common.aliexpress', text: '速卖通' }),
  1: getLabelText({ key: 'remote.common.other', text: '其他' }),
  3: 'Noon',
  4: 'Souq'
}

const CityDistrict = {
  1: getLabelText({ key: 'remote.common.city', text: '市' }),
  2: getLabelText({ key: 'remote.common.county', text: '县' }),
  3: getLabelText({ key: 'remote.common.district', text: '区' })
}

const dualUser = ['13927430723', '15914011947', '18938649998', '15920315086', '13924612120', '18307647475', '13316847789', '18898562758', '19925476019']

const companyObj = {
  0: getLabelText({
    key: 'remote.common.continentalCorporation',
    text: '大陆公司'
  }),
  1: getLabelText({ key: 'remote.common.otherAreas', text: '其他地区' }),
  2: getLabelText({ key: 'remote.common.hongKongCompany', text: '香港公司' }),
  3: getLabelText({ key: 'remote.common.britishCompany', text: '英国公司' }),
  4: getLabelText({ key: 'remote.common.americanCompany', text: '美国公司' }),
  5: getLabelText({ key: 'remote.common.regionCompany1', text: '法国公司' }),
  6: getLabelText({ key: 'remote.common.regionCompany2', text: 'BVI公司' }),
  7: getLabelText({ key: 'remote.common.regionCompany3', text: '新加坡公司' }),
  8: getLabelText({ key: 'remote.common.regionCompany4', text: '德国公司' }),
  9: getLabelText({ key: 'remote.common.regionCompany5', text: '澳门公司' }),
  10: getLabelText({ key: 'remote.common.regionCompany6', text: '日本公司' }),
  11: getLabelText({ key: 'remote.common.regionCompany7', text: '韩国公司' })
}

const businessStyleObj = {
  0: getLabelText({ key: 'remote.common.horizontalVersion', text: '横版' }),
  1: getLabelText({ key: 'remote.common.verticalVersion', text: '竖版' })
}

const businessStyle = [
  {
    id: '0',
    name: getLabelText({ key: 'remote.common.horizontalVersion', text: '横版' })
  },
  {
    id: '1',
    name: getLabelText({ key: 'remote.common.verticalVersion', text: '竖版' })
  }
]

const businessScopeArr = [
  {
    value: '0',
    label: getLabelText({
      key: 'remote.common.Egep',
      text: '电子商品 electrical products'
    })
  },
  {
    value: '1',
    label: getLabelText({
      key: 'remote.common.OfMde',
      text: '户外家具 Outdoor Furniture'
    })
  },
  {
    value: '2',
    label: getLabelText({
      key: 'remote.common.Pdafapa',
      text: '汽车配件 Auto parts'
    })
  },
  {
    value: '3',
    label: getLabelText({
      key: 'remote.common.kitchenProducts',
      text: '厨房产品 Kitchen Products'
    })
  },
  {
    value: '4',
    label: getLabelText({
      key: 'remote.common.Lpffppf',
      text: '宠物产品 Pet Products'
    })
  },
  {
    value: '5',
    label: getLabelText({
      key: 'remote.common.jewelryAccessories',
      text: '饰品 Jewelry Accessories'
    })
  },
  {
    value: '6',
    label: getLabelText({
      key: 'remote.common.MaipaMaip',
      text: '母婴产品 Maternal and infant products'
    })
  },
  {
    value: '7',
    label: getLabelText({
      key: 'remote.common.clothingIndumentaria',
      text: '服装 Clothing'
    })
  },
  {
    value: '8',
    label: getLabelText({
      key: 'remote.common.hardware2',
      text: '五金 hardware'
    })
  },
  {
    value: '9',
    label: getLabelText({
      key: 'remote.common.householdProducts',
      text: '家居生活产品 Household Products'
    })
  },
  {
    value: '10',
    label: getLabelText({
      key: 'remote.common.POpdyfosafp',
      text: '运动健身产品 Sports and fitness products'
    })
  },
  {
    value: '11',
    label: getLabelText({
      key: 'remote.common.weddingProducts',
      text: '婚庆 Wedding Products'
    })
  }
]

const cType = {
  0: getLabelText({
    key: 'remote.common.limitedLiabilityCompany',
    text: '有限责任公司'
  }),
  1:
    getLabelText({
      key: 'remote.common.limitedLiabilityCompany',
      text: '有限责任公司'
    }) +
    '（' +
    getLabelText({
      key: 'remote.common.soleProprietorshipByNaturalPerson',
      text: '自然人独资'
    }) +
    '）',
  2: getLabelText({
    key: 'remote.common.jointStockLimitedLiabilityCompany',
    text: '股份有限责任公司'
  }),
  3: getLabelText({
    key: 'remote.common.individualProprietorship',
    text: '个人独资企业'
  }),
  4: getLabelText({ key: 'remote.common.partnership', text: '合伙企业' }),
  5: getLabelText({
    key: 'remote.common.individualIndustrialAndCommercialHouseholds',
    text: '个体工商户'
  })
}

// 分发 申报回执类型 为了防止老是漏改 因此使用枚举的形式 下拉 跟 映射 都在枚举里面拿 波兰的需求
export const DECLARE_RECEIPT_TYPE_ENUM = new GenerateEnum({
  PL_JPK_PL2: {
    label: 'JPK(PL2)',
    value: '116',
    name: '波兰VAT申报回执-JPK(PL2)',
    fileUrl: 'https://cdn.evatmaster.com/ost/26052184a02154d121419db6637e75472e4b37.pdf',
    id: '116'
  },
  PL_UE_PL2: {
    label: 'UE(PL2)',
    value: '117',
    name: '波兰B2B申报回执-UE(PL2)',
    fileUrl: 'https://cdn.evatmaster.com/ost/251231ce7b996a7c9b4ee1bd95f3ae86f992eb.pdf',
    id: '117'
  }
})



const letterArr = [
  { id: 0, name: '债券公司催税' },
  { id: 1, name: 'C79' },
  { id: 2, name: 'FRS' },
  { id: 3, name: '罚款+利息通知' },
  { id: 4, name: '付税通知' },
  { id: 5, name: '估税' },
  { id: 6, name: '缴税提醒通知' },
  { id: 7, name: '退税支票' },
  { id: 8, name: '税金催收' },
  { id: 9, name: '纸质证书' },
  { id: 10, name: '滞纳金通知' },
  { id: 11, name: 'EORI证书' },
  { id: 12, name: '22f证书' },
  { id: 13, name: '本地税号' },
  { id: 14, name: '迟申报通知' },
  { id: 15, name: '催税+罚款通知' },
  { id: 16, name: '罚款通知' },
  { id: 17, name: '紧急催税' },
  { id: 18, name: '手工过账' },
  { id: 19, name: '税金+附加费详情' },
  { id: 20, name: '税务稽查通知' },
  { id: 21, name: '税务明细' },
  { id: 22, name: '税务识别号' },
  { id: 23, name: '退税文件' },
  { id: 24, name: '未申报通知' },
  { id: 25, name: '未支付税金详情' },
  { id: 26, name: '申报周期变更' },
  { id: 27, name: '法国税号文件&转地址证明(PDF版)' },
  { id: 28, name: '西班牙申报回执' },
  { id: 29, name: '意大利税号文件&转地址证明' },
  { id: 30, name: '意大利VIES文件' },
  { id: 31, name: '意大利申报回执（F24）' },
  { id: 32, name: '意大利预申报回执' },
  { id: 33, name: '意大利年报回执' },
  { id: 34, name: '西班牙年报回执' },
  { id: 35, name: '奥地利年报回执' },
  { id: 36, name: '西班牙法人税号' },
  { id: 37, name: '西班牙本土税号证书' },
  { id: 38, name: '西班牙海牙认证文件' },
  { id: 39, name: '西班牙VAT税号证书' },
  { id: 40, name: '西班牙欧盟EORI证书' },
  { id: 41, name: '法国税号文件&转地址证明(扫描版)' },
  { id: 42, name: '德国税务识别号证书' },
  { id: 43, name: '德国VAT税号证书' },
  { id: 44, name: '波兰VAT申报回执-JPK(P3)' },
  { id: 51, name: '法国激活日期' },
  { id: 52, name: '法国siret号' },
  { id: 53, name: '法国申报回执-Resume' },
  { id: 54, name: '法国申报回执-Accuse' },
  { id: 55, name: '法国申报回执-paiement（旧）' },
  { id: 126, name: '法国申报回执-paiement（新）' },
  { id: 58, name: '西班牙官方翻译件' },
  { id: 61, name: '德国电池法证书' },
  { id: 62, name: '德国WEEE证书' },
  { id: 63, name: '意大利WEEE证书' },
  { id: 64, name: '意大利包装法证书' },
  { id: 65, name: '意大利电池法证书' },
  { id: 66, name: '西班牙WEEE证书' },
  { id: 67, name: '西班牙包装法证书' },
  { id: 68, name: '西班牙电池法证书' },
  { id: 120, name: '意大利VAT申报回执' },
  { id: 60, name: '意大利B2B申报回执' },
  { id: 80, name: '意大利年报回执-内容识别' },
  { id: 104, name: '捷克VAT申报回执' },
  { id: 108, name: 'IOSS申报意大利税局回执' },
  { id: 70, name: '意大利VAT申报回执（年报用）' },
  { id: 111, name: '波兰VAT申报回执-JPK(P2/P5)' },
  { id: 112, name: '波兰VAT申报回执-JPK(P4)' },
  { id: 113, name: '波兰B2B申报回执-UE' },
  { id: 114, name: '波兰B2B申报回执-UE(P4)' },
  { id: 85, name: '意大利年报回执-文件名识别' },
  { id: 125, name: '墨西哥VAT申报回执' },
  { id: 133, name: '西班牙海牙认证文件（其他服务）' },
  { id: 115, name: 'VAT税号证书' },
  { id: 140, name: '日本JCT申报回执' },
  { id: 153, name: '西班牙欧盟税号证书' },
  { id: 141, name: '西班牙授权电子签名' },
  { id: 142, name: '西班牙授权电子通信' },
  { id: 143, name: '西班牙解除电子通信' },
  { id: 160, name: '意大利海牙待办文件' },
  { id: 161, name: '意大利海牙证词文件' },
  { id: 164, name: '意大利海牙认证文件（供应商回传）' },
  { id: 162, name: getLabelText({
      key: 'remote.admin.italianOfficialGuarantee',
      text: '意大利正式保函'
    }) },
  { id: 163, name: getLabelText({
      key: 'remote.admin.spanishReplyLetterMaterials',
      text: '西班牙回复信件资料'
    }) },
  { id: 158, name: '意大利本土税号证书' },
  { id: 159, name: '意大利官方翻译文件' },
]

const hlBatteryCategoryOptions = [
  {
    value: '1',
    label: getLabelText({
      key: 'remote.common.portableBatteryType',
      text: '便携式电池'
    })
  },
  {
    value: '2',
    label: getLabelText({
      key: 'remote.common.industrialBatteryType',
      text: '工业电池'
    })
  }
]
const hlBatterySubCategoryOptions = [
  {
    value: '101',
    label: getLabelText({
      key: 'remote.common.portableBatteryType',
      text: '便携式电池'
    })
  },
  {
    value: '201',
    label: '重量≤1kg'
  },
  {
    value: '202',
    label: '重量＞1kg'
  },
  {
    value: '203',
    label: '自行车电池(EPAC)'
  }
]
// const letterArr = [
//   { id: 0, name: getLabelText({ key: 'remote.common.theBondCompanyPressedForTax', text: '债券公司催税' }) },
//   { id: 1, name: 'C79' },
//   { id: 2, name: 'FRS' },
//   { id: 3, name: getLabelText({ key: 'remote.common.penaltyInterestNotice', text: '罚款+利息通知' }) },
//   { id: 4, name: getLabelText({ key: 'remote.common.noticeOfTaxPayment', text: '付税通知' }) },
//   { id: 5, name: getLabelText({ key: 'remote.common.taxAssessment', text: '估税' }) },
//   { id: 6, name: getLabelText({ key: 'remote.common.taxReminderNotice', text: '缴税提醒通知' }) },
//   { id: 7, name: getLabelText({ key: 'remote.common.taxRefundCheck', text: '退税支票' }) },
//   { id: 8, name: getLabelText({ key: 'remote.common.taxCollection2', text: '税金催收' }) },
//   { id: 9, name: getLabelText({ key: 'remote.common.paperCertificate', text: '纸质证书' }) },
//   { id: 10, name: getLabelText({ key: 'remote.common.noticeOfLateFee', text: '滞纳金通知' }) },
//   { id: 11, name: 'EORI' + getLabelText({ key: 'remote.common.certification', text: '证书' }) },
//   { id: 12, name: '22f' + getLabelText({ key: 'remote.common.certification', text: '证书' }) },
//   { id: 13, name: getLabelText({ key: 'remote.common.localTaxId', text: '本地税号' }) },
//   { id: 14, name: getLabelText({ key: 'remote.common.noticeOfLateDeclaration', text: '迟申报通知' }) },
//   { id: 15, name: getLabelText({ key: 'remote.common.taxCollectionAndPenaltyNotice', text: '催税+罚款通知' }) },
//   { id: 16, name: getLabelText({ key: 'remote.common.penaltyNotice', text: '罚款通知' }) },
//   { id: 17, name: getLabelText({ key: 'remote.common.urgentTaxCall', text: '紧急催税' }) },
//   { id: 18, name: getLabelText({ key: 'remote.common.manualPosting', text: '手工过账' }) },
//   { id: 19, name: getLabelText({ key: 'remote.common.detailsOfTaxesAndSurcharges', text: '税金+附加费详情' }) },
//   { id: 20, name: getLabelText({ key: 'remote.common.noticeOfTaxInspection', text: '税务稽查通知' }) },
//   { id: 21, name: getLabelText({ key: 'remote.common.taxDetails', text: '税务明细' }) },
//   { id: 22, name: getLabelText({ key: 'remote.common.taxIdentificationNumber', text: '税务识别号' }) },
//   { id: 23, name: getLabelText({ key: 'remote.common.taxRefundDocuments', text: '退税文件' }) },
//   { id: 24, name: getLabelText({ key: 'remote.common.noticeOfFailureToDeclare', text: '未申报通知' }) },
//   { id: 25, name: getLabelText({ key: 'remote.common.detailsOfTaxNotPaid', text: '未支付税金详情' }) },
//   { id: 26, name: getLabelText({ key: 'remote.common.changeOfDeclarationCycle', text: '申报周期变更' }) },
//   { id: 27, name: getLabelText({ key: 'remote.common.frTaxIdentificationDocProAddTransferPDF', text: '法国税号文件&转地址证明(PDF版)' }) },
//   { id: 28, name: getLabelText({ key: 'remote.common.spanishDeclarationReceipt', text: '西班牙申报回执' }) },
//   { id: 29, name: getLabelText({ key: 'remote.common.italianTaxIdentificationDocProofAddTransfer', text: '意大利税号文件&转地址证明' }) },
//   { id: 30, name: getLabelText({ key: 'remote.common.VIESFileFromItaly', text: '意大利VIES文件' }) },
//   { id: 31, name: getLabelText({ key: 'remote.common.italianDeclarationReceipt', text: '意大利申报回执' }) + '（F24）' },
//   { id: 32, name: getLabelText({ key: 'remote.common.italyPreDeclarationReceipt', text: '意大利预申报回执' }) },
//   { id: 33, name: getLabelText({ key: 'remote.common.italianAnnualReportReceipt', text: '意大利年报回执' }) },
//   { id: 34, name: getLabelText({ key: 'remote.common.spainAnnualReportReceipt', text: '西班牙年报回执' }) },
//   { id: 35, name: getLabelText({ key: 'remote.common.austrianAnnualReportReceipt', text: '奥地利年报回执' }) },
//   { id: 36, name: getLabelText({ key: 'remote.common.spanishCorporateTaxNumber', text: '西班牙法人税号' }) },
//   { id: 37, name: getLabelText({ key: 'remote.common.spanishLocalTaxIDCertificate', text: '西班牙本土税号证书' }) },
//   { id: 38, name: getLabelText({ key: 'remote.common.hagueCertificationDocumentsSpain', text: '西班牙海牙认证文件' }) },
//   { id: 39, name: getLabelText({ key: 'remote.common.spanishVATNumberCertificate', text: '西班牙VAT税号证书' }) },
//   { id: 40, name: getLabelText({ key: 'remote.common.spanishEUEORICertificate', text: '西班牙欧盟EORI证书' }) },
//   { id: 41, name: getLabelText({ key: 'remote.common.frenchTaxIdentificationDocumentProofAddTransfersv', text: '法国税号文件&转地址证明(扫描版)' }) },
//   { id: 42, name: getLabelText({ key: 'remote.common.germanTaxIdentificationNumCertificate', text: '德国税务识别号证书' }) },
//   { id: 43, name: getLabelText({ key: 'remote.common.germanVATNumberCertificate', text: '德国VAT税号证书' }) },
//   { id: 44, name: getLabelText({ key: 'remote.common.polandVATDeclarationReceipt', text: '波兰VAT申报回执' }) + '-JPK(P3)' },
//   { id: 51, name: getLabelText({ key: 'remote.common.franceActivationDate', text: '法国激活日期' }) },
//   { id: 52, name: getLabelText({ key: 'remote.common.frenchSiretNumber', text: '法国siret号' }) },
//   { id: 53, name: getLabelText({ key: 'remote.common.frenchDeclarationReceipt', text: '法国申报回执' }) + '-Resume' },
//   { id: 54, name: getLabelText({ key: 'remote.common.frenchDeclarationReceipt', text: '法国申报回执' }) + '-Accuse' },
//   { id: 55, name: getLabelText({ key: 'remote.common.frenchDeclarationReceipt', text: '法国申报回执' }) + '-paiement' },
//   { id: 58, name: getLabelText({ key: 'remote.common.officialTranslationFromSpain', text: '西班牙官方翻译件' }) },
//   { id: 120, name: getLabelText({ key: 'remote.common.italianVATDeclarationReceipt', text: '意大利VAT申报回执' }) },
//   { id: 60, name: getLabelText({ key: 'remote.common.italianB2BDeclarationReceipt', text: '意大利B2B申报回执' }) },
//   { id: 80, name: getLabelText({ key: 'remote.common.italianAnnualReportReceipt', text: '意大利年报回执' }) },
//   { id: 104, name: getLabelText({ key: 'remote.common.czechVATDeclarationReceipt', text: '捷克VAT申报回执' }) },
//   { id: 108, name: getLabelText({ key: 'remote.common.iossDeclarationReceiptItalianTaxBureau', text: 'IOSS申报意大利税局回执' }) },
//   { id: 70, name: getLabelText({ key: 'remote.common.italianVATDeclarationReceiptAr', text: '意大利VAT申报回执（年报用）' }) },
//   { id: 111, name: getLabelText({ key: 'remote.common.polandVATDeclarationReceipt', text: '波兰VAT申报回执' }) + '-JPK(P2/P5)' },
//   { id: 112, name: getLabelText({ key: 'remote.common.polandVATDeclarationReceipt', text: '波兰VAT申报回执' }) + '-JPK(P4)' },
//   { id: 113, name: getLabelText({ key: 'remote.common.polandB2BDeclarationReceipt', text: '波兰B2B申报回执' }) + '-UE' },
//   { id: 114, name: getLabelText({ key: 'remote.common.polandB2BDeclarationReceipt', text: '波兰B2B申报回执' }) + '-UE(P4)' }
// ]

const wwwConfigcountryList = [
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.US),
    value: COMMON_COUNTRY.US,
    en: 'USD',
    zh: getLabelText({ key: 'remote.common.dollar', text: '美元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.GB),
    value: COMMON_COUNTRY.GB,
    en: 'GBP',
    zh: getLabelText({ key: 'remote.common.pound', text: '英镑' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CN),
    value: COMMON_COUNTRY.CN,
    en: 'CNY',
    zh: getLabelText({ key: 'remote.common.rmb', text: '人民币' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.JP),
    value: COMMON_COUNTRY.JP,
    en: 'JPY',
    zh: getLabelText({ key: 'remote.common.japaneseYen', text: '日元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.EU),
    value: COMMON_COUNTRY.EU,
    en: 'EUR',
    zh: getLabelText({ key: 'remote.common.euro', text: '欧元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.KR),
    value: COMMON_COUNTRY.KR,
    en: 'KRW',
    zh: getLabelText({ key: 'remote.common.won', text: '韩元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.PH),
    value: COMMON_COUNTRY.PH,
    en: 'PHP',
    zh: getLabelText({
      key: 'remote.common.philippinePesos',
      text: '菲律宾比索'
    })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IN),
    value: COMMON_COUNTRY.IN,
    en: 'INR',
    zh: getLabelText({ key: 'remote.common.indianRupee', text: '印度卢比' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.DE),
    value: COMMON_COUNTRY.DE,
    en: 'EUR',
    zh: getLabelText({ key: 'remote.common.euro', text: '欧元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.AU),
    value: COMMON_COUNTRY.AU,
    en: 'AUD',
    zh: getLabelText({ key: 'remote.common.australianDollar', text: '澳元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CA),
    value: COMMON_COUNTRY.CA,
    en: 'CAD',
    zh: getLabelText({ key: 'remote.common.canadianDollars', text: '加元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.BR),
    value: COMMON_COUNTRY.BR,
    en: 'BRL',
    zh: getLabelText({ key: 'remote.common.brazilianReal', text: '巴西雷亚尔' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MX),
    value: COMMON_COUNTRY.MX,
    en: 'MXN',
    zh: getLabelText({ key: 'remote.common.mexicanPeso', text: '墨西哥比索' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SG),
    value: COMMON_COUNTRY.SG,
    en: 'SGD',
    zh: getLabelText({ key: 'remote.common.singaporeDollar', text: '新加坡元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.HK),
    value: COMMON_COUNTRY.HK,
    en: 'HKD',
    zh: getLabelText({ key: 'remote.common.hongKongDollar', text: '港币' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.TH),
    value: COMMON_COUNTRY.TH,
    en: 'THB',
    zh: getLabelText({ key: 'remote.common.thaiBaht', text: '泰铢' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MY),
    value: COMMON_COUNTRY.MY,
    en: 'MYR',
    zh: getLabelText({
      key: 'remote.common.malaysianRinggit',
      text: '马来西亚令吉'
    })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ID),
    value: COMMON_COUNTRY.ID,
    en: 'IDR',
    zh: getLabelText({
      key: 'remote.enumerate.indonesianRupiah',
      text: '印度尼西亚盾'
    })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.VN),
    value: COMMON_COUNTRY.VN,
    en: 'VRD',
    zh: getLabelText({ key: 'remote.common.vietnameseDong', text: '越南盾' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SA),
    value: COMMON_COUNTRY.SA,
    en: 'SAR',
    zh: getLabelText({ key: 'remote.common.saudiRiyal', text: '沙特里亚尔' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.UAE),
    value: COMMON_COUNTRY.UAE,
    en: 'AED',
    zh: getLabelText({ key: 'remote.common.uaeDirham', text: '阿联酋迪拉姆' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.FR),
    value: COMMON_COUNTRY.FR,
    en: 'EUR',
    zh: getLabelText({ key: 'remote.common.euro', text: '欧元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IT),
    value: COMMON_COUNTRY.IT,
    en: 'EUR',
    zh: getLabelText({ key: 'remote.common.euro', text: '欧元' })
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ES),
    value: COMMON_COUNTRY.ES,
    en: 'EUR',
    zh: getLabelText({ key: 'remote.common.euro', text: '欧元' })
  }
]

const nodeData = {
  begin: getLabelText({ key: 'remote.common.notStarted', text: '未开始' }),
  // customerhandle: getLabelText({ key: 'remote.enumerate.customerServiceProcessing', text: '客服处理' }),
  mtdopen: getLabelText({ key: 'remote.enumerate.enableMTD', text: '开通MTD' }),
  datadownload: getLabelText({
    key: 'remote.enumerate.downloadServiceMaterials',
    text: '下载服务资料'
  }),
  authsuccess: getLabelText({
    key: 'remote.enumerate.confirmAuthorizationSuccess',
    text: '确认授权成功'
  }),
  applyway: getLabelText({
    key: 'remote.common.taxIdApplication',
    text: '税号申请'
  }),
  distributeserver: getLabelText({
    key: 'remote.common.assignASupplier',
    text: '分配供应商'
  }),
  applysuccess: getLabelText({
    key: 'remote.enumerate.confirmApplicationSuccess',
    text: '确认申请成功'
  }),
  mtdval: getLabelText({
    key: 'remote.enumerate.mtdLoginVerification',
    text: 'MTD登录验证'
  }),
  customerdelay: getLabelText({
    key: 'remote.enumerate.customerServiceExtension',
    text: '客服延期处理'
  }),
  clerkreject: getLabelText({
    key: 'remote.enumerate.clerkRejection',
    text: '文员驳回'
  }),
  vatdownload: getLabelText({
    key: 'remote.enumerate.taxNumberCertificateDownload',
    text: '税号证书下载'
  }),
  turnaddress: getLabelText({
    key: 'remote.enumerate.applyAddressChange',
    text: '申请转地址'
  }),
  mtdinput: getLabelText({
    key: 'remote.enumerate.enterMtdInfo',
    text: '输入MTD信息'
  }),
  gbsendfrs: getLabelText({
    key: 'remote.enumerate.applyFRS',
    text: '申请FRS'
  }),
  desendem: getLabelText({
    key: 'remote.common.taxIdApplication',
    text: '税号申请'
  }), //申请邮件已发送 德国新申请
  destroy_success: getLabelText({
    key: 'remote.enumerate.completeCancellation',
    text: '完成注销'
  }),
  cancel: getLabelText({
    key: 'remote.enumerate.mdtVatTaxNumberDeregister',
    text: '注销'
  }),
  end: getLabelText({
    key: 'remote.common.processCompleted',
    text: '流程结束'
  }),
  customerend: getLabelText({
    key: 'remote.enumerate.reviewCompleted',
    text: '审核完成'
  }),
  hagueapprove: getLabelText({
    key: 'remote.enumerate.completeHagueCertification',
    text: '完成海牙认证'
  }),
  completeOfficialTranslation: getLabelText({
    key: 'remote.enumerate.completeOfficialTranslation',
    text: '完成官方翻译'
  }),
  vatcertificate: getLabelText({
    key: 'remote.enumerate.uploadAddressChangeProof',
    text: '上传转地址证明'
  }),
  autoattachoffice: getLabelText({
    key: 'remote.enumerate.oneClickTaxAuthorityLink',
    text: '一键挂靠税局'
  }),
  autochangebank: getLabelText({
    key: 'remote.enumerate.oneClickBankInfoChange',
    text: '一键更改银行信息'
  }),
  gatewaymtdopen: getLabelText({
    key: 'remote.enumerate.enableGWMTD',
    text: '开通GWMTD'
  }),
  lawgetvat: getLabelText({
    key: 'remote.enumerate.submitCorporateTaxNumber',
    text: '递交法人税号'
  }),
  taxidentifierapply: getLabelText({
    key: 'remote.enumerate.localTaxNumberApplication',
    text: '本土税号申请'
  }),
  uploadingSiretNumber: getLabelText({
    key: 'remote.enumerate.uploadSiretNumber',
    text: '上传siret号码'
  }),
  taxActive: getLabelText({
    key: 'remote.enumerate.activateTaxNumber',
    text: '税号激活'
  }),
  applyEori: getLabelText({
    key: 'remote.enumerate.applyEORI',
    text: '申请EORI'
  }),
  completeAttachService: getLabelText({
    key: 'remote.enumerate.processValueAddedServices',
    text: '处理增值服务'
  }),
  clerkhandle: getLabelText({
    key: 'remote.common.deliveryReview',
    text: '交付审核'
  }),
  changestobecommitted: getLabelText({
    key: 'remote.common.toBeSubmitted',
    text: '待提交'
  }),
  customerhandle: getLabelText({
    key: 'remote.enumerate.customerServiceProcessing',
    text: '客服处理'
  }),
  redeclare: getLabelText({
    key: 'remote.common.processingComplete',
    text: '处理完成'
  }),
  uploadCorporateNumber: getLabelText({
    key: 'remote.enumerate.uploadCorporateNumber',
    text: '上传法人番号'
  }),
  rejectAgainSubmit: getLabelText({
    key: 'remote.enumerate.rejectedResubmit',
    text: '驳回再提交'
  })
}

// 未开始
const notStartedYet = getLabelText({
  key: 'remote.common.notStarted',
  text: '未开始'
})
// 待提交服务资料
const serviceDataToBeSubmitted = getLabelText({
  key: 'remote.common.serviceDataToBeSubmitted',
  text: '待提交服务资料'
})
// 申请中
const applicationInProgress = getLabelText({
  key: 'remote.common.applicationInProgress',
  text: '申请中'
})
// 申请成功
const theApplicationWasSuccessful = getLabelText({
  key: 'remote.common.theApplicationWasSuccessful',
  text: '申请成功'
})
// 申请失败
const theApplicationFailed = getLabelText({
  key: 'remote.common.theApplicationFailed',
  text: '申请失败'
})
// 已退款
const refunded = getLabelText({
  key: 'remote.common.refunded',
  text: '已退款'
})
// 退款中
const refundInProgress = getLabelText({
  key: 'remote.common.refundInProgress',
  text: '退款中'
})
const cancelled = getLabelText({
  key: 'remote.common.cancelled',
  text: '已取消'
})
const frozen = getLabelText({ key: 'remote.common.frozen', text: '已冻结' })
const authorizationInProgress = getLabelText({
  key: 'remote.common.authorizationInProgress',
  text: '授权中'
})
const authorizationSucceeded = getLabelText({
  key: 'remote.common.authorizationSucceeded',
  text: '授权成功'
})
const authorizationFailed = getLabelText({
  key: 'remote.common.authorizationFailed',
  text: '授权失败'
})
const processing = getLabelText({
  key: 'remote.common.processing',
  text: '处理中'
})
const completed = getLabelText({
  key: 'remote.common.completed',
  text: '已完成'
})
const logoutFailed = getLabelText({
  key: 'remote.common.logoutFailed',
  text: '注销失败'
})
const failedToMakeUpTheDifference = getLabelText({
  key: 'remote.common.failedToMakeUpTheDifference',
  text: '补差价失败'
})
const renewalFailed = getLabelText({
  key: 'remote.common.renewalFailed',
  text: '续费失败'
})
const serviceProgress = [
  [notStartedYet, serviceDataToBeSubmitted, applicationInProgress, theApplicationWasSuccessful, theApplicationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, authorizationInProgress, authorizationSucceeded, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, renewalFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, authorizationInProgress, authorizationSucceeded, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, authorizationInProgress, authorizationSucceeded, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  ['', '', processing, completed],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, failedToMakeUpTheDifference, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, authorizationInProgress, authorizationSucceeded, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, authorizationInProgress, authorizationSucceeded, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  // 以上0-11 以下凑数
  [notStartedYet, serviceDataToBeSubmitted, applicationInProgress, theApplicationWasSuccessful, theApplicationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, applicationInProgress, completed, theApplicationFailed, refunded, refundInProgress, cancelled, frozen],
  ['', '', '', '', '', '', '', ''],
  [notStartedYet, serviceDataToBeSubmitted, applicationInProgress, theApplicationWasSuccessful, theApplicationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, authorizationInProgress, authorizationSucceeded, authorizationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, applicationInProgress, theApplicationWasSuccessful, theApplicationFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  // 以下增值服务
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen],
  [notStartedYet, serviceDataToBeSubmitted, processing, completed, logoutFailed, refunded, refundInProgress, cancelled, frozen]
]

const firstTaskHead = globalThis().appName === MODULE_TYPE_OBJ.IPP ? 'MDT_' : ''
const TASK_ENUM = {
  TASK_FROM_TODAY: `${firstTaskHead}TASK_FROM_TODAY`,
  TASK_DEADLINE: `${firstTaskHead}TASK_DEADLINE`
}

// 【打标状态】
const TAG_STATE = {
  NODEED_UPDATE: 1,
  ALREADY_UPDATE: 2,
  WAIT_UPDATE: 3
}

const TAG_STATE_MAP = {
  [TAG_STATE.NODEED_UPDATE]: getLabelText({
    key: 'remote.common.noUpdateNeeded',
    text: '无需更新'
  }),
  [TAG_STATE.ALREADY_UPDATE]: getLabelText({
    key: 'remote.common.updated',
    text: '已更新'
  }),
  [TAG_STATE.WAIT_UPDATE]: getLabelText({
    key: 'remote.common.pendingUpdate',
    text: '待更新'
  })
}

//其他欧盟国家税号校验
const ruleList = [
  {
    value: '0',
    name: getLabelText({ key: 'remote.common.theUk', text: '英国' }),
    label: 'GB',
    length: 9,
    rule: {
      pattern: /^[0-9]{9}$/,
      message: getLabelText({
        key: 'remote.common.ukVatRexMsg',
        text: '英国税号只能输入9位数字'
      })
    }
  },
  {
    value: '1',
    name: getLabelText({ key: 'remote.common.france', text: '法国' }),
    label: 'FR',
    length: 11,
    rule: {
      pattern: /^([0-9a-zA-Z]{11})+$/,
      message: getLabelText({
        key: 'remote.common.frVatRexMsg',
        text: '法国欧盟税号只能输入11位数字和字母'
      })
    }
  },
  {
    value: '2',
    name: getLabelText({ key: 'remote.common.germany', text: '德国' }),
    label: 'DE',
    length: 9,
    rule: {
      pattern: /^(\d{9})+$/,
      message: getLabelText({
        key: 'remote.common.OdcbeftGETI',
        text: '德国欧盟税号只能输入9位数字'
      })
    }
  },
  {
    value: '3',
    name: getLabelText({ key: 'remote.common.italy', text: '意大利' }),
    label: 'IT',
    length: 11,
    rule: {
      pattern: /^(\d{11})+$/,
      message: getLabelText({
        key: 'remote.common.IETIcobewd',
        text: '意大利欧盟税号只能输入11位数字'
      })
    }
  },
  {
    value: '4',
    name: getLabelText({ key: 'remote.common.spain', text: '西班牙' }),
    label: 'ES',
    length: 9,
    rule: {
      pattern: /^[0-9a-zA-Z]{9}$/,
      message: getLabelText({
        key: 'remote.common.spainVatRexMsg',
        text: '西班牙欧盟税号只能输入9位数字和字母组合'
      })
    }
  },
  {
    value: '5',
    name: getLabelText({ key: 'remote.common.poland', text: '波兰' }),
    label: 'PL',
    length: 10,
    rule: {
      pattern: /^(\d{10})+$/,
      message: getLabelText({
        key: 'remote.common.PETIcobewd',
        text: '波兰欧盟税号只能输入10位数字'
      })
    }
  },
  {
    value: '6',
    name: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克' }),
    label: 'CZ',
    length: 9,
    rule: {
      pattern: /^(\d{9})+$/,
      message: getLabelText({
        key: 'remote.common.czVatRexMsg',
        text: '捷克欧盟税号只能输入9位数字'
      })
    }
  },
  {
    value: '7',
    name: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }),
    label: 'NL',
    length: 12,
    rule: {
      pattern: /^[0-9a-zA-Z]{12}$/,
      message: getLabelText({
        key: 'remote.common.nlVatRexMsg',
        text: '荷兰欧盟税号只能输入12位数字或字母'
      })
    }
  },
  {
    value: '8',
    name: getLabelText({ key: 'remote.common.austria', text: '奥地利' }),
    label: 'AT',
    length: 9,
    rule: {
      pattern: /^U[0-9]{8}$/,
      message: getLabelText({
        key: 'remote.common.atVatRexMsg',
        text: '奥地利欧盟税号只能输入U+8位数字'
      })
    }
  },
  {
    value: '9',
    name: getLabelText({ key: 'remote.common.belgium', text: '比利时' }),
    label: 'BE',
    length: 10,
    rule: {
      pattern: /^(\d{10})+$/,
      message: getLabelText({
        key: 'remote.common.beVatRexMsg',
        text: '比利时欧盟税号只能输入10位数字'
      })
    }
  },
  {
    value: '10',
    name: getLabelText({ key: 'remote.common.sweden', text: '瑞典' }),
    label: 'SE',
    length: 12,
    rule: {
      pattern: /^(\d{12})+$/,
      message: getLabelText({
        key: 'remote.common.SETIcobewd',
        text: '瑞典欧盟税号只能输入12位数字'
      })
    }
  }
]

// 0销售凭证获取方法地址
const zeroSaleUrl = {
  fileName: getLabelText({
    key: 'remote.common.amazonZeroSalesSummaryReportDownloadGuidePdf',
    text: '亚马逊零销售凭证-Summary report下载指引.pdf'
  }),
  path: 'https://cdn.evatmaster.com/ost/23090637c9af292cda48a5b83daca725b0f5a5.pdf'
}

const zeroSaleUrl2 = zeroSaleUrl

// 通用示例图片地址
const imgList = [
  {
    id: 1,
    title: getLabelText({
      key: 'remote.common.iDCardPhotoSide',
      text: '身份证（人像面）'
    }),
    imgUrl: 'https://user.evatmaster.com/img/5.90c964a1.png'
  },
  {
    id: 2,
    title: getLabelText({
      key: 'remote.common.iDCardCoatOfArmsSide',
      text: '身份证（国徽面）'
    }),
    imgUrl: 'https://user.evatmaster.com/img/card-back.fab5fc03.png'
  },
  {
    id: 3,
    title: getLabelText({
      key: 'remote.common.signatureOfLegalPerson',
      text: '法人签名'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/21081329c7daaa76334f02b73dafdcacec5879.jpg'
  },
  {
    id: 4,
    title: getLabelText({
      key: 'remote.common.screenshotOfStoreLink',
      text: '店铺链接截图'
    }),
    imgUrl: 'https://user.evatmaster.com/img/links.76d5b6e6.png'
  },
  {
    id: 5,
    title: getLabelText({
      key: 'remote.common.stockCertificate',
      text: '库存证明'
    }),
    imgUrl: 'https://user.evatmaster.com/img/germanyStock.c923b6bb.jpg'
  },
  {
    id: 6,
    title: getLabelText({
      key: 'remote.common.certificateOfDeliveryAndStorage',
      text: '发货仓储证明'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/210813f9b7aa4a0e1149dfa9769a60ba4b09af.png'
  },
  {
    id: 7,
    title: getLabelText({ key: 'remote.common.the8802Form', text: '8802表格' }),
    imgUrl: 'https://cdn.evatmaster.com/ost/210813dc6584a4c373420b873bfde5da8dddcb.png'
  },
  {
    id: 8,
    title: getLabelText({ key: 'remote.common.irsFile', text: 'IRS文件' }),
    imgUrl: 'https://cdn.evatmaster.com/ost/2108130e5f24994ebb40b89e53b45efb85c6a9.png'
  },
  {
    id: 9,
    title: getLabelText({
      key: 'remote.common.passportOfLegalRepresentative',
      text: '法人代表护照'
    }),
    imgUrl: 'https://cdn.evatmaster.com/ost/210817cb3b11384d524815a81d09808ccf6551.png'
  },
  {
    id: 10,
    title: getLabelText({
      key: 'remote.common.germanTaxCertificate',
      text: '德国税务证明'
    }),
    imgUrl: 'https://user.evatmaster.com/img/1.935e1453.png'
  },
  {
    id: 11,
    title: getLabelText({
      key: ['remote.common.taxId', '/', 'remote.common.certificateOfValue-addedTaxNumber'],
      text: 'VAT税号/增值税税号证书'
    }),
    imgUrl: 'https://user.evatmaster.com/img/2.fdd80912.png'
  },
  {
    id: 12,
    title: getLabelText({
      key: ['remote.common.taxIdentificationNumber', '/', 'remote.common.certificateOfLocalTaxNumber'],
      text: '税务识别号/本土税号证书'
    }),
    imgUrl: 'https://user.evatmaster.com/img/3.9fe35637.png'
  },
  {
    id: 13,
    title: getLabelText({
      key: 'remote.common.RoLVD',
      text: '最后一次VAT申报回执'
    }),
    imgUrl: 'https://user.evatmaster.com/img/4.6e858f84.png'
  }
]

const BATTERY_WEIGHT_INFO = [
  { name: '1~50', value: '0', limit: ['3006'] },
  { name: '51~150', value: '1', limit: ['3006'] },
  { name: '151~250', value: '2', limit: ['3006'] },
  { name: '251~500', value: '3', limit: ['3006'] },
  { name: '501~750', value: '4', limit: ['3006'] },
  { name: '751~1000', value: '5', limit: ['3006'] },
  { name: '1001~2000', value: '7', limit: ['3006'] },
  { name: '2001~4000', value: '11', limit: ['3006'] },
  {
    name: getLabelText({
      key: 'remote.common.buttonBattery',
      text: '纽扣电池'
    }),
    value: '6',
    limit: ['3008', '3002', '3005']
  }
]

let BATTERY_WEIGHT_MAP = {}

BATTERY_WEIGHT_INFO.map((item) => {
  BATTERY_WEIGHT_MAP[item.value] = item.name
})

const EPR_SERVICE_OPTIONS = [
  {
    label: getLabelText({ key: 'remote.common.whole', text: '全部' }),
    value: ''
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeWeee',
      text: 'WEEE'
    }),
    value: '1',
    serviceType: ['101', '106', '127', '201'],
    routerName: [
      { name: 'WEEEManageDetailFrance', country: ['1'] },
      { name: 'WEEEManageDetailEnglish', country: ['0'] },
      { name: 'WEEEManageDetailSpain', country: ['4'] },
      { name: 'WEEEManageDetail' }
    ]
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypePackagingLaw',
      text: '包装法'
    }),
    value: '2',
    serviceType: ['102', '105', '107', '202'],
    routerName: 'packingManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeBatteryLaw',
      text: '电池法'
    }),
    value: '3',
    serviceType: ['103', '108', '126', '203'],
    routerName: 'batteryManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeTextileLaw',
      text: '纺织法'
    }),
    value: '4',
    serviceType: ['115', '128', '215'],
    routerName: 'spinManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeFurnitureLaw',
      text: '家具法'
    }),
    value: '5',
    serviceType: ['116', '216'],
    routerName: 'furnitureManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeToyLaw',
      text: '玩具法'
    }),
    value: '6',
    serviceType: ['122', '222'],
    routerName: 'toysManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypePlasticTax',
      text: '塑料税'
    }),
    value: '7',
    serviceType: ['123', '223'],
    routerName: 'toysManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeTireLaw',
      text: '轮胎法'
    }),
    value: '8',
    serviceType: ['129'],
    routerName: 'serviceManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypePaperLaw',
      text: '纸张法'
    }),
    value: '9',
    serviceType: ['130'],
    routerName: 'serviceManageInfo'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeSportsAndRecreation',
      text: '体育和休闲运动'
    }),
    value: '10',
    serviceType: ['138'],
    routerName: 'sportsManageDetail'
  },
  {
    label: getLabelText({
      key: 'remote.enumerate.belongingToTypeDiyAndGardenTools',
      text: 'DIY和园艺工具'
    }),
    value: '11',
    serviceType: ['139'],
    routerName: 'diyGardenManageDetail'
  }
]

//纳税人识别号校验
const validatorIdentifyNumber = {
  validator: (_, value) => {
    if (!value) {
      return Promise.reject(
        getLabelText({
          key: 'remote.common.pleaseEnterTheTaxpayerIdentificationNumberOfYourBillingCompany',
          text: '请输入您开票公司的纳税人识别号'
        })
      )
    } else if (!/^[\S]*$/.test(value)) {
      return Promise.reject(
        getLabelText({
          key: 'remote.enumerate.taxpayerIdNoSpaces',
          text: '纳税人识别号不能包含空格'
        })
      )
    } else if (value.length < 6 || value.length > 18) {
      return Promise.reject(
        getLabelText({
          key: 'remote.enumerate.enterTaxpayerId',
          text: '请输入6-18位纳税人识别号'
        })
      )
    }
    return Promise.resolve()
  }
}

const EPR_SERVICE_COUNTRY = [
  {
    value: '',
    label: getLabelText({ key: 'remote.common.whole', text: '全部' })
  },
  ...serviceContryList
]

const search_country_list = [
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.US),
    value: COMMON_COUNTRY.US
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.EU),
    value: COMMON_COUNTRY.EU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.GB),
    value: COMMON_COUNTRY.GB
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CN),
    value: COMMON_COUNTRY.CN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.JP),
    value: COMMON_COUNTRY.JP
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.KR),
    value: COMMON_COUNTRY.KR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.PH),
    value: COMMON_COUNTRY.PH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IN),
    value: COMMON_COUNTRY.IN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.DE),
    value: COMMON_COUNTRY.DE
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.AU),
    value: COMMON_COUNTRY.AU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CA),
    value: COMMON_COUNTRY.CA
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SG),
    value: COMMON_COUNTRY.SG
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.TH),
    value: COMMON_COUNTRY.TH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MY),
    value: COMMON_COUNTRY.MY
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ID),
    value: COMMON_COUNTRY.ID
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.VN),
    value: COMMON_COUNTRY.VN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SA),
    value: COMMON_COUNTRY.SA
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.UAE),
    value: COMMON_COUNTRY.UAE
  }
]

// 外观专利国家
const designCountryList = [
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.US),
    value: COMMON_COUNTRY.US
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.EU),
    value: COMMON_COUNTRY.EU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.GB),
    value: COMMON_COUNTRY.GB
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.JP),
    value: COMMON_COUNTRY.JP
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.KR),
    value: COMMON_COUNTRY.KR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.PH),
    value: COMMON_COUNTRY.PH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IN),
    value: COMMON_COUNTRY.IN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CA),
    value: COMMON_COUNTRY.CA
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MX),
    value: COMMON_COUNTRY.MX
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SG),
    value: COMMON_COUNTRY.SG
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.TH),
    value: COMMON_COUNTRY.TH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MY),
    value: COMMON_COUNTRY.MY
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ID),
    value: COMMON_COUNTRY.ID
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.VN),
    value: COMMON_COUNTRY.VN
  }
]

// ipr 专用
const iprUserCountryList = [
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.US),
    value: COMMON_COUNTRY.US
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.GB),
    value: COMMON_COUNTRY.GB
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.EU),
    value: COMMON_COUNTRY.EU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.JP),
    value: COMMON_COUNTRY.JP
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CN),
    value: COMMON_COUNTRY.CN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.AU),
    value: COMMON_COUNTRY.AU
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MX),
    value: COMMON_COUNTRY.MX
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.CA),
    value: COMMON_COUNTRY.CA
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.DE),
    value: COMMON_COUNTRY.DE
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.HK),
    value: COMMON_COUNTRY.HK
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.KR),
    value: COMMON_COUNTRY.KR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.BR),
    value: COMMON_COUNTRY.BR
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.IN),
    value: COMMON_COUNTRY.IN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.PH),
    value: COMMON_COUNTRY.PH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.TH),
    value: COMMON_COUNTRY.TH
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.VN),
    value: COMMON_COUNTRY.VN
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.ID),
    value: COMMON_COUNTRY.ID
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.MY),
    value: COMMON_COUNTRY.MY
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SG),
    value: COMMON_COUNTRY.SG
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.SA),
    value: COMMON_COUNTRY.SA
  },
  {
    country: COMMON_COUNTRY.getValueToLabel(COMMON_COUNTRY.UAE),
    value: COMMON_COUNTRY.UAE
  }
]

const couponModules = {
  kill: '0',
  couponBag: '1',
  service: '2',
  full: '3'
}
//优惠券类型
const couponType = [
  {
    text: getLabelText({
      key: 'remote.common.immediatelyReduceTheCoupon',
      text: '立减券'
    }),
    value: couponModules['kill']
  },
  {
    text: getLabelText({ key: 'remote.common.couponBag', text: '券包' }),
    value: couponModules['couponBag']
  },
  {
    text: getLabelText({
      key: 'remote.common.voucherForService',
      text: '服务兑换券'
    }),
    value: couponModules['service']
  },
  {
    text: getLabelText({
      key: 'remote.common.fullDiscountCoupon',
      text: '满减券'
    }),
    value: couponModules['full']
  }
]

const PACKAGETYPE = {
  2001: getLabelText({ key: 'remote.common.paper2', text: '纸皮' }),
  2002: getLabelText({ key: 'remote.common.plastic', text: '塑料' }),
  2003: getLabelText({ key: 'remote.common.glass', text: '玻璃' }),
  2004: getLabelText({ key: 'remote.common.iron', text: '铁' }),
  2005: getLabelText({ key: 'remote.common.aluminium', text: '铝' }),
  2006: getLabelText({
    key: 'remote.common.beverageCartonPackaging',
    text: '饮料纸盒包装'
  }),
  2007: getLabelText({
    key: 'remote.common.otherCompositePackaging',
    text: '其他复合包装'
  }),
  2008: getLabelText({
    key: 'remote.common.otherMaterials',
    text: '其他材料'
  }),
  2009: getLabelText({ key: 'remote.common.metal', text: '金属' })
}

const SPAIN_PACKAGETYPE = {
  4010: getLabelText({ key: 'remote.common.other', text: '其他' }),
  4001: getLabelText({ key: 'remote.common.plastic', text: '塑料' }),
  4002: getLabelText({
    key: ['remote.common.cardboard', '&', 'remote.enumerate.paper'],
    text: '纸板&纸张'
  }),
  4003: getLabelText({ key: 'remote.common.glass', text: '玻璃' }),
  4004: getLabelText({ key: 'remote.common.metal', text: '金属' }),
  4005: getLabelText({ key: 'remote.enumerate.wood', text: '木材' }),
  4006: getLabelText({
    key: ['remote.enumerate.beverage', '/', 'remote.enumerate.foodPackagingBox'],
    text: '饮料/食品包装盒'
  }),
  4007: getLabelText({ key: 'remote.enumerate.ceramics', text: '陶瓷' }),
  4008: getLabelText({
    key: ['remote.common.rubber', '/', 'remote.enumerate.siliconeGel'],
    text: '橡胶/硅胶'
  }),
  4009: getLabelText({ key: 'remote.common.aluminium', text: '铝' })
}

const SWEDEM_PACKAGETYPE = {
  5001: getLabelText({ key: 'remote.common.mixedPaper', text: '混合纸皮' }),
  5002: getLabelText({ key: 'remote.common.purePaperboard', text: '纯纸皮' }),
  5003: getLabelText({ key: 'remote.common.mixedPlastic', text: '混合塑料' }),
  5004: getLabelText({ key: 'remote.common.purePlastic', text: '纯塑料' }),
  5005: getLabelText({ key: 'remote.common.aluminium', text: '铝' }),
  5006: getLabelText({
    key: ['remote.common.steel', '、', 'remote.common.iron'],
    text: '钢、铁'
  }),
  6001: getLabelText({ key: 'remote.common.mixedPaper', text: '混合纸皮' }),
  6002: getLabelText({ key: 'remote.common.purePaperboard', text: '纯纸皮' }),
  6003: getLabelText({ key: 'remote.common.mixedPlastic', text: '混合塑料' }),
  6004: getLabelText({ key: 'remote.common.purePlastic', text: '纯塑料' }),
  6005: getLabelText({ key: 'remote.common.aluminium', text: '铝' }),
  6006: getLabelText({
    key: ['remote.common.steel', '、', 'remote.common.iron'],
    text: '钢、铁'
  })
}

const vipTypeEnum = new GenerateEnum({
  THEIR_2: {
    value: 2,
    label: getLabelText({
      key: ['SVIP', 'remote.enumerate.monthlyCardBenefits'],
      text: 'SVIP月卡权益'
    })
  },
  THEIR_4: {
    value: 4,
    label: getLabelText({
      key: ['SVIP', 'remote.enumerate.annualCardBenefits'],
      text: 'SVIP年卡权益'
    })
  }
})

const manualVerificationModule = new GenerateEnum({
  NORMAL: {
    value: 0,
    label: getLabelText({ key: 'remote.enumerate.normal', text: '普通' })
  },
  VIP: {
    value: 1,
    label: getLabelText({
      key: ['remote.common.vipMember', '(', 'remote.common.annualCard', ')'],
      text: 'VIP会员(年卡)'
    })
  },
  SVIP: {
    value: 2,
    label: getLabelText({
      key: ['remote.common.svipMember', '(', 'remote.common.annualCard', ')'],
      text: 'SVIP会员(年卡)'
    })
  },
  VIP2: {
    value: 3,
    label: getLabelText({
      key: ['remote.common.experience', 'VIP'],
      text: '体验VIP'
    })
  },
  SVIP2: {
    value: 4,
    label: getLabelText({
      key: ['remote.common.experience', 'SVIP'],
      text: '体验SVIP'
    })
  },
  VIP7: {
    value: 7,
    label: getLabelText({
      key: ['remote.common.firstPieceExperience', 'VIP'],
      text: '首件体验VIP'
    })
  },
  VIP8: {
    value: 8,
    label: getLabelText({
      key: ['remote.common.firstPieceExperience', 'SVIP'],
      text: '首件体验SVIP'
    })
  },
  VIP_MONTH_CARD: {
    value: 11,
    label: getLabelText({
      key: ['remote.common.vipMember', '(', 'remote.common.monthlyCard', ')'],
      text: 'VIP会员(月卡)'
    })
  },
  SVIP_MONT_CARD: {
    value: 12,
    label: getLabelText({
      key: ['remote.common.svipMember', '(', 'remote.common.monthlyCard', ')'],
      text: 'SVIP会员(月卡)'
    })
  }
})

const configStatusModule = new GenerateEnum({
  END: {
    value: 0,
    label: getLabelText({ key: 'remote.common.expired3', text: '已失效' })
  },
  INEFFECT: {
    value: 1,
    label: getLabelText({ key: 'remote.enumerate.inEffect', text: '生效中' })
  }
})

const memberCenterShow = new GenerateEnum({
  YES: {
    value: 1,
    label: getLabelText({ key: 'remote.customHelpModal.hide', text: '隐藏' })
  },
  NO: {
    value: 0,
    label: getLabelText({ key: 'remote.common.show', text: '显示' })
  }
})

const equityList = new GenerateEnum({
  TYPE_1: {
    value: 1,
    label: getLabelText({
      key: 'remote.enumerate.memberExclusiveDiscount',
      text: '会员专属优惠价'
    })
  },
  TYPE_2: {
    value: 2,
    label: getLabelText({
      key: 'remote.enumerate.purchaseCardExclusiveCoupon',
      text: '购卡专属券'
    })
  },
  TYPE_3: {
    value: 3,
    label: getLabelText({
      key: 'remote.enumerate.monthlyExclusiveCoupon',
      text: '每月专属券'
    })
  },
  TYPE_4: {
    value: 4,
    label: getLabelText({
      key: 'remote.enumerate.reviewOpinionExclusiveCoupon',
      text: '审查意见专属券'
    })
  },
  TYPE_5: {
    value: 5,
    label: getLabelText({
      key: 'remote.enumerate.drawingExclusiveCoupon',
      text: '绘图专属券'
    })
  },
  TYPE_6: {
    value: 6,
    label: getLabelText({
      key: 'remote.enumerate.manualVerificationRight',
      text: '人工核名权益'
    })
  },
  TYPE_7: {
    value: 7,
    label: getLabelText({
      key: 'remote.enumerate.usptoDesignatedSeniorLawyer',
      text: '美标指定专业的资深律师'
    })
  },
  TYPE_8: {
    value: 8,
    label: getLabelText({
      key: 'remote.enumerate.appearanceRetrievalRightsAndInterests',
      text: '外观检索权益'
    })
  }
})

const artificialNameVerification = new GenerateEnum({
  VIP: {
    value: 1,
    label: getLabelText({
      key: ['remote.common.vipMember', '(', 'remote.common.annualCard', ')'],
      text: 'VIP会员(年卡)'
    })
  },
  SVIP: {
    value: 2,
    label: getLabelText({
      key: ['remote.common.svipMember', '(', 'remote.common.annualCard', ')'],
      text: 'SVIP会员(年卡)'
    })
  },
  VIP_MONTH_CARD: {
    value: 11,
    label: getLabelText({
      key: ['remote.common.vipMember', '(', 'remote.common.monthlyCard', ')'],
      text: 'VIP会员(月卡)'
    })
  },
  SVIP_MONT_CARD: {
    value: 12,
    label: getLabelText({
      key: ['remote.common.svipMember', '(', 'remote.common.monthlyCard', ')'],
      text: 'SVIP会员(月卡)'
    })
  },
  PAID_USERS: {
    value: 13,
    label: getLabelText({
      key: 'remote.enumerate.paidUser',
      text: '已付费用户'
    })
  },
  UNPAID_USERS: {
    value: 14,
    label: getLabelText({
      key: 'remote.enumerate.unpaidUser',
      text: '未付费用户'
    })
  },
  SMALL_STARS: {
    value: 15,
    label: getLabelText({ key: ['1-5', 'remote.common.star'], text: '1-5星' })
  },
  BIG_STARS: {
    value: 16,
    label: getLabelText({ key: ['6-8', 'remote.common.star'], text: '6-8星' })
  }
})

const couponStatusModules = {
  noBegin: '0',
  begin: '1',
  end: '2',
  cancel: '3'
}

// 优惠券状态
const couponStatus = [
  {
    text: getLabelText({ key: 'remote.common.notStarted', text: '未开始' }),
    value: couponStatusModules.noBegin
  },
  {
    text: getLabelText({ key: 'remote.common.inProgress', text: '进行中' }),
    value: couponStatusModules.begin
  },
  {
    text: getLabelText({ key: 'remote.common.ended', text: '已结束' }),
    value: couponStatusModules.end
  },
  {
    text: getLabelText({ key: 'remote.common.cancelled', text: '已取消' }),
    value: couponStatusModules.cancel
  }
]
const LZ_ATTRIBATE = {
  lz_productGroupType_10: getLabelText({
    key: 'remote.common.electronicProduct',
    text: '电子产品'
  }),
  lz_productGroupType_20: getLabelText({
    key: 'remote.enumerate.nonElectronicProducts',
    text: '非电子产品'
  }),
  lz_productGroupType_30: getLabelText({
    key: 'remote.common.largePieceFurniture',
    text: '大件家具'
  })
}
const LZ_ATTRIBATE_TEXT = {
  lz_productGroupType_10: getLabelText({
    key: 'remote.common.numberOfElectronicProductGroups',
    text: '电子产品组数'
  }),
  lz_productGroupType_20: getLabelText({
    key: 'remote.enumerate.numberOfNonElectronicProductGroups',
    text: '非电子产品组数'
  }),
  lz_productGroupType_30: getLabelText({
    key: 'remote.common.numberOfLargeFurnitureSets',
    text: '大件家具组数'
  })
}

const italy_material_list = new GenerateEnum({
  ITALY_PAPER: {
    label: getLabelText({ key: 'remote.common.paperMaterial', text: '纸' }),
    value: '7100',
    children: new GenerateEnum({
      ITALY_PAPER_SUB_ALONE: {
        value: '7101',
        label: getLabelText({
          key: 'remote.common.singlePaperPackaging',
          text: '单一纸材料的包装'
        })
      },
      ITALY_PAPER_SUB_CPL: {
        value: '7102',
        label: 'CPL'
      },
      ITALY_PAPER_SUB_C: {
        value: '7103',
        label: getLabelText({
          key: 'remote.common.typeCComposite',
          text: 'C型复合材料'
        })
      },
      ITALY_PAPER_SUB_D: {
        value: '7104',
        label: getLabelText({
          key: 'remote.common.typeDComposite',
          text: 'D型复合材料'
        })
      }
    })
  },
  ITALY_PLASTIC: {
    label: getLabelText({ key: 'remote.common.plastic', text: '塑料' }),
    value: '7200',
    children: new GenerateEnum({
      ITALY_PLASTIC_SUB_SINGLE_CONTAINERS: {
        value: '7201',
        label: getLabelText({
          key: 'remote.common.singlePlasticCratesBoxes',
          text: '用于工业/农业的单一塑料材质的箱/盒子、瓶/桶/盖子'
        })
      },
      ITALY_PLASTIC_SUB_LARGE_CONTAINERS: {
        value: '7202',
        label: getLabelText({
          key: 'remote.common.largePlasticContainer',
          text: '容量等于或大于30升的塑料桶/罐'
        })
      },
      ITALY_PLASTIC_SUB_INDUSTRIAL_LINERS: {
        value: '7203',
        label: getLabelText({
          key: 'remote.common.industrialLinersBags',
          text: '工业用衬垫和袋子'
        })
      },
      ITALY_PLASTIC_SUB_BOTTLES_JARS: {
        value: '7204',
        label: getLabelText({
          key: 'remote.common.rigidContainersCaps',
          text: '瓶、烧瓶、罐和其他硬质容器及纸瓶盖'
        })
      },
      ITALY_PLASTIC_SUB_SINGLE_PET_CONTAINERS: {
        value: '7205',
        label: getLabelText({
          key: 'remote.common.singleLayerPetBottle',
          text: '单层PET瓶子/罐子'
        })
      },
      ITALY_PLASTIC_SUB_PP_CONTAINERS: {
        value: '7206',
        label: getLabelText({
          key: 'remote.common.largePpContainer',
          text: '采用PP材质的容量大于等于3L的袋/瓶及盖子/标签'
        })
      },
      ITALY_PLASTIC_SUB_SOFT_PACKAGING: {
        value: '7207',
        label: getLabelText({
          key: 'remote.common.softPackaging',
          text: 'PP/PE/PS/PET软包装'
        })
      },
      ITALY_PLASTIC_SUB_RIGID_PACKAGING: {
        value: '7208',
        label: getLabelText({
          key: 'remote.common.rigidPetPsPackaging',
          text: 'PET和非发泡PS硬质包装（例如托盘、罐子、托盘和泡罩、HIPS和GPPS）'
        })
      },
      ITALY_PLASTIC_SUB_OTHER_POLYMERS: {
        value: '7209',
        label: getLabelText({
          key: 'remote.common.otherPolymerMaterials',
          text: '其他以塑料为主的聚合物材料'
        })
      }
    })
  },
  ITALY_IRON: {
    label: getLabelText({ key: 'remote.common.steel', text: '钢' }),
    value: '7300'
  },
  ITALY_ALUMINUM: {
    label: getLabelText({ key: 'remote.common.aluminium', text: '铝' }),
    value: '7400'
  },
  ITALY_WOOD: {
    label: getLabelText({ key: 'remote.common.tree', text: '木' }),
    value: '7500'
  },
  ITALY_BIODEGRADABLE: {
    label: getLabelText({
      key: 'remote.common.biodegradableCompostablePlastic',
      text: '可生物降解和堆肥塑料'
    }),
    value: '7600'
  },
  ITALY_GLASS: {
    label: getLabelText({ key: 'remote.common.glass', text: '玻璃' }),
    value: '7700'
  }
})

const IT_BATTERY_LIST = new GenerateEnum({
  PORTABLE_BATTERY: {
    label: getLabelText({
      key: 'remote.common.portableBattery',
      text: '便携式电池和蓄电池'
    }),
    value: '1',
    children: new GenerateEnum({
      CARBON_ZINC: {
        value: '1.1',
        label: getLabelText({
          key: 'remote.common.carbonZincCell',
          text: '碳锌电池组'
        })
      },
      ZINC_CHLORIDE: {
        value: '1.2',
        label: getLabelText({
          key: 'remote.common.zincChlorideCell',
          text: '氯化锌电池组'
        })
      },
      ALKALINE: {
        value: '1.3',
        label: getLabelText({
          key: 'remote.common.alkalineStack',
          text: '碱性电池组'
        })
      },
      LITHIUM: {
        value: '1.4',
        label: getLabelText({
          key: 'remote.common.lithiumBattery',
          text: '锂电池'
        })
      },
      ZINC_AIR: {
        value: '1.5',
        label: getLabelText({
          key: 'remote.common.zincAirStack',
          text: '锌空气电池组'
        })
      },
      SILVER_ZINC: {
        value: '1.6',
        label: getLabelText({
          key: 'remote.common.silverZincCell',
          text: '银锌电池组'
        })
      },
      LEAD_ACID: {
        value: '1.7',
        label: getLabelText({
          key: 'remote.common.leadAcidBattery',
          text: '铅蓄电池'
        })
      },
      NICKEL_CADMIUM: {
        value: '1.8',
        label: getLabelText({
          key: 'remote.common.nickelCadmiumBattery',
          text: '镍镉蓄电池'
        })
      },
      NICKEL_METAL_HYDRIDE: {
        value: '1.9',
        label: getLabelText({
          key: 'remote.common.nickelMetalHydrideBattery',
          text: '镍氢蓄电池'
        })
      },
      LITHIUM_ION: {
        value: '1.10',
        label: getLabelText({
          key: 'remote.common.lithiumRechargeableBatteries',
          text: '锂蓄电池'
        })
      },
      ALKALINE_BUTTON_BATTERY: {
        value: '1.12',
        label: getLabelText({
          key: 'remote.common.itAlkalineButtonBattery',
          text: '碱性纽扣电池'
        })
      },
      LITHIUM_BUTTON_BATTERY: {
        value: '1.13',
        label: getLabelText({
          key: 'remote.common.itLithiumButtonBattery',
          text: '锂纽扣电池'
        })
      },
      ZINC_AIR_BUTTON_BATTERY: {
        value: '1.14',
        label: getLabelText({
          key: 'remote.common.itZincAirButtonBattery',
          text: '锌空气纽扣电池'
        })
      },
      SILVER_ZINC_BUTTON_BATTERY: {
        value: '1.15',
        label: getLabelText({
          key: 'remote.common.itSilverZincButtonBattery',
          text: '银锌纽扣电池'
        })
      },
      OTHER_BUTTON_BATTERIES: {
        value: '1.16',
        label: getLabelText({
          key: 'remote.common.itOtherButtonBatteries',
          text: '其他纽扣电池'
        })
      },
      OTHER_1: {
        value: '1.11',
        label: getLabelText({ key: 'remote.common.other', text: '其他' })
      }
    })
  },
  LMT_LIGHT_MEANSOF_TRANSPORT: {
    label: getLabelText({
      key: 'remote.common.LMTLightMeansofTransport',
      text: 'LMT-轻型运输工具'
    }),
    value: '4',
    children: new GenerateEnum({
      LEAD_ACID_2: {
        value: '4.1',
        label: getLabelText({
          key: 'remote.common.lead',
          text: '铅'
        })
      },
      NICKEL_CADMIUM_2: {
        value: '4.2',
        label: getLabelText({
          key: 'remote.common.nickelCadmium',
          text: '镍镉'
        })
      },
      LITHIUM: {
        value: '4.3',
        label: getLabelText({
          key: 'remote.common.lithium',
          text: '锂'
        })
      },
      NICKEL_METAL_HYDRID: {
        value: '4.4',
        label: getLabelText({
          key: 'remote.common.nickelHydrogen',
          text: '镍氢'
        })
      },
      OTHER_2: {
        value: '4.5',
        label: getLabelText({ key: 'remote.common.other', text: '其他' })
      }
    })
  },
  INDUSTRY_BATTERY: {
    label: getLabelText({
      key: 'remote.common.industrialBattery',
      text: '工业蓄电池'
    }),
    value: '2',
    children: new GenerateEnum({
      LEAD_ACID_2: {
        value: '2.1',
        label: getLabelText({
          key: 'remote.common.leadStorageDevice',
          text: '铅蓄电储能设备'
        })
      },
      LEAD_OTHER: {
        value: '2.14',
        label: getLabelText({
          key: 'remote.common.leadother',
          text: '其他铅电池'
        })
      },
      NICKEL_CADMIUM_2: {
        value: '2.2',
        label: getLabelText({
          key: 'remote.common.batteryNickelCadmium2',
          text: '镍镉蓄电储能设备'
        })
      },
      NICKEL_CADMIUM_OTHER: {
        value: '2.4',
        label: getLabelText({
          key: 'remote.common.nickelCadmiumOther',
          text: '其他镍镉电池'
        })
      },
      LITHIUM: {
        value: '2.5',
        label: getLabelText({
          key: 'remote.common.lithium',
          text: '锂'
        })
      },
      LITHIUM_LI_SOCL2_THIONYL_CHLORIDE: {
        value: '2.7',
        label: getLabelText({
          key: 'remote.common.lithiumLiSOCL2ThionylChloride',
          text: '锂亚硫酰氯电池（Li-SOCl2)'
        })
      },
      TRACTION_OF_HANDLING_EQUIPMENT_E_G_FORK_LI_FTS_MACHINERY_ET: {
        value: '2.8',
        label: getLabelText({
          key: 'remote.common.tractionofHandlingEquipmentegforkliftsmachineryet',
          text: '物料搬运设备牵引用电池（如叉车、机械等）'
        })
      },
      LITHIUM_OTHER: {
        value: '2.6',
        label: getLabelText({
          key: 'remote.common.lithiumOther',
          text: '其它锂电池'
        })
      },
      NICKEL_METAL_HYDRID_STORAGE: {
        value: '2.9',
        label: getLabelText({
          key: 'remote.common.nickelMetalHydridStorage',
          text: '镍氢储能电池'
        })
      },
      NICKEL_METAL_HYDRID_OTHER: {
        value: '2.10',
        label: getLabelText({
          key: 'remote.common.nickelMetalHydridOther',
          text: '其它镍氢电池'
        })
      },
      OTHER_STORAGE: {
        value: '2.11',
        label: getLabelText({
          key: 'remote.common.otherStorage',
          text: '其它储能电池'
        })
      },
      FOUR_R_25: {
        value: '2.12',
        label: getLabelText({
          key: 'remote.common.fourR25',
          text: '4R25型电池（方形高容量电池，常用于灯具）'
        })
      },
      NAS_SODIUM_SULFUR: {
        value: '2.13',
        label: getLabelText({
          key: 'remote.common.NASSodiumSulfur',
          text: 'NAS钠硫电池'
        })
      },
      OTHER_2: {
        value: '2.3',
        label: getLabelText({ key: 'remote.common.other', text: '其他' })
      }
    })
  },
  CAR_BATTERY: {
    label: getLabelText({
      key: 'remote.common.EV',
      text: '电动车电池'
    }),
    value: '3',
    children: new GenerateEnum({
      LEAD_ACID_2: {
        value: '3.1',
        label: getLabelText({
          key: 'remote.common.lead',
          text: '铅'
        })
      },
      NICKEL_CADMIUM_2: {
        value: '3.2',
        label: getLabelText({
          key: 'remote.common.nickelCadmium',
          text: '镍镉'
        })
      },
      LITHIUM: {
        value: '3.4',
        label: getLabelText({
          key: 'remote.common.lithium',
          text: '锂'
        })
      },
      NICKEL_METAL_HYDRID: {
        value: '3.5',
        label: getLabelText({
          key: 'remote.common.nickelHydrogen',
          text: '镍氢'
        })
      },
      OTHER_2: {
        value: '3.3',
        label: getLabelText({ key: 'remote.common.other', text: '其他' })
      }
    })
  },
  SLI_STARTING_LIGHTING_AND_IGNITION: {
    label: getLabelText({
      key: 'remote.common.SLIStartingLightingAndIgnition',
      text: '启动、照明和点火电池（SLI）'
    }),
    value: '5',
    children: new GenerateEnum({
      LEAD_ACID_2: {
        value: '5.1',
        label: getLabelText({
          key: 'remote.common.lead',
          text: '铅'
        })
      },
      NICKEL_CADMIUM_2: {
        value: '5.2',
        label: getLabelText({
          key: 'remote.common.nickelCadmium',
          text: '镍镉'
        })
      },
      LITHIUM: {
        value: '5.3',
        label: getLabelText({
          key: 'remote.common.lithium',
          text: '锂'
        })
      },
      NICKEL_METAL_HYDRID: {
        value: '5.4',
        label: getLabelText({
          key: 'remote.common.nickelHydrogen',
          text: '镍氢'
        })
      },
      OTHER_2: {
        value: '5.5',
        label: getLabelText({ key: 'remote.common.other', text: '其他' })
      }
    })
  }
})

// 意大利的W3E
const IT_W3E_LIST = [
  {
    name: getLabelText({
      key: 'remote.common.heatExchanger',
      text: '温度交换设备'
    }),
    value: '1',
    status: '1',
    data: [
      {
        name: getLabelText({
          key: 'remote.enumerate.refrigeratorsAndFreezers',
          text: '冰箱'
        }),
        value: '1.1'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.freezersForFreezers',
          text: '冰柜'
        }),
        value: '1.2'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.coldGoodsAutomaticDistributor',
          text: '自动分发冷产品的设备'
        }),
        value: '1.3'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.airConditioningHeatPumpDehumidifier',
          text: '空调、除湿机、热泵'
        }),
        value: '1.4'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.oilRadiator',
          text: '油汀'
        }),
        value: '1.5'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.otherTemperatureExchangeEquipmentContainingLiquidsExcludingWater',
          text: '使用非水类流体的其他温度交换设备'
        }),
        value: '1.6'
      }
    ]
  },
  {
    name: getLabelText({
      key: 'remote.common.largeScreenDevice',
      text: '屏幕、显示器及显示面积大于100平方厘米的设备'
    }),
    value: '2',
    status: '2',
    data: [
      {
        name: getLabelText({ key: 'remote.common.screen', text: '屏幕' }),
        value: '2.1'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.television1024',
          text: '电视机'
        }),
        value: '2.2'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.digitalLCDFrame',
          text: '数字液晶相框'
        }),
        value: '2.3'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.monitor1024',
          text: '显示器'
        }),
        value: '2.4'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.notebookComputer',
          text: '笔记本电脑'
        }),
        value: '2.5'
      }
    ]
  },
  {
    name: getLabelText({ key: 'remote.common.lightBulb', text: '灯' }),
    value: '3',
    status: '3',
    data: [
      {
        name: getLabelText({
          key: 'remote.enumerate.fluorescentLamp',
          text: '荧光灯管'
        }),
        value: '3.1'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.smallFluorescentLightBulb',
          text: '紧凑型荧光灯（节能灯）'
        }),
        value: '3.2'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.fluorescentTube',
          text: '荧光灯'
        }),
        value: '3.3'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.highDensityDischargeHighpressureSodiumVaporLampsMetalHalideLampsPressureSodiumVaporlamps',
          text: '高强度气体放电灯，包括高压钠灯'
        }),
        value: '3.4'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.led',
          text: '发光二极管灯（LED灯）'
        }),
        value: '3.5'
      }
    ]
  },
  {
    name: getLabelText({
      key: 'remote.common.largeEquipment',
      text: '大型设备'
    }),
    value: '4',
    status: '4',
    data: [
      {
        name: getLabelText({
          key: 'remote.enumerate.washingMachine',
          text: '洗衣机'
        }),
        value: '4.1'
      },
      {
        name: getLabelText({ key: 'remote.enumerate.dryer', text: '干衣机' }),
        value: '4.2'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.heatPumpDryer',
          text: '热泵式干衣机'
        }),
        value: '4.17'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.dishwasher',
          text: '洗碗机'
        }),
        value: '4.3'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.cookingEquipmentElectricHeatersElectricStoves',
          text: '烹饪设备、电暖气、电炉盘'
        }),
        value: '4.4'
      },
      {
        name: getLabelText({
          key: 'remote.common.lightingEquipment',
          text: '照明设备'
        }),
        value: '4.5'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.musicEquipmentTapeRecordersVideoRecorders',
          text: '音像播放设备、音乐设备'
        }),
        value: '4.6'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.sewingMachine',
          text: '缝纫机、编织机'
        }),
        value: '4.7'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.largeScalePrinter',
          text: '大型打印机'
        }),
        value: '4.8'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.largeCopier',
          text: '大型复印机'
        }),
        value: '4.9'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.largeCoinOperatedMachine',
          text: '大型投币式设备'
        }),
        value: '4.10'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.largeMedicalEquipment',
          text: '大型医疗设备'
        }),
        value: '4.11'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.largeScaleMonitoringAndControlEquipment',
          text: '大型监控与控制设备'
        }),
        value: '4.12'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.largeCargoAndCoinDispensers',
          text: '自动分发商品或金钱的大型设备'
        }),
        value: '4.13'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.photovoltaicPanel',
          text: '光伏板（太阳能板）'
        }),
        value: '4.14'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.largeCommercialServers',
          text: '主机（大型计算机）'
        }),
        value: '4.15'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricHeatersBedroomBedsChairsFurnitureAndOtherLargeApplications',
          text: '电暖器、电加热设备、用于加热床铺和座椅家具的大型设备及其他应用'
        }),
        value: '4.16'
      }
    ]
  },
  {
    name: getLabelText({
      key: 'remote.enumerate.smallEquipment1024',
      text: '小型设备'
    }),
    value: '5',
    status: '5',
    data: [
      {
        name: getLabelText({
          key: 'remote.enumerate.vacuumCleaner',
          text: '吸尘器'
        }),
        value: '5.1'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricBroom',
          text: '机械扫地机'
        }),
        value: '5.2'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.sewingMachine2',
          text: '缝纫机'
        }),
        value: '5.3'
      },
      {
        name: getLabelText({
          key: 'remote.common.lightingEquipment',
          text: '照明设备'
        }),
        value: '5.4'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.microwaveOven',
          text: '微波炉'
        }),
        value: '5.5'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricFan',
          text: '电风扇'
        }),
        value: '5.6'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricIron',
          text: '熨斗'
        }),
        value: '5.7'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.toaster',
          text: '烤面包机'
        }),
        value: '5.8'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricKnife',
          text: '电动刀具'
        }),
        value: '5.9'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricKettle',
          text: '电热水壶'
        }),
        value: '5.10'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.clockAndAlarmClock',
          text: '时钟和闹钟'
        }),
        value: '5.11'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricShaver',
          text: '电动剃须刀'
        }),
        value: '5.12'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electronicScale',
          text: '电子秤'
        }),
        value: '5.13'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.hairCuttingElectricPusher',
          text: '理发器和身体护理设备'
        }),
        value: '5.14'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.calculator',
          text: '计算器'
        }),
        value: '5.15'
      },
      {
        name: getLabelText({ key: 'remote.enumerate.radio', text: '收音设备' }),
        value: '5.16'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.camera',
          text: '摄像机、录像机'
        }),
        value: '5.17'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.hifiSpeakersInstrumentsAudioAndImageResetDevices',
          text: '高保真音响设备、乐器、音像播放设备'
        }),
        value: '5.18'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electricToys',
          text: '电动和电子玩具'
        }),
        value: '5.19'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.sportsEquipmentBicyclesComputersScubaDivingtreadmillsRowingMachinesetc',
          text: '体育设备、自行车码表、潜水设备、跑步器、划船器等'
        }),
        value: '5.20'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.smokeDetectorsHeatRegulatorsTemperatureControllersSmallElectrical',
          text: '烟雾探测器、温度调节器、恒温器、小型电气和电子仪器、小型医疗设备、小型监控和控制设备'
        }),
        value: '5.21'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.smallEquipmentForAutomatiPproductAllocation',
          text: '自动分发产品的小型设备'
        }),
        value: '5.22'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.smallEquipmentWithIntegratedPhotovoltaicPanels',
          text: '内置光伏板的小型设备'
        }),
        value: '5.23'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.cookwareElectricHeatersElectricPlatesElectricHeatersFryingPanixersElec1024',
          text: '烹饪设备、电暖器、电炉盘、电加热器、油炸锅、搅拌机、电动咖啡研磨机、开封/封装设备、吹风机、电动牙刷、电动剃须刀、按摩设备及其他身体护理设备、清洁用具及其他小型电器'
        }),
        value: '5.24'
      }
    ]
  },
  {
    name: getLabelText({
      key: 'remote.common.smallItTelecomEquipment',
      text: '小型IT和电信设备（外部尺寸不超过50厘米)'
    }),
    value: '6',
    status: '6',
    data: [
      {
        name: getLabelText({
          key: 'remote.enumerate.mobilePhone',
          text: '手机'
        }),
        value: '6.1'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.gps1024',
          text: '卫星导航设备（GPS）'
        }),
        value: '6.2'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.calculator',
          text: '计算器'
        }),
        value: '6.3'
      },
      {
        name: getLabelText({ key: 'remote.enumerate.router', text: '路由器' }),
        value: '6.4'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.personalComputer',
          text: '个人电脑'
        }),
        value: '6.5'
      },
      {
        name: getLabelText({ key: 'remote.enumerate.printer', text: '打印机' }),
        value: '6.6'
      },
      {
        name: getLabelText({ key: 'remote.common.phones', text: '固定电话' }),
        value: '6.7'
      },
      {
        name: getLabelText({
          key: 'remote.enumerate.electronicOrganizersElectricAndElectronicTypewriters',
          text: '电子记事本、电动和电子打字机、其他用于电子方式收集、存储、处理、展示或传递信息的产品与设备，例如传真机、电传打字机、公用电话亭、电话答录机，以及其他通过通信方式传输声音、图像或信息的产品与设备，以及其他小型信息与通信设备'
        }),
        value: '6.8'
      }
    ]
  }
]

export const isEprBackTaxType = (serviceType, country) => {
  return (
    COMMON_COUNTRY.FR === String(country) &&
    [
      COMMON_SERVICE_TYPE.PACKAGING_REGISTRATION_DECLARATION,
      COMMON_SERVICE_TYPE.PACKAGING_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.PACKAGING_RENEW,
      COMMON_SERVICE_TYPE.TEXTILE_LAW_DECLARATION,
      COMMON_SERVICE_TYPE.TEXTILE_LAW_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.TEXTILE_LAW_RENEW,
      COMMON_SERVICE_TYPE.BATTERY_REGISTRATION_DECLARATION,
      COMMON_SERVICE_TYPE.BATTERY_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.BATTERY_RENEW,
      COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION,
      COMMON_SERVICE_TYPE.WEEE_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.WEEE_RENEW,
      COMMON_SERVICE_TYPE.TOY_DECLARATION,
      COMMON_SERVICE_TYPE.TOY_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.TOY_RENEW,
      COMMON_SERVICE_TYPE.HOME_FURNISHING_DECLARATION,
      COMMON_SERVICE_TYPE.HOME_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.HOME_FURNISHING_RENEW,
      COMMON_SERVICE_TYPE.DIY_GARDEN_REGISTRATION,
      COMMON_SERVICE_TYPE.DIY_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.DIY_GARDEN_RENEW
    ].includes(String(serviceType))
  )
}

export const GERMANY_PLASTIC_TAX = PLASTIC_LIST

export const DecimalUtils = {
  // 加法
  add(...numbers) {
    return numbers.reduce((acc, num) => acc.plus(new Decimal(num)), new Decimal(0)).toNumber()
  },

  // 减法 (a - b)
  subtract(a, b) {
    return new Decimal(a).minus(new Decimal(b)).toNumber()
  },

  // 乘法
  multiply(...numbers) {
    return numbers.reduce((acc, num) => acc.times(new Decimal(num)), new Decimal(1)).toNumber()
  },

  // 除法 (a / b)
  divide(a, b) {
    if (new Decimal(b).equals(0)) throw new Error('Division by zero')
    return new Decimal(a).dividedBy(new Decimal(b)).toNumber()
  },

  // 向上取整（指定小数位）
  ceil(number, decimals = 0) {
    return new Decimal(number).toDecimalPlaces(decimals, Decimal.ROUND_UP).toNumber()
  },
  // 10位取整
  toNearestRoundHalfUp(a) {
    return new Decimal(a).toNearest(10, Decimal.ROUND_HALF_UP).toNumber()
  }
}

// 获取回收价格转换后币种
export const getRecyclingCurrencyName = () => {
  const getters = typeof window !== 'undefined' ? window?.app?.$store?.getters || {} : {}
  const recyclingCurrency = typeof window !== 'undefined' ? window?.app?.$store?.state?.user?.currencyConfigDataVO.recyclingCurrency || {} : {}
  let currency = ''
  if (recyclingCurrency.isMultiCurrency == 1) {
    currency = recyclingCurrency.currency
  } else {
    if (getters?.ISGJTEU) {
      currency = 'EUR'
    } else if (getters?.ISGJTUS) {
      currency = 'USD'
    } else {
      currency = 'CNY'
    }
  }
  return getPriceSymbol(currency)
}

// 获取回收价格标题
export const getRecyclingTitle = () => {
  return `${window?.app?.$t('remote.common.recoveryUnitPrice')}（${getRecyclingCurrencyName()}）`
}

// 获取回收价格
export const getAfterConversionPrice = (currency, value) => {
  const recyclingCurrency = typeof window !== 'undefined' ? window?.app?.$store?.state?.user?.currencyConfigDataVO.recyclingCurrency || {} : {}
  if (recyclingCurrency.isMultiCurrency == 1) {
    const obj1 = recyclingCurrency.currencyConfigVos.find((item) => item.currency == currency)
    const obj2 = recyclingCurrency.currencyConfigVos.find((item) => item.currency == recyclingCurrency.currency)
    if ((Number(value) || value === 0) && obj1 && obj2) {
      let rate = DecimalUtils.divide(obj1.rate, obj2.rate)
      if (recyclingCurrency.isExchangeRate) {
        rate = DecimalUtils.multiply(rate, DecimalUtils.add(1, DecimalUtils.divide(recyclingCurrency.coefficientBonus, 100)))
      }
      rate = DecimalUtils.ceil(rate, recyclingCurrency.rateDecimalPlaces)
      return DecimalUtils.ceil(DecimalUtils.multiply(Number(value), Number(rate)), recyclingCurrency.recyclingPriceDecimalPlaces)
    }
    return ''
  } else {
    const obj1 = recyclingCurrency.currencyConfigVos?.find((item) => item.currency == currency)
    if ((Number(value) || value === 0) && obj1) {
      const rate = DecimalUtils.ceil(Number(obj1.rate), recyclingCurrency.rateDecimalPlaces)
      return DecimalUtils.ceil(DecimalUtils.multiply(Number(value), rate), recyclingCurrency.recyclingPriceDecimalPlaces)
    }
    return ''
  }
}

// 获取商品价格
export const getAfterConversionGoodsPrice = (value) => {
  const currencyConfigDataVO = typeof window !== 'undefined' ? window?.app?.$store?.state?.user?.currencyConfigDataVO || {} : {}
  const { currencyConfigVos } = currencyConfigDataVO
  const obj = currencyConfigVos?.find((item) => item.currencyType == 1 && item.state == 1)
  if (obj) {
    if (Number(value) || value === 0) {
      let price = DecimalUtils.ceil(DecimalUtils.multiply(Number(value), Number(obj.rate)), obj.decimalClaces)
      if (obj.decimalClaces === 0 && obj.tenFlag == 1 && price > 10) {
        // 若个位数字小于5，则将个位设为0；若≥5，则个位设为0并向十位进1。
        price = DecimalUtils.toNearestRoundHalfUp(price)
      }
      return price
    } else {
      return ''
    }
  }
  return value
}

// 获取汇率币种名称
export const getRateCurrencyName = (type) => {
  // 1 转换前 2 转换后
  const getters = typeof window !== 'undefined' ? window?.app?.$store?.getters || {} : {}
  const officialCurrency = typeof window !== 'undefined' ? window?.app?.$store?.state?.user?.currencyConfigDataVO?.officialCurrency || {} : {}
  let currency = ''
  if (type == 1) {
    if (getters?.ISGJT) {
      currency = 'EUR'
    } else {
      currency = 'CNY'
    }
  }
  if (type == 2) {
    if (officialCurrency?.isMultiCurrency == 1) {
      currency = officialCurrency.currency
    } else {
      if (getters?.ISGJTEU) {
        currency = 'EUR'
      } else if (getters?.ISGJTUS) {
        currency = 'USD'
      } else {
        currency = 'CNY'
      }
    }
  }
  return getPriceSymbol(currency, 1)
}

// 获取官费币种名称
export const getOfficialCurrencyName = (type, showType) => {
  // 1 转换前 2 转换后
  const getters = typeof window !== 'undefined' ? window?.app?.$store?.getters || {} : {}
  const officialCurrency = typeof window !== 'undefined' ? window?.app?.$store?.state?.user?.currencyConfigDataVO?.officialCurrency || {} : {}
  let currency = ''
  if (type == 1) {
    if (getters?.ISGJT) {
      currency = 'EUR'
    } else {
      currency = 'CNY'
    }
  }
  if (type == 2) {
    if (officialCurrency?.isMultiCurrency == 1) {
      currency = officialCurrency.currency
    } else {
      if (getters?.ISGJTEU) {
        currency = 'EUR'
      } else if (getters?.ISGJTUS) {
        currency = 'USD'
      } else {
        currency = 'CNY'
      }
    }
  }
  if (showType == 2) {
    return currency
  }
  return getPriceSymbol(currency, 1)
}

// 获取官费价格
export const getOfficialPrice = (price, rate) => {
  const officialCurrency = typeof window !== 'undefined' ? window?.app?.$store?.state?.user?.currencyConfigDataVO?.officialCurrency || {} : {}
  return DecimalUtils.ceil(DecimalUtils.multiply(Number(price), Number(rate)), officialCurrency.officialDecimalPlaces)
}

export const isEprBackTaxTypeToPay = (serviceType, country) => {
  return (
    COMMON_COUNTRY.FR === String(country) &&
    [
      COMMON_SERVICE_TYPE.PACKAGING_REGISTRATION_DECLARATION,
      COMMON_SERVICE_TYPE.PACKAGING_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.PACKAGING_RENEW,
      COMMON_SERVICE_TYPE.TEXTILE_LAW_DECLARATION,
      COMMON_SERVICE_TYPE.TEXTILE_LAW_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.TEXTILE_LAW_RENEW,
      COMMON_SERVICE_TYPE.BATTERY_REGISTRATION_DECLARATION,
      COMMON_SERVICE_TYPE.BATTERY_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.BATTERY_RENEW,
      COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION,
      COMMON_SERVICE_TYPE.WEEE_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.WEEE_RENEW,
      COMMON_SERVICE_TYPE.TOY_DECLARATION,
      COMMON_SERVICE_TYPE.TOY_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.TOY_RENEW,
      COMMON_SERVICE_TYPE.HOME_FURNISHING_DECLARATION,
      COMMON_SERVICE_TYPE.HOME_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.HOME_FURNISHING_RENEW,
      COMMON_SERVICE_TYPE.DIY_GARDEN_REGISTRATION,
      COMMON_SERVICE_TYPE.DIY_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.DIY_GARDEN_RENEW,
      COMMON_SERVICE_TYPE.SPORTS_AND_LEISURE_REGISTRATION,
      COMMON_SERVICE_TYPE.SPORTS_AND_LEISURE_TRANSFORM_DECLARATION,
      COMMON_SERVICE_TYPE.SPORTS_AND_LEISURE_RENEW
    ].includes(String(serviceType))
  )
}

const POLAND_CHILDREN = {
  ZINC_CARBON: {
    value: '80086',
    label: getLabelText({
      key: 'remote.common.zincCarbonBatteries',
      text: '锌碳电池'
    })
  },
  ZINC_MANGANESE: {
    value: '80087',
    label: getLabelText({
      key: 'remote.common.zincManganeseBattery',
      text: '锌锰电池'
    })
  },
  ZINC_AIR: {
    value: '80088',
    label: getLabelText({
      key: 'remote.common.zinc-airBattery',
      text: '锌空气电池'
    })
  },
  ALKALINE: {
    value: '80089',
    label: getLabelText({
      key: 'remote.common.alkalineBattery',
      text: '碱性电池'
    })
  },
  NICKEL_CADMIUM: {
    value: '80090',
    label: getLabelText({
      key: 'remote.common.cadmiumBattery',
      text: '镍镉电池'
    })
  },
  LEAD: {
    value: '80091',
    label: getLabelText({
      key: 'remote.common.leadBattery',
      text: '铅电池'
    })
  },
  LEAD_ACID_BATTERIES: {
    value: '80095',
    label: getLabelText({
      key: 'remote.common.leadAcidBatteries',
      text: '铅酸电池'
    })
  },
  MERCURY_FREE_BUTTON: {
    value: '80092',
    label: getLabelText({
      key: 'remote.common.mercuryFreeButtonBattery',
      text: '不含汞的纽扣电池'
    })
  },
  MERCURY_CONTAINING_BUTTON: {
    value: '80093',
    label: getLabelText({
      key: 'remote.common.mercuryContainingButtonBattery',
      text: '含汞纽扣电池'
    })
  },
  OTHERS: {
    value: '80094',
    label: getLabelText({
      key: 'remote.common.otherBatteries',
      text: '其它电池'
    })
  }
}

// 波兰电池类型
const POLAND_BATTERY = new GenerateEnum({
  PORTABLE: {
    value: '20086',
    label: getLabelText({
      key: 'remote.common.deviceBatteryType',
      text: '设备电池'
    }),
    children: new GenerateEnum(POLAND_CHILDREN)
  },
  INDUSTRIAL: {
    value: '20087',
    label: getLabelText({
      key: 'remote.common.industrialBatteryType',
      text: '工业电池'
    }),
    children: new GenerateEnum(POLAND_CHILDREN)
  },
  AUTOMOTIVE: {
    value: '20088',
    label: getLabelText({
      key: 'remote.common.automotiveBatteries',
      text: '汽车电池'
    }),
    children: new GenerateEnum(POLAND_CHILDREN)
  }
})

// 瑞典电池类型
const SWEDEN_BATTERY = new GenerateEnum({
  PORTABLE: {
    value: '20086',
    label: getLabelText({
      key: 'remote.common.deviceBatteryType',
      text: '设备电池'
    }),
    children: new GenerateEnum({
      PORTABLE_ZINC: {
        value: '861',
        label: getLabelText({
          key: 'remote.common.alkalineZincCarbonSilverZinc',
          text: '碱性/锌碳/氧化银/锌'
        })
      },
      PORTABLE_NICKEL_CADMIUM: {
        value: '862',
        label: getLabelText({
          key: 'remote.common.nickelCadmium',
          text: '镍镉'
        })
      },
      PORTABLE_NICKEL_METAL_HYDRIDE: {
        value: '863',
        label: getLabelText({
          key: 'remote.common.NiMHBattery',
          text: '镍氢电池'
        })
      },
      PORTABLE_LEAD: {
        value: '864',
        label: getLabelText({
          key: 'remote.common.lead',
          text: '铅'
        })
      },
      PORTABLE_LI: {
        value: '865',
        label: getLabelText({
          key: 'remote.common.lithium',
          text: '锂'
        })
      },
      PORTABLE_LITHIUM_ION: {
        value: '866',
        label: getLabelText({
          key: 'remote.common.lithiumIonLithiumPolymer',
          text: '锂离子/锂聚合物'
        })
      }
    })
  },
  INDUSTRIAL: {
    value: '20087',
    label: getLabelText({
      key: 'remote.common.industrialBatteryTypeLessThan3kg',
      text: '工业电池（单个电池重量≤3kg）'
    }),
    children: new GenerateEnum({
      INDUSTRY_LEAD: {
        value: '871',
        label: getLabelText({
          key: 'remote.common.lead',
          text: '铅'
        })
      },
      INDUSTRY_NICKEL_METAL_HYDRIDE: {
        value: '872',
        label: getLabelText({
          key: 'remote.common.NiMHBattery',
          text: '镍氢电池'
        })
      },
      INDUSTRY_ZINC: {
        value: '873',
        label: getLabelText({
          key: 'remote.common.alkalineZincCarbonSilverZinc',
          text: '碱性/锌碳/氧化银/锌'
        })
      },
      INDUSTRY_LITHIUM_ION: {
        value: '874',
        label: getLabelText({
          key: 'remote.common.lithiumIonLithiumPolymer',
          text: '锂离子/锂聚合物'
        })
      }
    })
  },
  INDUSTRY_BATTERY_OVER3: {
    value: '20089',
    label: getLabelText({
      key: 'remote.common.industrialBatteryTypeGreaterThan3kg',
      text: '工业电池（单个电池重量＞3kg）'
    }),
    children: new GenerateEnum({
      INDUSTRY_LEAD: {
        value: '891',
        label: getLabelText({
          key: 'remote.common.leadAcidNotCarBattery',
          text: '铅酸（非汽车电池）'
        })
      },
      INDUSTRY_NICKEL_METAL_HYDRIDE: {
        value: '892',
        label: getLabelText({
          key: 'remote.common.NiMHBattery',
          text: '镍氢电池'
        })
      },
      INDUSTRY_ZINC: {
        value: '893',
        label: getLabelText({
          key: 'remote.common.alkalineZincCarbonSilverZinc',
          text: '碱性/锌碳/氧化银/锌'
        })
      },
      INDUSTRY_LITHIUM_ION: {
        value: '894',
        label: getLabelText({
          key: 'remote.common.lithiumIonLithiumIonPolymerCanCharge',
          text: '锂离子（可充电）'
        })
      }
    })
  },
  AUTOMOTIVE: {
    value: '20088',
    label: getLabelText({
      key: 'remote.common.automotiveBatteries',
      text: '汽车电池'
    }),
    children: new GenerateEnum({
      CAR_NICKEL_CADMIUM: {
        value: '885',
        label: getLabelText({
          key: 'remote.common.nickelCadmiumNiCdNoBattery',
          text: '镍镉'
        })
      },
      CAR_OTHER_BATTERY: {
        value: '886',
        label: getLabelText({
          key: 'remote.common.otherBatteries',
          text: '其他电池'
        })
      },
      CAR_LEAD_ACID: {
        value: '887',
        label: getLabelText({
          key: 'remote.common.leadAcidBatteries',
          text: '铅酸电池'
        })
      }
    })
  }
})

// 爱尔兰电池类型
const IRELAND_BATTERY = new GenerateEnum({
  PORTABLE: {
    value: '170086',
    label:
      '1.' +
      getLabelText({
        key: 'remote.common.deviceBatteryType',
        text: '设备电池'
      }),
    children: new GenerateEnum({
      NON_RECHARGEABLE: {
        value: '10001',
        label:
          '1.1 ' +
          getLabelText({
            key: 'remote.enumerate.nonRechargeable',
            text: '非充电式'
          }),
        children: new GenerateEnum({
          ZINC_CARBON: {
            value: '1.1.1',
            label:
              '1.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.alkalineZincCarbonZincAir',
                text: '碱性/锌碳/锌空气'
              })
          },
          LI: {
            value: '1.1.2',
            label:
              '1.1.2' +
              getLabelText({
                key: 'remote.common.lithium',
                text: '锂'
              })
          },
          OXIDE: {
            value: '1.1.3',
            label:
              '1.1.3 ' +
              getLabelText({
                key: 'remote.common.silverOxide',
                text: '氧化银'
              })
          },
          OTHER_NON_RECHARGEABLE: {
            value: '1.1.4',
            label:
              '1.1.4 ' +
              getLabelText({
                key: 'remote.enumerate.other Non Rechargeable',
                text: '其他非充电式'
              })
          }
        })
      },
      RECHARGEABLE: {
        value: '10002',
        label:
          '1.2 ' +
          getLabelText({
            key: 'remote.enumerate.rechargeable',
            text: '可充电式'
          }),
        children: new GenerateEnum({
          LI_ION: {
            value: '1.2.1',
            label:
              '1.2.1 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          },
          LI_POLYMER: {
            value: '1.2.2',
            label:
              '1.2.2 ' +
              getLabelText({
                key: 'remote.common.lithiumPolymer',
                text: '锂聚合物'
              })
          },
          NICKEL_CADMIUM: {
            value: '1.2.4',
            label: '1.2.4 ' + getLabelText({ key: 'remote.common.nickelCadmium', text: '镍镉' })
          },
          NICKEL_HYDROGEN: {
            value: '1.2.5',
            label:
              '1.2.5 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          OTHER_RECHARGEABLE: {
            value: '1.2.6',
            label:
              '1.2.6 ' +
              getLabelText({
                key: 'remote.enumerate.otherRechargeable',
                text: '其他可充电式'
              })
          }
        })
      }
    })
  },
  LIGHT_MEANS_OF_TRANSPORT: {
    value: '170087',
    label:
      '2.' +
      getLabelText({
        key: 'remote.common.lightMeansOfTransport',
        text: '轻型运输工具电池'
      }),
    children: new GenerateEnum({
      E_CYCLES: {
        value: '20001',
        label:
          '2.1 ' +
          getLabelText({
            key: 'remote.common.IEBatterysubCategory3',
            text: '电动自行车'
          }),
        children: new GenerateEnum({
          LI: {
            value: '2.1.1',
            label:
              '2.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.lithiumIonPolymer',
                text: '锂(离子/聚合物)'
              })
          },
          NI_MH: {
            value: '2.1.2',
            label:
              '2.1.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LEAD_ACID: {
            value: '2.1.3',
            label:
              '2.1.3 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          }
        })
      },
      E_SCOOTERS: {
        value: '20002',
        label:
          '2.2 ' +
          getLabelText({
            key: 'remote.common.IEBatterysubCategory4',
            text: '电动滑板车'
          }),
        children: new GenerateEnum({
          LI: {
            value: '2.2.1',
            label:
              '2.2.1 ' +
              getLabelText({
                key: 'remote.enumerate.lithiumIonPolymer',
                text: '锂(离子/聚合物)'
              })
          },
          NI_MH: {
            value: '2.2.2',
            label:
              '2.2.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LEAD_ACID: {
            value: '2.2.3',
            label:
              '2.2.3 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          }
        })
      },
      ELECTRIC_MOBILITY: {
        value: '20003',
        label:
          '2.3 ' +
          getLabelText({
            key: 'remote.enumerate.theEMobilityWheelchairsGolfBuggy',
            text: '电动出行（电动轮椅，高尔夫球车）'
          }),
        children: new GenerateEnum({
          LI: {
            value: '2.3.1',
            label:
              '2.3.1 ' +
              getLabelText({
                key: 'remote.enumerate.lithiumIonPolymer',
                text: '锂(离子/聚合物)'
              })
          },
          NI_MH: {
            value: '2.3.2',
            label:
              '2.3.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LEAD_ACID: {
            value: '2.3.3',
            label:
              '2.3.3 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          }
        })
      },
      OTHER_MOBILITY: {
        value: '20004',
        label:
          '2.4 ' +
          getLabelText({
            key: 'remote.enumerate.otherMobilityGolfTrollyLeisureEquipment',
            text: '其他出行工具（高尔夫推车，休闲设备）'
          }),
        children: new GenerateEnum({
          LI: {
            value: '2.4.1',
            label:
              '2.4.1 ' +
              getLabelText({
                key: 'remote.enumerate.lithiumIonPolymer',
                text: '锂(离子/聚合物)'
              })
          },
          NI_MH: {
            value: '2.4.2',
            label:
              '2.4.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LEAD_ACID: {
            value: '2.4.3',
            label:
              '2.4.3 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          }
        })
      }
    })
  },
  STARTING_LIGHTING_AND_IGNITION_BATTERIES: {
    value: '170088',
    label:
      '3.' +
      getLabelText({
        key: 'remote.common.startingLightingAndIgnitionBatteries',
        text: '起动、照明和点火电池'
      }),
    children: new GenerateEnum({
      ALL_VEHICLES: {
        value: '30001',
        label:
          '3.1 ' +
          getLabelText({
            key: 'remote.enumerate.allVehicles',
            text: '所有车型'
          }),
        children: new GenerateEnum({
          LEAD_ACID: {
            value: '3.1.1',
            label:
              '3.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          },
          LI: {
            value: '3.1.2',
            label:
              '3.1.2 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          },
          NI_MH: {
            value: '3.1.3',
            label:
              '3.1.3 ' +
              getLabelText({
                key: 'remote.common.other',
                text: '其他'
              })
          }
        })
      }
    })
  },
  AUTOMOTIVE: {
    value: '170089',
    label:
      '4.' +
      getLabelText({
        key: 'remote.enumerate.electricVehiclesEVs',
        text: '电动汽车电池'
      }),
    children: new GenerateEnum({
      SMALL_VAN: {
        value: '40001',
        label:
          '4.1 ' +
          getLabelText({
            key: 'remote.enumerate.passengerCarM1',
            text: '乘用车，小型货车'
          }),
        children: new GenerateEnum({
          NICKEL_CADMIUM: {
            value: '4.1.1',
            label:
              '4.1.1 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '4.1.2',
            label:
              '4.1.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LI: {
            value: '4.1.3',
            label:
              '4.1.3 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          }
        })
      },
      L_CLASS: {
        value: '40002',
        label:
          '4.2 ' +
          getLabelText({
            key: 'remote.enumerate.motorCyclesScootersLClass',
            text: '摩托车/滑板车，L级'
          }),
        children: new GenerateEnum({
          NICKEL_CADMIUM: {
            value: '4.2.1',
            label:
              '4.2.1 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '4.2.2',
            label:
              '4.2.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LI: {
            value: '4.2.3',
            label:
              '4.2.3 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          }
        })
      },
      N2N3: {
        value: '40003',
        label:
          '4.3 ' +
          getLabelText({
            key: 'remote.enumerate.minibusesBusesN2N3',
            text: '（迷你）公共汽车（M2/M3）/卡车/货车（N2 N3)'
          }),
        children: new GenerateEnum({
          NICKEL_CADMIUM: {
            value: '4.3.1',
            label:
              '4.3.1 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '4.3.2',
            label:
              '4.3.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LI: {
            value: '4.3.3',
            label:
              '4.3.3 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          }
        })
      },
      TRAILERS: {
        value: '40004',
        label:
          '4.4 ' +
          getLabelText({
            key: 'remote.enumerate.trailersO',
            text: '拖车（O）'
          }),
        children: new GenerateEnum({
          NICKEL_CADMIUM: {
            value: '4.4.1',
            label:
              '4.4.1 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '4.4.2',
            label:
              '4.4.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LI: {
            value: '4.4.3',
            label:
              '4.4.3 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          }
        })
      }
    })
  },
  INDUSTRIAL_BATTERY_OR_PORTABLE_BATTERY_OVER5: {
    value: '170090',
    label:
      '5.' +
      getLabelText({
        key: 'remote.common.industrialBatteryOrPortableBatteryOver5',
        text: '工业电池或设备电池超过5kg'
      }),
    children: new GenerateEnum({
      ESS: {
        value: '50001',
        label:
          '5.1' +
          getLabelText({
            key: 'remote.enumerate.energyStorageSystemsESS',
            text: '储能系统（ESS）'
          }),
        children: new GenerateEnum({
          LI_ION: {
            value: '5.1.1',
            label:
              '5.1.1 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          },
          LI_OTHER: {
            value: '5.1.2',
            label:
              '5.1.2 ' +
              getLabelText({
                key: 'remote.enumerate.lithiumOther',
                text: '其他锂'
              })
          },
          LEAD_ACID: {
            value: '5.1.3',
            label:
              '5.1.3 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '5.1.4',
            label:
              '5.1.4 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          NICKEL_CADMIUM: {
            value: '5.1.5',
            label:
              '5.1.5 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          OTHER: {
            value: '5.1.6',
            label:
              '5.1.6 ' +
              getLabelText({
                key: 'remote.common.other',
                text: '其他'
              })
          }
        })
      },
      UPS: {
        value: '50002',
        label:
          '5.2 ' +
          getLabelText({
            key: 'remote.enumerate.universalPowerSupplyUPS',
            text: '通用电源（UPS）'
          }),
        children: new GenerateEnum({
          LI_ION: {
            value: '5.2.1',
            label:
              '5.2.1 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          },
          LI_OTHER: {
            value: '5.2.2',
            label:
              '5.2.2 ' +
              getLabelText({
                key: 'remote.enumerate.lithiumOther',
                text: '其他锂'
              })
          },
          LEAD_ACID: {
            value: '5.2.3',
            label:
              '5.2.3 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '5.2.4',
            label:
              '5.2.4 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          NICKEL_CADMIUM: {
            value: '5.2.5',
            label:
              '5.2.5 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          OTHER: {
            value: '5.2.6',
            label:
              '5.2.6 ' +
              getLabelText({
                key: 'remote.common.other',
                text: '其他'
              })
          }
        })
      },
      TRACTION: {
        value: '50003',
        label:
          '5.3 ' +
          getLabelText({
            key: 'remote.enumerate.traction',
            text: '牵引'
          }),
        children: new GenerateEnum({
          LEAD_ACID: {
            value: '5.3.1',
            label:
              '5.3.1 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '5.3.2',
            label:
              '5.3.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          NICKEL_CADMIUM: {
            value: '5.3.3',
            label:
              '5.3.3 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          LI_ION: {
            value: '5.3.4',
            label:
              '5.3.4 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          },
          OTHER: {
            value: '5.3.5',
            label:
              '5.3.5 ' +
              getLabelText({
                key: 'remote.common.other',
                text: '其他'
              })
          }
        })
      },
      AGRI: {
        value: '50004',
        label:
          '5.4 ' +
          getLabelText({
            key: 'remote.enumerate.agriBatteriesFarmFence',
            text: '农业电池（农场围栏）'
          }),
        children: new GenerateEnum({
          ZINC_CARBON: {
            value: '5.4.1',
            label:
              '5.4.1 ' +
              getLabelText({
                key: 'remote.enumerate.alkalineZincCarbonZincAir',
                text: '碱性/锌碳/锌空气'
              })
          },
          LI_ION: {
            value: '5.4.2',
            label:
              '5.4.2 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          }
        })
      },
      EMERGENCY: {
        value: '50005',
        label:
          '5.5 ' +
          getLabelText({
            key: 'remote.enumerate.emergencyLightingBatteries',
            text: '应急照明电池'
          }),
        children: new GenerateEnum({
          NICKEL_CADMIUM: {
            value: '5.5.1',
            label:
              '5.5.1 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '5.5.2',
            label:
              '5.5.2 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          LEAD_ACID: {
            value: '5.5.3',
            label:
              '5.5.3 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          },
          LI_ION: {
            value: '5.5.4',
            label:
              '5.5.4 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          }
        })
      },
      OTHER_INDUSTRIAL: {
        value: '50006',
        label:
          '5.6 ' +
          getLabelText({
            key: 'remote.common.IEBatterysubCategory17',
            text: '其他工业电池'
          }),
        children: new GenerateEnum({
          LEAD_ACID: {
            value: '5.6.1',
            label:
              '5.6.1 ' +
              getLabelText({
                key: 'remote.enumerate.leadAcid',
                text: '铅酸'
              })
          },
          LI_ION: {
            value: '5.6.2',
            label:
              '5.6.2 ' +
              getLabelText({
                key: 'remote.common.lithiumIon',
                text: '锂离子'
              })
          },
          NICKEL_CADMIUM: {
            value: '5.6.3',
            label:
              '5.6.3 ' +
              getLabelText({
                key: 'remote.common.nickelCadmium',
                text: '镍镉'
              })
          },
          NICKEL_METAL_HYDRID: {
            value: '5.6.4',
            label:
              '5.6.4 ' +
              getLabelText({
                key: 'remote.common.nickelHydrogen',
                text: '镍氢'
              })
          },
          OTHER: {
            value: '5.6.5',
            label:
              '5.6.5 ' +
              getLabelText({
                key: 'remote.common.other',
                text: '其他'
              })
          }
        })
      }
    })
  }
})

// 波兰WEEE
const POLAND_WEEE = new GenerateEnum({
  TEMPERATURE_EXCHANGE_EQUIPMENT: {
    value: '10086',
    label: getLabelText({
      key: 'remote.common.heatExchanger',
      text: '温度交换设备'
    }),
    requestLabel: getLabelText({
      key: 'remote.common.heatExchangerWithWeight',
      text: '温度交换设备150kg'
    })
  },
  SCREEN: {
    value: '10087',
    label: getLabelText({
      key: 'remote.common.displayScreen',
      text: '显示屏'
    }),
    requestLabel: getLabelText({
      key: 'remote.common.displayScreenWithWeight',
      text: '显示屏200kg'
    })
  },
  BULB: {
    value: '10088',
    label: getLabelText({
      key: 'remote.common.lightingEquipment2',
      text: '灯类'
    }),
    requestLabel: getLabelText({
      key: 'remote.common.lightingEquipment2WithWeight',
      text: '灯类100kg'
    })
  },
  LARGE_DEVICE: {
    value: '10089',
    label: getLabelText({
      key: 'remote.enumerate.largeNonPhotovoltaicEquipment',
      text: '大型非光伏设备'
    }),
    requestLabel: getLabelText({
      key: 'remote.enumerate.largeNonPhotovoltaicEquipmentWithWeight',
      text: '大型非光伏设备200kg'
    })
  },
  SMALL_DEVICE: {
    value: '10090',
    label: getLabelText({
      key: 'remote.enumerate.smallNonPvEquipment',
      text: '小型非光伏设备'
    }),
    requestLabel: getLabelText({
      key: 'remote.enumerate.smallNonPvEquipmentWithWeight',
      text: '小型非光伏设备200kg'
    })
  },
  SMALL_IT_TELECOM: {
    value: '10091',
    label: getLabelText({
      key: 'remote.common.smallITAndTelecommunicationEquipment',
      text: '小型IT和电信设备'
    }),
    requestLabel: getLabelText({
      key: 'remote.common.smallITAndTelecommunicationEquipmentWithWeight',
      text: '小型IT和电信设备200kg'
    })
  },
  // PHOTOVOLTAIC_EQUIPMENT: {
  //   value: '10092',
  //   label: getLabelText({
  //     key: 'remote.common.photovoltaicEquipment',
  //     text: '光伏设备',
  //   })
  // },

  LARGE_PHOTOVOLTAIC_EQUIPMENT: {
    value: '10093',
    label: getLabelText({
      key: 'remote.enumerate.largePvEquipment',
      text: '大型光伏设备'
    }),
    requestLabel: getLabelText({
      key: 'remote.enumerate.largePvEquipmentWithWeight',
      text: '大型光伏设备200kg'
    })
  },
  SMALL_PHOTOVOLTAIC_EQUIPMENT: {
    value: '10094',
    label: getLabelText({
      key: 'remote.enumerate.smallPvEquipment',
      text: '小型光伏设备'
    }),
    requestLabel: getLabelText({
      key: 'remote.enumerate.smallPvEquipmentWithWeight',
      text: '小型光伏设备200kg'
    })
  }
})

// 波兰包装法
const POLAND_PACKAGING = new GenerateEnum({
  PLASTIC: {
    value: '2002',
    label: getLabelText({
      key: 'remote.common.plastic',
      text: '塑料'
    })
  },
  ALUMINIUM: {
    value: '10002',
    label: getLabelText({
      key: 'remote.common.aluminium',
      text: '铝'
    })
  },
  IRON_AND_OTHER_METALS: {
    value: '10003',
    label: getLabelText({
      key: 'remote.enumerate.steelAndOtherMetalPackaging',
      text: '铁和其它金属'
    })
  },
  PAPER: {
    value: '2001',
    label: getLabelText({
      key: 'remote.common.paper2',
      text: '纸皮'
    })
  },
  GLASS: {
    value: '10005',
    label: getLabelText({
      key: 'remote.common.glass',
      text: '玻璃'
    })
  },
  WOOD: {
    value: '10006',
    label: getLabelText({
      key: 'remote.enumerate.wood',
      text: '木材'
    })
  },
  OTHER_MATERIALS: {
    value: '10007',
    label: getLabelText({
      key: 'remote.enumerate.otherMaterialsPackaging',
      text: '其它材料'
    })
  }
})

// 瑞典WEEE
const SWEDEN_WEEE = new GenerateEnum({
  TEMPERATURE_EXCHANGE_EQUIPMENT: {
    value: '10086',
    label: getLabelText({
      key: 'remote.common.heatExchanger',
      text: '温度交换设备'
    })
  },
  SCREEN: {
    value: '10087',
    label: getLabelText({
      key: 'remote.common.displayScreen',
      text: '显示屏'
    })
  },
  BULB: {
    value: '10088',
    label: getLabelText({
      key: 'remote.common.lightingEquipment2',
      text: '灯类'
    })
  },
  LARGE_DEVICE: {
    value: '10089',
    label: getLabelText({
      key: 'remote.common.largeElectronicAndElectricalEquipment',
      text: '大型电子电气设备'
    })
  },
  SMALL_DEVICE: {
    value: '10090',
    label: getLabelText({
      key: 'remote.common.smallElectronicAndElectricalEquipment',
      text: '小型电子电气设备'
    })
  },
  SMALL_IT_TELECOM: {
    value: '10091',
    label: getLabelText({
      key: 'remote.common.smallITAndTelecommunicationEquipment',
      text: '小型IT和电信设备'
    })
  }
})

// 爱尔兰WEEE
const IRELAND_WEEE = new GenerateEnum({
  TEMPERATURE_EXCHANGE_EQUIPMENT: {
    value: '10086',
    label:
      '1.' +
      getLabelText({
        key: 'remote.common.heatExchanger',
        text: '温度交换设备'
      }),
    children: new GenerateEnum({
      REFRIGERATION_SIDE_BY_SIDE: {
        value: '1.1',
        label:
          '1.1 ' +
          getLabelText({
            key: 'remote.enumerate.refrigerationSideAmericanStyle',
            text: '制冷（并排式/美式）'
          }),
        children: new GenerateEnum({
          ALL_REFRIGERATION: {
            value: '1.1.1',
            label:
              '1.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.allRefrigeration',
                text: '所有制冷'
              })
          }
        })
      },
      REFRIGERATION_2DOOR_OVER150L: {
        value: '1.2',
        label:
          '1.2 ' +
          getLabelText({
            key: 'remote.enumerate.refrigeration2Door150Litres',
            text: '制冷（2门+立式冷冻柜>150升）'
          }),
        children: new GenerateEnum({
          ALL_REFRIGERATION: {
            value: '1.2.1',
            label:
              '1.2.1 ' +
              getLabelText({
                key: 'remote.enumerate.allRefrigeration',
                text: '所有制冷'
              })
          },
          UPRIGHT_FREEZER: {
            value: '1.2.2',
            label:
              '1.2.2 ' +
              getLabelText({
                key: 'remote.enumerate.chestFreezers',
                text: '立式冷冻柜'
              })
          }
        })
      },
      REFRIGERATION_UNDER150L: {
        value: '1.3',
        label:
          '1.3 ' +
          getLabelText({
            key: 'remote.enumerate.refrigerationChestxy150Litres',
            text: '制冷（台下/桌面+立式冷冻柜<150升）'
          }),
        children: new GenerateEnum({
          ALL_REFRIGERATION: {
            value: '1.3.1',
            label:
              '1.3.1 ' +
              getLabelText({
                key: 'remote.enumerate.allRefrigeration',
                text: '所有制冷'
              })
          },
          UPRIGHT_FREEZER: {
            value: '1.3.2',
            label:
              '1.3.2 ' +
              getLabelText({
                key: 'remote.enumerate.chestFreezers',
                text: '立式冷冻柜'
              })
          }
        })
      },
      OTHER_TEMPERATURE_EXCHANGE: {
        value: '1.4',
        label:
          '1.4 ' +
          getLabelText({
            key: 'remote.enumerate.allOtherTemperatureExchangeEquipment',
            text: '所有其他温度交换设备'
          }),
        children: new GenerateEnum({
          ALL_REFRIGERATION_EQUIPMENT: {
            value: '1.4.1',
            label:
              '1.4.1 ' +
              getLabelText({
                key: 'remote.enumerate.airConditioningEquipmentAllOtherRefrigeration',
                text: '冰箱、冷冻柜、自动输送冷藏产品的设备，空调设备、除湿设备、热泵、所有其他制冷设备'
              })
          }
        })
      },
      OIL_RADIATOR: {
        value: '1.5',
        label:
          '1.5 ' +
          getLabelText({
            key: 'remote.enumerate.containingOilExchangeEquipmentUsingFluids',
            text: '含油散热器及其他使用水以外流体进行温度交换的温度交换设备'
          }),
        children: new GenerateEnum({
          OIL_RADIATOR_EQUIPMENT: {
            value: '1.5.1',
            label:
              '1.5.1 ' +
              getLabelText({
                key: 'remote.enumerate.radiatorsContainingOilAndTemperatureExchangeEquipmentUsing',
                text: '含油散热器及使用水以外的液体进行温度交换的温度交换设备'
              })
          }
        })
      }
    })
  },
  SCREEN: {
    value: '10087',
    label:
      '2.' +
      getLabelText({
        key: 'remote.common.largeScreenDevice',
        text: '屏幕，显示器设备（表面积大于100平方厘米）'
      }),
    children: new GenerateEnum({
      LARGE_TV: {
        value: '2.1',
        label:
          '2.1 ' +
          getLabelText({
            key: 'remote.enumerate.largeTelevisionsVisibleScreenSize',
            text: '大型电视（可见屏幕尺寸）'
          }),
        children: new GenerateEnum({
          ALL_LARGE_TV: {
            value: '2.1.1',
            label:
              '2.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.largeTVs73cm',
                text: '73厘米及以上的大型电视'
              })
          }
        })
      },
      SMALL_MEDIUM_TV: {
        value: '2.2',
        label:
          '2.2 ' +
          getLabelText({
            key: 'remote.enumerate.mediumAndSmallSizeTelevisions072cmVisibleScreenSize',
            text: '中小尺寸电视（0-72cm可见屏幕尺寸）'
          }),
        children: new GenerateEnum({
          ALL_SMALL_MEDIUM_TV: {
            value: '2.2.1',
            label:
              '2.2.1 ' +
              getLabelText({
                key: 'remote.enumerate.mediumAndSmallSizeTelevisions072cmVisibleScreenSize',
                text: '中小尺寸电视（0-72cm可见屏幕尺寸）'
              })
          }
        })
      },
      COMPUTER_MONITOR: {
        value: '2.3',
        label:
          '2.3 ' +
          getLabelText({
            key: 'remote.enumerate.computerMonitorsScreensWhereMainFunctionBeUsedMonitor',
            text: '主要功能为显示器的计算机显示器或屏幕'
          }),
        children: new GenerateEnum({
          ALL_COMPUTER_MONITOR: {
            value: '2.3.1',
            label:
              '2.3.1 ' +
              getLabelText({
                key: 'remote.enumerate.ScreensAndMonitors',
                text: '屏幕和显示器'
              })
          }
        })
      },
      OTHER_LARGE_SCREEN: {
        value: '2.4',
        label:
          '2.4 ' +
          getLabelText({
            key: 'remote.enumerate.otherEquipmentContainingScreensHavingSurfaceGreaterThan100cm',
            text: '其他屏幕面积大于100cm2的设备'
          }),
        children: new GenerateEnum({
          ALL_OTHER_LARGE_SCREEN: {
            value: '2.4.1',
            label:
              '2.4.1 ' +
              getLabelText({
                key: 'remote.enumerate.otherEquipmentContainingScreensHavingSurfaceGreaterThan100cm',
                text: '其他屏幕面积大于100cm2的设备'
              })
          }
        })
      }
    })
  },
  BULB: {
    value: '10088',
    label:
      '3.' +
      getLabelText({
        key: 'remote.common.lightingEquipment2',
        text: '灯类'
      }),
    children: new GenerateEnum({
      GAS_DISCHARGE: {
        value: '3.1',
        label:
          '3.1 ' +
          getLabelText({
            key: 'remote.enumerate.gasDischargeLamps',
            text: '气体放电灯'
          }),
        children: new GenerateEnum({
          ALL_FLUORESCENT: {
            value: '3.1.1',
            label:
              '3.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.allFluorescentLamps',
                text: '所有荧光灯'
              })
          },
          HIGH_LOW_PRESSURE: {
            value: '3.1.2',
            label:
              '3.1.2 ' +
              getLabelText({
                key: 'remote.enumerate.highAndLowPressureGasDisLamps',
                text: '高低压气体放电灯，包括压力钠灯和金属卤化物灯'
              })
          },
          COMPACT_FLUORESCENT: {
            value: '3.1.3',
            label:
              '3.1.3 ' +
              getLabelText({
                key: 'remote.enumerate.allCompactFluorescentLampsPLSANDCFLs',
                text: '所有紧凑型荧光灯(PLS和CFLs)'
              })
          }
        })
      },
      LED: {
        value: '3.2',
        label:
          '3.2 ' +
          getLabelText({
            key: 'remote.enumerate.ledLamps',
            text: 'LED灯'
          }),
        children: new GenerateEnum({
          LED_LAMP: {
            value: '3.2.1',
            label:
              '3.2.1 ' +
              getLabelText({
                key: 'remote.enumerate.ledLamps',
                text: 'LED灯'
              })
          }
        })
      }
    })
  },
  LARGE_DEVICE: {
    value: '10089',
    label:
      '4. ' +
      getLabelText({
        key: 'remote.enumerate.largeEquipmentAnyExternalDimensionMoreThan50',
        text: '大型设备（任何外部尺寸超过50厘米）'
      }),
    children: new GenerateEnum({
      LARGE_HOUSEHOLD_APPLIANCES: {
        value: '4.1',
        label:
          '4.1 ' +
          getLabelText({
            key: 'remote.enumerate.largeAppliances',
            text: '大型家电'
          }),
        children: new GenerateEnum({
          WASHING_MACHINE: {
            value: '4.1.1',
            label:
              '4.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.machinesWasherDryerDishWashingMachine',
                text: '洗衣机、洗衣烘干机、干衣机、洗碗机'
              })
          },
          COOKING_EQUIPMENT: {
            value: '4.1.2',
            label:
              '4.1.2 ' +
              getLabelText({
                key: 'remote.enumerate.gasCookerWithElectronicOtherProcessingOfFood',
                text: '组合烤箱、烤箱、带电子/电气元件的燃气灶、独立式槽，嵌入式和台式烹饪用具，用于烹饪和其他食品加工的其他大型器具'
              })
          },
          OTHER_LARGE_APPLIANCES: {
            value: '4.1.3',
            label:
              '4.1.3 ' +
              getLabelText({
                key: 'remote.enumerate.otherLargeAppliancesEgSunbed',
                text: '其他大型电器，例如日光浴床'
              })
          }
        })
      },
      DATA_PROCESSING_EQUIPMENT: {
        value: '4.2',
        label:
          '4.2 ' +
          getLabelText({
            key: 'remote.enumerate.dataProcessingPrintingAndCopyingEquipment',
            text: '集中数据处理、打印和复印设备'
          }),
        children: new GenerateEnum({
          DATA_PRINT_COPY: {
            value: '4.2.1',
            label:
              '4.2.1 ' +
              getLabelText({
                key: 'remote.enumerate.dataProcessingPrintingAndCopyingEquipment',
                text: '集中数据处理、打印和复印设备'
              })
          }
        })
      },
      OTHER_LARGE_EQUIPMENT: {
        value: '4.3',
        label:
          '4.3 ' +
          getLabelText({
            key: 'remote.enumerate.otherLargeEquipment',
            text: '其他大型设备'
          }),
        children: new GenerateEnum({
          OTHER_LARGE: {
            value: '4.3.1',
            label:
              '4.3.1 ' +
              getLabelText({
                key: 'remote.enumerate.otherLargeEquipment',
                text: '其他大型设备'
              })
          }
        })
      },
      PHOTOVOLTAIC_PANELS: {
        value: '4.4',
        label:
          '4.4 ' +
          getLabelText({
            key: 'remote.enumerate.largePhotovoltaicPanels',
            text: '大型光伏电池板'
          }),
        children: new GenerateEnum({
          LARGE_PHOTOVOLTAIC: {
            value: '4.4.1',
            label:
              '4.4.1 ' +
              getLabelText({
                key: 'remote.enumerate.largePhotovoltaicPanels2',
                text: '大型光伏板'
              })
          }
        })
      },
      LED_LIGHTING: {
        value: '4.5',
        label:
          '4.5 ' +
          getLabelText({
            key: 'remote.enumerate.largeLEDLightingEquipmentControllingLuminaires',
            text: '用于传播或控制光的大型 LED 照明设备，包括家用灯具'
          }),
        children: new GenerateEnum({
          LARGE_LED_LIGHTS: {
            value: '4.5.1',
            label:
              '4.5.1 ' +
              getLabelText({
                key: 'remote.enumerate.largeLEDLuminaire',
                text: '大型LED灯具'
              })
          }
        })
      },
      OTHER_LIGHTING: {
        value: '4.6',
        label:
          '4.6 ' +
          getLabelText({
            key: 'remote.enumerate.otherLargeLuminaireLightingEquipment',
            text: '其他大型灯具及照明设备'
          }),
        children: new GenerateEnum({
          OTHER_LARGE_LIGHTS: {
            value: '4.6.1',
            label:
              '4.6.1 ' +
              getLabelText({
                key: 'remote.enumerate.otherLargeLuminaireLightingEquipment',
                text: '其他大型灯具及照明设备'
              })
          }
        })
      },
      ELECTRICAL_TOOLS: {
        value: '4.7',
        label:
          '4.7 ' +
          getLabelText({
            key: 'remote.enumerate.largeElectricalAndElectronicTools',
            text: '大型电气和电子工具'
          }),
        children: new GenerateEnum({
          LARGE_ELECTRICAL_TOOLS: {
            value: '4.7.1',
            label:
              '4.7.1 ' +
              getLabelText({
                key: 'remote.enumerate.largeElectricalAndElectronicTools',
                text: '大型电气电子工具'
              })
          }
        })
      },
      MEDICAL_EQUIPMENT: {
        value: '4.8',
        label:
          '4.8 ' +
          getLabelText({
            key: 'remote.enumerate.largeMedicalDevices',
            text: '大型医疗器械'
          }),
        children: new GenerateEnum({
          LARGE_MEDICAL: {
            value: '4.8.1',
            label:
              '4.8.1 ' +
              getLabelText({
                key: 'remote.enumerate.largeMedicalDevices',
                text: '大型医疗器械'
              })
          }
        })
      },
      MONITORING_EQUIPMENT: {
        value: '4.9',
        label:
          '4.9 ' +
          getLabelText({
            key: 'remote.enumerate.monitoringControlEquipmentOtherThanSmokeDetectors',
            text: '除烟雾探测器以外的监控设备'
          }),
        children: new GenerateEnum({
          NON_SMOKE_MONITORS: {
            value: '4.9.1',
            label:
              '4.9.1 ' +
              getLabelText({
                key: 'remote.enumerate.monitoringControlEquipmentOtherThanSmokeDetectors',
                text: '除烟雾探测器以外的监控设备'
              })
          }
        })
      },
      AUTOMATIC_DISPENSERS: {
        value: '4.10',
        label:
          '4.10 ' +
          getLabelText({
            key: 'remote.enumerate.automaticDispensers',
            text: '自动分配器'
          }),
        children: new GenerateEnum({
          DISPENSER_EQUIPMENT: {
            value: '4.10.1',
            label:
              '4.10.1 ' +
              getLabelText({
                key: 'remote.enumerate.automaticDispensers',
                text: '自动分配器'
              })
          }
        })
      },
      OTHER_LARGE: {
        value: '4.11',
        label:
          '4.11 ' +
          getLabelText({
            key: 'remote.enumerate.otherLargeAppliances',
            text: '其他大型电器'
          }),
        children: new GenerateEnum({
          DISPENSER_EQUIPMENT: {
            value: '4.11.1',
            label:
              '4.11.1 ' +
              getLabelText({
                key: 'remote.enumerate.otherLargeAppliances',
                text: '其他大型电器'
              })
          }
        })
      },
      MOBILITY_AIDS: {
        value: '4.12',
        label:
          '4.12 ' +
          getLabelText({
            key: 'remote.enumerate.mobilityAidsEquipment',
            text: '行动辅助设备'
          }),
        children: new GenerateEnum({
          MOBILITY_EQUIPMENT: {
            value: '4.12.1',
            label:
              '4.12.1 ' +
              getLabelText({
                key: 'remote.enumerate.mobilityAidsEquipment2',
                text: '行动辅助器具及设备'
              })
          }
        })
      },
      TOYS_SPORTS: {
        value: '4.13',
        label:
          '4.13 ' +
          getLabelText({
            key: 'remote.enumerate.largeToysLeisureSportsEquipment',
            text: '大型玩具、休闲及运动设备'
          }),
        children: new GenerateEnum({
          LARGE_TOYS_SPORTS: {
            value: '4.13.1',
            label:
              '4.13.1 ' +
              getLabelText({
                key: 'remote.enumerate.largeToysLeisureSportsEquipment',
                text: '大型玩具、休闲及运动设备'
              })
          }
        })
      }
    })
  },
  SMALL_DEVICE: {
    value: '10090',
    label:
      '5.' +
      getLabelText({
        key: 'remote.enumerate.smallEquipmentAnyExternalDimensionMoreThan50',
        text: '小型设备（外部尺寸不超过50厘米）'
      }),
    children: new GenerateEnum({
      SMALL_HOUSEHOLD: {
        value: '5.1',
        label:
          '5.1 ' +
          getLabelText({
            key: 'remote.enumerate.smallHouseholdEquipment',
            text: '小型家用设备'
          }),
        children: new GenerateEnum({
          SMALL_HOUSEHOLD_SUB: {
            value: '5.1.1',
            label:
              '5.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.smallHouseholdEquipment',
                text: '小型家用设备'
              })
          }
        })
      },
      SMALL_CONSUMER: {
        value: '5.2',
        label:
          '5.2 ' +
          getLabelText({
            key: 'remote.enumerate.smallConsumerEquipment',
            text: '小型消费设备'
          }),
        children: new GenerateEnum({
          SMALL_CONSUMER_SUB: {
            value: '5.2.1',
            label:
              '5.2.1 ' +
              getLabelText({
                key: 'remote.enumerate.smallConsumerEquipment',
                text: '小型消费设备'
              })
          }
        })
      },
      PHOTOVOLTAIC: {
        value: '5.3',
        label:
          '5.3 ' +
          getLabelText({
            key: 'remote.enumerate.photovoltaicPanels',
            text: '光伏板'
          }),
        children: new GenerateEnum({
          PHOTOVOLTAIC_SUB: {
            value: '5.3.1',
            label:
              '5.3.1 ' +
              getLabelText({
                key: 'remote.enumerate.photovoltaicPanels',
                text: '光伏板'
              })
          }
        })
      },
      GAME_EQUIPMENT: {
        value: '5.4',
        label:
          '5.4 ' +
          getLabelText({
            key: 'remote.enumerate.gamingEquipment',
            text: '游戏设备'
          }),
        children: new GenerateEnum({
          GAME_EQUIPMENT_SUB: {
            value: '5.4.1',
            label:
              '5.4.1 ' +
              getLabelText({
                key: 'remote.enumerate.gamingEquipment',
                text: '游戏设备'
              })
          }
        })
      },
      SMALL_LED_LIGHTING: {
        value: '5.5',
        label:
          '5.5 ' +
          getLabelText({
            key: 'remote.enumerate.smallledLightPurposeSpreading',
            text: '用于传播或控制光线的小型 LED 照明设备，包括小型家用灯具、手电筒和自行车灯'
          }),
        children: new GenerateEnum({
          SMALL_LED_LIGHTING_SUB: {
            value: '5.5.1',
            label:
              '5.5.1 ' +
              getLabelText({
                key: 'remote.enumerate.smallLEDLuminaire',
                text: '小型LED灯具'
              })
          }
        })
      },
      OTHER_SMALL_LIGHTING: {
        value: '5.6',
        label:
          '5.6 ' +
          getLabelText({
            key: 'remote.enumerate.otheSmallLuminairesAndLightingEquipment',
            text: '其他小型灯具和照明设备'
          }),
        children: new GenerateEnum({
          OTHER_SMALL_LIGHTING_SUB: {
            value: '5.6.1',
            label:
              '5.6.1 ' +
              getLabelText({
                key: 'remote.enumerate.otheSmallLuminairesAndLightingEquipment',
                text: '其他小型灯具和照明设备'
              })
          }
        })
      },
      SMALL_ELECTRICAL_TOOLS: {
        value: '5.7',
        label:
          '5.7 ' +
          getLabelText({
            key: 'remote.enumerate.smallElectricalAndElectronicTools',
            text: '小型电气和电子工具'
          }),
        children: new GenerateEnum({
          SMALL_ELECTRICAL_TOOLS_SUB: {
            value: '5.7.1',
            label:
              '5.7.1 ' +
              getLabelText({
                key: 'remote.enumerate.smallElectricalAndElectronicTools',
                text: '小型电气和电子工具'
              })
          }
        })
      },
      SMALL_TOYS_SPORTS: {
        value: '5.8',
        label:
          '5.8 ' +
          getLabelText({
            key: 'remote.enumerate.smallToysLeisureSportsEquipment',
            text: '小型玩具休闲运动设备'
          }),
        children: new GenerateEnum({
          SMALL_TOYS_SPORTS_SUB: {
            value: '5.8.1',
            label:
              '5.8.1 ' +
              getLabelText({
                key: 'remote.enumerate.smallToysLeisureSportsEquipment2',
                text: '小型玩具、休闲及运动设备'
              })
          }
        })
      },
      SMALL_MEDICAL: {
        value: '5.9',
        label:
          '5.9 ' +
          getLabelText({
            key: 'remote.enumerate.smallMedicalDevices',
            text: '小型医疗设备'
          }),
        children: new GenerateEnum({
          SMALL_MEDICAL_SUB: {
            value: '5.9.1',
            label:
              '5.9.1 ' +
              getLabelText({
                key: 'remote.enumerate.smallMedicalDevices',
                text: '小型医疗设备'
              })
          }
        })
      },
      SMOKE_DETECTOR_WITH_IONIZATION: {
        value: '5.10',
        label:
          '5.10 ' +
          getLabelText({
            key: 'remote.enumerate.smokeDetectorsWithLonisationChamber',
            text: '带电离室的烟雾探测器'
          }),
        children: new GenerateEnum({
          SMOKE_DETECTOR_WITH_IONIZATION_SUB: {
            value: '5.10.1',
            label:
              '5.10.1 ' +
              getLabelText({
                key: 'remote.enumerate.smokeDetectorsWithLonisationChamber',
                text: '带电离室的烟雾探测器'
              })
          }
        })
      },
      SMOKE_DETECTOR_WITHOUT_IONIZATION: {
        value: '5.11',
        label:
          '5.11 ' +
          getLabelText({
            key: 'remote.enumerate.detectorsWithoutLonisationChamber',
            text: '不带电离室的探测器'
          }),
        children: new GenerateEnum({
          SMOKE_DETECTOR_WITHOUT_IONIZATION_SUB: {
            value: '5.11.1',
            label:
              '5.11.1 ' +
              getLabelText({
                key: 'remote.enumerate.detectorsWithoutLonisationChamber',
                text: '不带电离室的探测器'
              })
          }
        })
      },
      OTHER_MONITORING: {
        value: '5.12',
        label:
          '5.12 ' +
          getLabelText({
            key: 'remote.enumerate.monitoringControlEquipmentOtherSmokeDetectors',
            text: '除烟雾探测器以外的监控设备'
          }),
        children: new GenerateEnum({
          OTHER_MONITORING_SUB: {
            value: '5.12.1',
            label:
              '5.12.1 ' +
              getLabelText({
                key: 'remote.enumerate.monitoringControlEquipmentOtherSmokeDetectors',
                text: '除烟雾探测器以外的监控设备'
              })
          }
        })
      },
      OTHER_SMALL_APPLIANCES: {
        value: '5.13',
        label:
          '5.13 ' +
          getLabelText({
            key: 'remote.enumerate.allOtherSmallAppliances',
            text: '所有其他小型电器'
          }),
        children: new GenerateEnum({
          OTHER_SMALL_APPLIANCES_SUB: {
            value: '5.13.1',
            label:
              '5.13.1 ' +
              getLabelText({
                key: 'remote.enumerate.allOtherSmallAppliances',
                text: '所有其他小型电器'
              })
          }
        })
      },
      E_CIGARETTES: {
        value: '5.14',
        label:
          '5.14 ' +
          getLabelText({
            key: 'remote.enumerate.vapesECigarettes',
            text: '电子烟'
          }),
        children: new GenerateEnum({
          NON_RECHARGEABLE_E_CIGARETTES: {
            value: '5.14.1',
            label:
              '5.14.1 ' +
              getLabelText({
                key: 'remote.enumerate.vapesECigarettesNonRechargable',
                text: '不可充电电子烟'
              })
          },
          RECHARGEABLE_E_CIGARETTES: {
            value: '5.14.2',
            label:
              '5.14.2 ' +
              getLabelText({
                key: 'remote.enumerate.vapesECigarettesRechargeable',
                text: '可充电电子烟'
              })
          }
        })
      }
    })
  },
  SMALL_IT_TELECOM: {
    value: '10091',
    label:
      '6.' +
      getLabelText({
        key: 'remote.enumerate.smallITTelEquipmentNoExternalDimensionMoreThan50cm',
        text: '小型IT及电信设备（外部尺寸不超过50厘米）'
      }),
    children: new GenerateEnum({
      PERSONAL_COMPUTER: {
        value: '6.1',
        label:
          '6.1 ' +
          getLabelText({
            key: 'remote.enumerate.personalComputing',
            text: '个人电脑'
          }),
        children: new GenerateEnum({
          PERSONAL_COMPUTER_SUB: {
            value: '6.1.1',
            label:
              '6.1.1 ' +
              getLabelText({
                key: 'remote.enumerate.personalComputing',
                text: '个人电脑'
              })
          }
        })
      },
      PRINT_COPY_EQUIPMENT: {
        value: '6.2',
        label:
          '6.2 ' +
          getLabelText({
            key: 'remote.enumerate.printingAndCopyingEquipment',
            text: '打印和复印设备'
          }),
        children: new GenerateEnum({
          PRINT_COPY_EQUIPMENT_SUB: {
            value: '6.2.1',
            label:
              '6.2.1 ' +
              getLabelText({
                key: 'remote.enumerate.printingAndCopyingEquipment',
                text: '打印和复印设备'
              })
          }
        })
      },
      PRINTER_CARTRIDGE: {
        value: '6.3',
        label:
          '6.3 ' +
          getLabelText({
            key: 'remote.enumerate.electronicPrinterCartridges',
            text: '电子打印机墨盒'
          }),
        children: new GenerateEnum({
          PRINTER_CARTRIDGE_SUB: {
            value: '6.3.1',
            label:
              '6.3.1 ' +
              getLabelText({
                key: 'remote.enumerate.electronicPrinterCartridges',
                text: '电子打印机墨盒'
              })
          }
        })
      },
      USER_TERMINAL_SYSTEM: {
        value: '6.4',
        label:
          '6.4 ' +
          getLabelText({
            key: 'remote.enumerate.userTerminalsAndSystems',
            text: '用户终端和系统'
          }),
        children: new GenerateEnum({
          USER_TERMINAL_SYSTEM_SUB: {
            value: '6.4.1',
            label:
              '6.4.1 ' +
              getLabelText({
                key: 'remote.enumerate.userTerminalsAndSystems',
                text: '用户终端和系统'
              })
          }
        })
      },
      OTHER_IT_TELECOM: {
        value: '6.5',
        label:
          '6.5 ' +
          getLabelText({
            key: 'remote.enumerate.allOtherITTelecommunicationEquipment',
            text: '所有其他IT和电信设备'
          }),
        children: new GenerateEnum({
          OTHER_IT_TELECOM_SUB: {
            value: '6.5.1',
            label:
              '6.5.1 ' +
              getLabelText({
                key: 'remote.enumerate.allOtherITTelecommunicationEquipment',
                text: '所有其他IT和电信设备'
              })
          }
        })
      }
    })
  }
})

/**
 * 荷兰包装法包材类型枚举
 */
const netherlandsPackageEnum = new GenerateEnum({
  GLASS: {
    value: '9101',
    label: '${"key": "1991386027975159808", "name": "玻璃"}'
  },
  PAPER_AND_CARDBOARD: {
    value: '9102',
    label: '${"key": "1991386027975159809", "name": "纸和纸板"}'
  },
  HARD_PLASTIC_PACKAGING: {
    value: '9103',
    label: '${"key": "1991386027975159810", "name": "硬塑料包装"}'
  },
  SOFT_PLASTIC_PACKAGING: {
    value: '9104',
    label: '${"key": "1991386027975159811", "name": "软塑料包装"}'
  },
  ALUMINUM: {
    value: '9105',
    label: '${"key": "1991386027975159812", "name": "铝"}'
  },
  OTHER_METALS: {
    value: '9106',
    label: '${"key": "1991386027975159813", "name": "其他金属"}'
  },
  WOOD: {
    value: '9107',
    label: '${"key": "1991386027975159814", "name": "木头"}'
  },
  OTHER_MATERIALS: {
    value: '9108',
    label: '${"key": "1991386027975159815", "name": "其他材料类型"}'
  },
  NETHERLANDS_DRINK_CARTONS: {
    value: '9109',
    label: '${"key": "1996758679580033024", "name": "饮料纸盒"}'
  },
  NETHERLANDS_REUSABLE_PACKAGING_SYSTEM_RATE: {
    value: '9110',
    label: '${"key": "1996758679580033025", "name": "可重复使用包装（仅限系统费率）"}'
  },
  NETHERLANDS_REUSABLE_DRINK_CUPS: {
    value: '9111',
    label: '${"key": "1996758679580033026", "name": "可重复使用的饮料杯"}'
  }
})

/**
 * 比利时包装法包材类型枚举
 */
const belgiumPackageEnum = new GenerateEnum({
  BELGIUM_GLASS: {
    value: '10001',
    label: '玻璃'
  },
  BELGIUM_PAPER_AND_CARDBOARD: {
    value: '10002',
    label: '纸板/纸类'
  },
  BELGIUM_STEEL: {
    value: '10003',
    label: '钢（≥ 50%）'
  },
  BELGIUM_ALUMINUM_GE_50UM: {
    value: '10004',
    label: '铝 ≥ 50μm（≥ 50% 铝）'
  },
  BELGIUM_ALUMINUM_LT_50UM: {
    value: '10005',
    label: '铝 < 50μm（≥ 50% 铝）'
  },
  BELGIUM_DRINK_CARTONS: {
    value: '10006',
    label: '饮料纸盒'
  },
  BELGIUM_CORK: {
    value: '10007',
    label: '软木'
  },
  BELGIUM_PET_CLEAR: {
    value: '10008',
    label: 'PET（聚对苯二甲酸乙二醇酯）– 透明无色的瓶子和容器'
  },
  BELGIUM_PET_BLUE: {
    value: '10009',
    label: 'PET – 透明蓝色的瓶子和容器'
  },
  BELGIUM_PET_OTHER_COLORS: {
    value: '10010',
    label: 'PET – 除无色和蓝色外的其他透明颜色瓶子和容器'
  },
  BELGIUM_PET_OPAQUE: {
    value: '10011',
    label: 'PET – 不透明的瓶子和容器'
  },
  BELGIUM_PET_SINGLE_HARD: {
    value: '10012',
    label: 'PET（单一材料）– 除瓶子和容器外的透明硬质包装'
  },
  BELGIUM_PET_MULTI_HARD: {
    value: '10013',
    label: 'PET（多种材料）– 除瓶子和容器外的透明硬质包装'
  },
  BELGIUM_PET_OPAQUE_HARD: {
    value: '10014',
    label: 'PET – 除瓶子和容器外的不透明硬质包装'
  },
  BELGIUM_PP_HARD: {
    value: '10015',
    label: 'PP（聚丙烯）– 瓶子、容器及其他硬质包装'
  },
  BELGIUM_PS_XPS_HARD: {
    value: '10016',
    label: 'PS 和 XPS（聚苯乙烯及挤塑聚苯乙烯）– 硬质包装，不包括 EPS（膨胀聚苯乙烯，泡沫塑料）'
  },
  BELGIUM_EPS: {
    value: '10017',
    label: 'EPS（膨胀聚苯乙烯，泡沫塑料）'
  },
  BELGIUM_PE_HARD: {
    value: '10018',
    label: 'PE（聚乙烯）– 瓶子、容器及其他硬质包装'
  },
  BELGIUM_PE_FILM: {
    value: '10019',
    label: 'PE – 薄膜'
  },
  BELGIUM_PP_FILM: {
    value: '10020',
    label: 'PP – 薄膜'
  },
  BELGIUM_OTHER_PLASTIC_FILM: {
    value: '10021',
    label: '其他塑料薄膜'
  },
  BELGIUM_COMPOSTABLE_BIODEGRADABLE: {
    value: '10022',
    label: '可堆肥和可生物降解的塑料包装'
  },
  BELGIUM_OTHER_PLASTIC: {
    value: '10023',
    label: '其他塑料包装（无论是否为复合材料）– 塑料为主要重量成分'
  },
  BELGIUM_COMPOSITE_PAPER: {
    value: '10024',
    label: '复合材料中纸板为主要重量成分的包装'
  },
  BELGIUM_WOOD: {
    value: '10025',
    label: '木材'
  },
  BELGIUM_OTHER_RECYCLABLE: {
    value: '10026',
    label: '其他可回收利用材料'
  },
  BELGIUM_COMPOSITE_GLASS: {
    value: '10027',
    label: '复合包装中玻璃为主要重量成分的包装'
  },
  BELGIUM_COMPOSITE_STEEL: {
    value: '10028',
    label: '复合包装中钢为主要重量成分的包装'
  },
  BELGIUM_CERAMICS: {
    value: '10029',
    label: '陶器、陶瓷、瓷器等'
  },
  BELGIUM_HHW: {
    value: '10030',
    label: '使用后必须作为家用有害垃圾（HHW）分类的家庭包装'
  }
})

// 荷兰电池法一级，售卖方式
const netherlandsBatteryTypeFirst = new GenerateEnum({
  SINGLE: {
    value: '1',
    label: '单一电池'
  },
  CONTAIN: {
    value: '2',
    label: '产品包含电池'
  }
})

// 荷兰电池法二级，产品大类
const netherlandsBatteryTypeSecond = new GenerateEnum({
  // ---------- 单一电池（SINGLE = 1） ----------
  INDUSTRIAL_RECHARGEABLE: {
    value: '1.1',
    label: '工业电池（可充电）'
  },
  INDUSTRIAL_NON_RECHARGEABLE: {
    value: '1.2',
    label: '工业电池（不可充电）'
  },
  PORTABLE_RECHARGEABLE: {
    value: '1.3',
    label: '便携式电池（可充电）'
  },
  PORTABLE_NON_RECHARGEABLE: {
    value: '1.4',
    label: '便携式电池（不可充电）'
  },

  // ---------- 产品包含电池（CONTAIN = 2） ----------
  INDUSTRIAL_RECHARGEABLE_CONTAIN: {
    value: '2.1',
    label: '工业电池（可充电）'
  },
  INDUSTRIAL_NON_RECHARGEABLE_CONTAIN: {
    value: '2.2',
    label: '工业电池（不可充电）'
  },
  PORTABLE_RECHARGEABLE_CONTAIN: {
    value: '2.3',
    label: '便携式电池（可充电）'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN: {
    value: '2.4',
    label: '便携式电池（不可充电）'
  }
})

// 荷兰电池法三级，产品小类
const netherlandsBatteryTypeThree = new GenerateEnum({
  // ---------- 单一电池 - 工业电池（可充电） ----------
  LEAD_ACID_1: {
    value: '1.1.1',
    label: '铅酸电池'
  },
  LITHIUM_ION_1: {
    value: '1.1.2',
    label: '锂离子电池'
  },
  LITHIUM_POLYMER_1: {
    value: '1.1.3',
    label: '锂聚合物电池'
  },
  NICKEL_CADMIUM_1: {
    value: '1.1.4',
    label: '镍镉电池'
  },
  NICKEL_METAL_HYDRIDE_1: {
    value: '1.1.5',
    label: '镍氢电池'
  },

  // ---------- 单一电池 - 工业电池（不可充电） ----------
  ALKALINE_MANGANESE_1: {
    value: '1.2.1',
    label: '碱性锰电池'
  },
  LITHIUM_THIONYL_CHLORIDE_1: {
    value: '1.2.2',
    label: '锂亚硫酰氯电池'
  },
  SILVER_OXIDE_1: {
    value: '1.2.3',
    label: '氧化银电池'
  },
  WATER_ACTIVATED_1: {
    value: '1.2.4',
    label: '水激活电池'
  },
  ZINC_AIR_1: {
    value: '1.2.5',
    label: '锌空气电池'
  },
  ZINC_CARBON_1: {
    value: '1.2.6',
    label: '锌碳电池'
  },
  LITHIUM_PORTABLE_3: { value: '1.2.7', label: '锂电池' },

  // ---------- 单一电池 - 便携式电池（可充电） ----------
  LEAD_ACID_PORTABLE_1: {
    value: '1.3.1',
    label: '铅酸电池'
  },
  LITHIUM_ION_PORTABLE_1: {
    value: '1.3.2',
    label: '锂离子电池'
  },
  LITHIUM_POLYMER_PORTABLE_1: {
    value: '1.3.3',
    label: '锂聚合物电池'
  },
  NICKEL_CADMIUM_PORTABLE_1: {
    value: '1.3.4',
    label: '镍镉电池'
  },
  NICKEL_METAL_HYDRIDE_PORTABLE_1: {
    value: '1.3.5',
    label: '镍氢电池'
  },

  // ---------- 单一电池 - 便携式电池（不可充电） ----------
  ALKALINE_MANGANESE_PORTABLE_1: {
    value: '1.4.1',
    label: '碱性锰电池'
  },
  LITHIUM_PORTABLE_1: {
    value: '1.4.2',
    label: '锂电池'
  },
  LITHIUM_THIONYL_CHLORIDE_PORTABLE_1: {
    value: '1.4.3',
    label: '锂亚硫酰氯电池'
  },
  SILVER_OXIDE_PORTABLE_1: {
    value: '1.4.4',
    label: '氧化银电池'
  },
  SIMPLE_BATTERY: {
    value: '1.4.5',
    label: '简易电池'
  },
  WATER_ACTIVATED_PORTABLE_1: {
    value: '1.4.6',
    label: '水激活电池'
  },
  ZINC_AIR_PORTABLE_1: {
    value: '1.4.7',
    label: '锌空气电池'
  },
  ZINC_CARBON_PORTABLE_1: {
    value: '1.4.8',
    label: '锌碳电池'
  },

  // ---------- 产品包含电池 - 工业电池（可充电） ----------
  LEAD_ACID_2: {
    value: '2.1.1',
    label: '铅酸电池'
  },
  LITHIUM_ION_2: {
    value: '2.1.2',
    label: '锂离子电池'
  },
  LITHIUM_POLYMER_2: {
    value: '2.1.3',
    label: '锂聚合物电池'
  },
  NICKEL_CADMIUM_2: {
    value: '2.1.4',
    label: '镍镉电池'
  },
  NICKEL_METAL_HYDRIDE_2: {
    value: '2.1.5',
    label: '镍氢电池'
  },

  // ---------- 产品包含电池 - 工业电池（不可充电） ----------
  ALKALINE_MANGANESE_2: {
    value: '2.2.1',
    label: '碱性锰电池'
  },
  UNKNOWN_CHEMISTRY: {
    value: '2.2.2',
    label: '化学类型未知'
  },
  LITHIUM_2: {
    value: '2.2.3',
    label: '锂电池'
  },
  LITHIUM_THIONYL_CHLORIDE_2: {
    value: '2.2.4',
    label: '锂亚硫酰氯电池'
  },
  SILVER_OXIDE_2: {
    value: '2.2.5',
    label: '氧化银电池'
  },
  WATER_ACTIVATED_2: {
    value: '2.2.6',
    label: '水激活电池'
  },
  ZINC_AIR_2: {
    value: '2.2.7',
    label: '锌空气电池'
  },
  ZINC_CARBON_2: {
    value: '2.2.8',
    label: '锌碳电池'
  },

  // ---------- 产品包含电池 - 便携式电池（可充电） ----------
  LEAD_ACID_PORTABLE_2: {
    value: '2.3.1',
    label: '铅酸电池'
  },
  LITHIUM_POLYMER_PORTABLE_2: {
    value: '2.3.2',
    label: '锂聚合物电池'
  },
  NICKEL_CADMIUM_PORTABLE_2: {
    value: '2.3.3',
    label: '镍镉电池'
  },
  NICKEL_METALHYDRIDE: { value: '2.3.4', label: '镍氢化物' },

  LITHIUM_ION_PORTABLE_2: { value: '2.3.5', label: '锂离子' },

  // ---------- 产品包含电池 - 便携式电池（不可充电） ----------
  ALKALINE_MANGANESE_PORTABLE_2: {
    value: '2.4.1',
    label: '碱性锰电池'
  },
  UNKNOWN_CHEMISTRY_PORTABLE_2: {
    value: '2.4.2',
    label: '化学类型未知'
  },
  LITHIUM_PORTABLE_2: {
    value: '2.4.3',
    label: '锂电池'
  },
  LITHIUM_THIONYL_CHLORIDE_PORTABLE_2: {
    value: '2.4.4',
    label: '锂亚硫酰氯电池'
  },
  SILVER_OXIDE_PORTABLE_2: {
    value: '2.4.5',
    label: '氧化银电池'
  },
  WATER_ACTIVATED_PORTABLE_2: {
    value: '2.4.6',
    label: '水激活电池'
  },
  EASY_BATTERY: {
    value: '2.4.7',
    label: '简易电池'
  },
  ZINC_AIR_PORTABLE_2: {
    value: '2.4.8',
    label: '锌空气电池'
  },
  ZINC_CARBON_PORTABLE_2: {
    value: '2.4.9',
    label: '锌碳电池'
  }
})

// 荷兰电池法四级，具体细类
const netherlandsBatteryTypeFour = new GenerateEnum({
  // ---------- 单一电池 - 工业电池（可充电） ----------
  LEAD_ACID_1: { value: '1.1.1.1', label: '铅酸电池' },
  LEAD_ACID_NON_AUTO_1: { value: '1.1.1.2', label: '非汽车推进动力' },

  LITHIUM_ION_EBIKE_1: { value: '1.1.2.1', label: '电动自行车' },
  LITHIUM_ION_STORAGE_1: { value: '1.1.2.2', label: '储能' },
  LITHIUM_ION_PACK_1: { value: '1.1.2.3', label: '电池组' },
  LITHIUM_ION_PAGER_1: { value: '1.1.2.4', label: '寻呼机' },
  LITHIUM_ION_NON_AUTO_1: { value: '1.1.2.5', label: '非汽车推进动力' },

  LITHIUM_POLYMER_BUTTON_1: { value: '1.1.3.1', label: '纽扣电池' },
  LITHIUM_POLYMER_EBIKE_1: { value: '1.1.3.2', label: '电动自行车' },
  LITHIUM_POLYMER_PACK_1: { value: '1.1.3.3', label: '电池组' },

  NICKEL_CADMIUM_PACK_1: { value: '1.1.4.1', label: '电池组' },
  NICKEL_CADMIUM_PAGER_1: { value: '1.1.4.2', label: '寻呼机' },
  NICKEL_CADMIUM_SINGLE_1: { value: '1.1.4.3', label: '单体电池' },
  NICKEL_CADMIUM_TOOL_1: { value: '1.1.4.4', label: '工具电池' },

  NICKEL_HYDRIDE_PACK_1: { value: '1.1.5.1', label: '电池组' },
  NICKEL_HYDRIDE_PAGER_1: { value: '1.1.5.2', label: '寻呼机' },
  NICKEL_HYDRIDE_NON_AUTO_1: { value: '1.1.5.3', label: '非汽车推进动力' },
  NICKEL_HYDRIDE_SINGLE_1: { value: '1.1.5.4', label: '单体电池' },

  // ---------- 单一电池 - 工业电池（不可充电） ----------
  ALKALINE_MANGANESE_FENCE_1: { value: '1.2.1.1', label: '碱性栅栏电池' },
  ALKALINE_MANGANESE_STORAGE_1: { value: '1.2.1.2', label: '储能' },
  ALKALINE_MANGANESE_PACK_1: { value: '1.2.1.3', label: '电池组' },

  LITHIUM_THIONYL_BUTTON_1: { value: '1.2.2.1', label: '纽扣电池' },
  LITHIUM_THIONYL_PACK_1: { value: '1.2.2.2', label: '电池组' },
  LITHIUM_THIONYL_SINGLE_1: { value: '1.2.2.3', label: '单体电池' },

  SILVER_OXIDE_PACK_1: { value: '1.2.3.1', label: '电池组' },
  WATER_ACTIVATED_PACK_1: { value: '1.2.4.1', label: '电池组' },

  ZINC_AIR_OTHER_1: { value: '1.2.5.1', label: '其他类型' },
  ZINC_AIR_MULTI_CELL_1: { value: '1.2.5.2', label: '多电芯电池' },
  ZINC_AIR_FENCE_1: { value: '1.2.5.3', label: '碱性栅栏电池' },

  ZINC_CARBON_STORAGE_1: { value: '1.2.6.1', label: '储能' },
  ZINC_CARBON_PACK_1: { value: '1.2.6.2', label: '电池组' },
  LITHIUM_PORTABLE_3_1: { value: '1.2.7.1', label: '纽扣电池' },
  LITHIUM_PORTABLE_3_2: { value: '1.2.7.2', label: '其他类型' },
  LITHIUM_PORTABLE_3_3: { value: '1.2.7.3', label: '电池组' },

  // ---------- 单一电池 - 便携式电池（可充电） - 第三级小类 ----------
  LEAD_ACID_PORTABLE_1_1: { value: '1.3.1.1', label: '铅酸电池' },

  LITHIUM_ION_PORTABLE_1_1: { value: '1.3.2.1', label: '纽扣电池' },
  LITHIUM_ION_PORTABLE_1_2: { value: '1.3.2.2', label: '其他类型' },
  LITHIUM_ION_PORTABLE_1_3: { value: '1.3.2.3', label: '通讯设备电池' },
  LITHIUM_ION_PORTABLE_1_4: { value: '1.3.2.4', label: '电池组' },
  LITHIUM_ION_PORTABLE_1_5: { value: '1.3.2.5', label: '单体电池' },
  LITHIUM_ION_PORTABLE_1_6: { value: '1.3.2.6', label: '工具电池' },
  LITHIUM_ION_PORTABLE_1_7: { value: '1.3.2.7', label: '摄像设备电池' },

  LITHIUM_POLYMER_PORTABLE_1_1: { value: '1.3.3.1', label: '纽扣电池' },
  LITHIUM_POLYMER_PORTABLE_1_2: { value: '1.3.3.2', label: '其他类型' },
  LITHIUM_POLYMER_PORTABLE_1_3: { value: '1.3.3.3', label: '通讯设备电池' },
  LITHIUM_POLYMER_PORTABLE_1_4: { value: '1.3.3.4', label: '电池组' },

  NICKEL_CADMIUM_PORTABLE_1_1: { value: '1.3.4.1', label: '纽扣电池' },
  NICKEL_CADMIUM_PORTABLE_1_2: { value: '1.3.4.2', label: '无线设备用' },
  NICKEL_CADMIUM_PORTABLE_1_3: { value: '1.3.4.3', label: '通讯设备电池' },
  NICKEL_CADMIUM_PORTABLE_1_4: { value: '1.3.4.4', label: '电池组' },
  NICKEL_CADMIUM_PORTABLE_1_5: { value: '1.3.4.5', label: '竞速模型电池' },
  NICKEL_CADMIUM_PORTABLE_1_6: { value: '1.3.4.6', label: '单体电池' },
  NICKEL_CADMIUM_PORTABLE_1_7: { value: '1.3.4.7', label: '工具电池' },
  NICKEL_CADMIUM_PORTABLE_1_8: { value: '1.3.4.8', label: '摄像设备电池' },

  NICKEL_METAL_HYDRIDE_PORTABLE_1_1: { value: '1.3.5.1', label: '纽扣电池' },
  NICKEL_METAL_HYDRIDE_PORTABLE_1_2: { value: '1.3.5.2', label: '电脑电池' },
  NICKEL_METAL_HYDRIDE_PORTABLE_1_3: {
    value: '1.3.5.3',
    label: '通讯设备电池'
  },
  NICKEL_METAL_HYDRIDE_PORTABLE_1_4: { value: '1.3.5.4', label: '单体电池' },
  NICKEL_METAL_HYDRIDE_PORTABLE_1_5: { value: '1.3.5.5', label: '工具电池' },
  NICKEL_METAL_HYDRIDE_PORTABLE_1_6: {
    value: '1.3.5.6',
    label: '摄像设备电池'
  },
  NICKEL_METAL_HYDRIDE_PORTABLE_1_7: {
    value: '1.3.5.7',
    label: '竞速模型电池'
  },

  // ---------- 单一电池 - 便携式电池（不可充电） - 第三级小类 ----------
  ALKALINE_MANGANESE_PORTABLE_1_1: { value: '1.4.1.1', label: '碱性电池' },
  ALKALINE_MANGANESE_PORTABLE_1_2: { value: '1.4.1.2', label: '多电芯电池' },
  ALKALINE_MANGANESE_PORTABLE_1_3: { value: '1.4.1.3', label: '电池组' },
  ALKALINE_MANGANESE_PORTABLE_1_4: { value: '1.4.1.4', label: '摄影器材电池' },
  ALKALINE_MANGANESE_PORTABLE_1_5: { value: '1.4.1.5', label: '纽扣电池' },

  LITHIUM_PORTABLE_1_1: { value: '1.4.2.1', label: '纽扣电池' },
  LITHIUM_PORTABLE_1_2: { value: '1.4.2.2', label: '多电芯电池' },
  LITHIUM_PORTABLE_1_3: { value: '1.4.2.3', label: '其他类型' },
  LITHIUM_PORTABLE_1_4: { value: '1.4.2.4', label: '其他圆柱形电池' },
  LITHIUM_PORTABLE_1_5: { value: '1.4.2.5', label: '电池组' },
  LITHIUM_PORTABLE_1_6: { value: '1.4.2.6', label: '摄影器材电池' },
  LITHIUM_PORTABLE_1_7: { value: '1.4.2.7', label: '单体电池' },

  LITHIUM_THIONYL_CHLORIDE_PORTABLE_1_1: {
    value: '1.4.3.1',
    label: '纽扣电池'
  },
  LITHIUM_THIONYL_CHLORIDE_PORTABLE_1_2: { value: '1.4.3.2', label: '电池组' },
  LITHIUM_THIONYL_CHLORIDE_PORTABLE_1_3: {
    value: '1.4.3.3',
    label: '单体电池'
  },

  SILVER_OXIDE_PORTABLE_1_1: { value: '1.4.4.1', label: '纽扣电池' },
  SILVER_OXIDE_PORTABLE_1_2: { value: '1.4.4.2', label: '电池组' },

  SIMPLE_BATTERY_1_1: { value: '1.4.5.1', label: '未设置 / 未分类' },

  WATER_ACTIVATED_PORTABLE_1_1: { value: '1.4.6.1', label: '其他类型' },
  WATER_ACTIVATED_PORTABLE_1_2: { value: '1.4.6.2', label: '电池组' },

  ZINC_AIR_PORTABLE_1_1: { value: '1.4.7.1', label: '碱性栅栏电池' },
  ZINC_AIR_PORTABLE_1_2: { value: '1.4.7.2', label: '纽扣电池' },
  ZINC_AIR_PORTABLE_1_3: { value: '1.4.7.3', label: '其他类型' },

  ZINC_CARBON_PORTABLE_1_1: { value: '1.4.8.1', label: '纽扣电池' },
  ZINC_CARBON_PORTABLE_1_2: { value: '1.4.8.2', label: '其他类型' },
  ZINC_CARBON_PORTABLE_1_3: { value: '1.4.8.3', label: '单体电池' },
  ZINC_CARBON_PORTABLE_1_4: { value: '1.4.8.4', label: '超级电池' },

  // ---------- 产品包含电池 - 工业电池（可充电） - 第三级小类 ----------
  LEAD_ACID_2_1: { value: '2.1.1.1', label: '铅酸电池' },
  LEAD_ACID_2_2: { value: '2.1.1.2', label: '非汽车推进动力' },

  LITHIUM_ION_2_1: { value: '2.1.2.1', label: '电动自行车' },
  LITHIUM_ION_2_2: { value: '2.1.2.2', label: '储能' },
  LITHIUM_ION_2_3: { value: '2.1.2.3', label: '电池组' },
  LITHIUM_ION_2_4: { value: '2.1.2.4', label: '寻呼机' },
  LITHIUM_ION_2_5: { value: '2.1.2.5', label: '非汽车推进动力' },

  LITHIUM_POLYMER_2_1: { value: '2.1.3.1', label: '纽扣电池' },
  LITHIUM_POLYMER_2_2: { value: '2.1.3.2', label: '电动自行车' },
  LITHIUM_POLYMER_2_3: { value: '2.1.3.3', label: '电池组' },

  NICKEL_CADMIUM_2_1: { value: '2.1.4.1', label: '电池组' },
  NICKEL_CADMIUM_2_2: { value: '2.1.4.2', label: '寻呼机' },
  NICKEL_CADMIUM_2_3: { value: '2.1.4.3', label: '单体电池' },
  NICKEL_CADMIUM_2_4: { value: '2.1.4.4', label: '工具电池' },

  NICKEL_METAL_HYDRIDE_2_1: { value: '2.1.5.1', label: '电池组' },
  NICKEL_METAL_HYDRIDE_2_2: { value: '2.1.5.2', label: '寻呼机' },
  NICKEL_METAL_HYDRIDE_2_3: { value: '2.1.5.3', label: '非汽车推进动力' },
  NICKEL_METAL_HYDRIDE_2_4: { value: '2.1.5.4', label: '单体电池' },

  // ---------- 产品包含电池 - 工业电池（不可充电） - 第三级小类 ----------
  ALKALINE_MANGANESE_2_1: { value: '2.2.1.1', label: '碱性栅栏电池' },
  ALKALINE_MANGANESE_2_2: { value: '2.2.1.2', label: '储能' },
  ALKALINE_MANGANESE_2_3: { value: '2.2.1.3', label: '电池组' },

  UNKNOWN_CHEMISTRY_2_1: { value: '2.2.2.1', label: '纽扣电池' },

  LITHIUM_2_1: { value: '2.2.3.1', label: '纽扣电池' },
  LITHIUM_2_2: { value: '2.2.3.2', label: '其他类型' },
  LITHIUM_2_3: { value: '2.2.3.3', label: '电池组' },

  LITHIUM_THIONYL_CHLORIDE_2_1: { value: '2.2.4.1', label: '纽扣电池' },
  LITHIUM_THIONYL_CHLORIDE_2_2: { value: '2.2.4.2', label: '电池组' },
  LITHIUM_THIONYL_CHLORIDE_2_3: { value: '2.2.4.3', label: '单体电池' },

  SILVER_OXIDE_2_1: { value: '2.2.5.1', label: '电池组' },

  WATER_ACTIVATED_2_1: { value: '2.2.6.1', label: '电池组' },

  ZINC_AIR_2_1: { value: '2.2.7.1', label: '其他类型' },
  ZINC_AIR_2_2: { value: '2.2.7.2', label: '多电芯电池' },
  ZINC_AIR_2_3: { value: '2.2.7.3', label: '碱性栅栏电池' },

  ZINC_CARBON_2_1: { value: '2.2.8.1', label: '电池组' },

  // ---------- 产品包含电池 - 便携式电池（可充电） ----------
  LEAD_ACID_PORTABLE_BATTERY_1: { value: '2.3.1.1', label: '铅酸电池' },

  LITHIUM_POLYMER_PORTABLE_BUTTON: { value: '2.3.2.1', label: '纽扣电池' },
  LITHIUM_POLYMER_PORTABLE_OTHER: { value: '2.3.2.2', label: '其他类型' },
  LITHIUM_POLYMER_PORTABLE_COMM: { value: '2.3.2.3', label: '通讯设备电池' },
  LITHIUM_POLYMER_PORTABLE_PACK: { value: '2.3.2.4', label: '电池组' },

  NICKEL_CADMIUM_PORTABLE_BUTTON: { value: '2.3.3.1', label: '纽扣电池' },
  NICKEL_CADMIUM_PORTABLE_WIRELESS: { value: '2.3.3.2', label: '无线设备用' },
  NICKEL_CADMIUM_PORTABLE_COMM: { value: '2.3.3.3', label: '通讯设备电池' },
  NICKEL_CADMIUM_PORTABLE_PACK: { value: '2.3.3.4', label: '电池组' },
  NICKEL_CADMIUM_PORTABLE_RACE: { value: '2.3.3.5', label: '竞速模型电池' },
  NICKEL_CADMIUM_PORTABLE_SINGLE: { value: '2.3.3.6', label: '单体电池' },
  NICKEL_CADMIUM_PORTABLE_TOOL: { value: '2.3.3.7', label: '工具电池' },
  NICKEL_CADMIUM_PORTABLE_CAMERA: { value: '2.3.3.8', label: '摄像设备电池' },

  NICKEL_METALHYDRIDE_BUTTON: { value: '2.3.4.1', label: '纽扣电池' },
  NICKEL_METALHYDRIDE_COMPUTER: { value: '2.3.4.2', label: '电脑电池' },
  NICKEL_METALHYDRIDE_GSM: { value: '2.3.4.3', label: '通讯设备电池' },
  NICKEL_METALHYDRIDE_PACKS: { value: '2.3.4.4', label: '电池组' },
  NICKEL_METALHYDRIDE_SINGLE: { value: '2.3.4.5', label: '单体电池' },
  NICKEL_METALHYDRIDE_TOOLS: { value: '2.3.4.6', label: '工具电池' },
  NICKEL_METALHYDRIDE_VIDEO: { value: '2.3.4.7', label: '摄像设备电池' },

  IUM_ION_PORTABLE_BUTTON: { value: '2.3.5.1', label: '纽扣电池' },
  LITHIUM_ION_PORTABLE_OTHER: { value: '2.3.5.2', label: '其他类型' },
  LITHIUM_ION_PORTABLE_COMM: { value: '2.3.5.3', label: '通讯设备电池' },
  LITHIUM_ION_PORTABLE_PACK: { value: '2.3.5.4', label: '电池组' },
  LITHIUM_ION_PORTABLE_SINGLE: { value: '2.3.5.5', label: '单体电池' },
  LITHIUM_ION_PORTABLE_TOOL: { value: '2.3.5.6', label: '工具电池' },
  LITHIUM_ION_PORTABLE_CAMERA: { value: '2.3.5.7', label: '摄像设备电池' },

  // ---------- 产品包含电池 - 便携式电池（不可充电） ----------
  ALKALINE_MANGANESE_PORTABLE_ALKALINE: { value: '2.4.1.1', label: '碱性电池' },
  ALKALINE_MANGANESE_PORTABLE_BUTTON: { value: '2.4.1.2', label: '纽扣电池' },
  ALKALINE_MANGANESE_PORTABLE_MULTI: { value: '2.4.1.3', label: '多电芯电池' },
  ALKALINE_MANGANESE_PORTABLE_PACK: { value: '2.4.1.4', label: '电池组' },
  ALKALINE_MANGANESE_PORTABLE_PHOTO: {
    value: '2.4.1.5',
    label: '摄影器材电池'
  },

  UNKNOWN_CHEMISTRY_PORTABLE_BUTTON: { value: '2.4.2.1', label: '纽扣电池' },

  LITHIUM_PORTABLE_BUTTON: { value: '2.4.3.1', label: '纽扣电池' },
  LITHIUM_PORTABLE_MULTI: { value: '2.4.3.2', label: '多电芯电池' },
  LITHIUM_PORTABLE_OTHER: { value: '2.4.3.3', label: '其他类型' },
  LITHIUM_PORTABLE_CYLINDRICAL: { value: '2.4.3.4', label: '其他圆柱形电池' },
  LITHIUM_PORTABLE_PACK: { value: '2.4.3.5', label: '电池组' },
  LITHIUM_PORTABLE_PHOTO: { value: '2.4.3.6', label: '摄影器材电池' },
  LITHIUM_PORTABLE_SINGLE: { value: '2.4.3.7', label: '单体电池' },

  LITHIUM_THIONYL_CHLORIDE_PORTABLE_BUTTON: {
    value: '2.4.4.1',
    label: '纽扣电池'
  },
  LITHIUM_THIONYL_CHLORIDE_PORTABLE_PACK: { value: '2.4.4.2', label: '电池组' },
  LITHIUM_THIONYL_CHLORIDE_PORTABLE_SINGLE: {
    value: '2.4.4.3',
    label: '单体电池'
  },

  SILVER_OXIDE_PORTABLE_BUTTON: { value: '2.4.5.1', label: '纽扣电池' },
  SILVER_OXIDE_PORTABLE_PACK: { value: '2.4.5.2', label: '电池组' },

  EASY_BATTERY_UNSET: { value: '2.4.7.1', label: '未设置 / 未分类' },

  WATER_ACTIVATED_PORTABLE_OTHER: { value: '2.4.6.1', label: '其他类型' },
  WATER_ACTIVATED_PORTABLE_PACK: { value: '2.4.6.2', label: '电池组' },

  ZINC_AIR_PORTABLE_ALKALINE: { value: '2.4.8.1', label: '碱性栅栏电池' },
  ZINC_AIR_PORTABLE_BUTTON: { value: '2.4.8.2', label: '纽扣电池' },
  ZINC_AIR_PORTABLE_OTHER: { value: '2.4.8.3', label: '其他类型' },

  ZINC_CARBON_PORTABLE_BUTTON: { value: '2.4.9.1', label: '纽扣电池' },
  ZINC_CARBON_PORTABLE_OTHER: { value: '2.4.9.2', label: '其他类型' },
  ZINC_CARBON_PORTABLE_SINGLE: { value: '2.4.9.3', label: '单体电池' },
  ZINC_CARBON_PORTABLE_SUPER: { value: '2.4.9.4', label: '超级电池' }
})

const threeTree = generateTreeByTwoArr(netherlandsBatteryTypeThree.enumArray, netherlandsBatteryTypeFour.enumArray)
const secondTree = generateTreeByTwoArr(netherlandsBatteryTypeSecond.enumArray, threeTree)
// 荷兰电池法，树结构
const netherlandsBatteryTypeTree = generateTreeByTwoArr(netherlandsBatteryTypeFirst.enumArray, secondTree)

// 比利时电池法一级，售卖方式
const belgiumBatteryTypeFirst = new GenerateEnum({
  SINGLE: {
    value: '1',
    label: '单一电池'
  },
  CONTAIN: {
    value: '2',
    label: '产品包含电池'
  }
})

// 比利时电池法二级，产品大类
const belgiumBatteryTypeSecond = new GenerateEnum({
  // ---------- 单一电池（SINGLE = 1） ----------,
  PORTABLE_RECHARGEABLE: {
    value: '1.1',
    label: '便携式电池（可充电）'
  },
  PORTABLE_NON_RECHARGEABLE: {
    value: '1.2',
    label: '便携式电池（不可充电）'
  },
  EV_LARGE_RECHARGEABLE: {
    value: '1.3',
    label: '大型电动车（可充电）'
  },
  ENERGY_STORAGE: {
    value: '1.4',
    label: '储能系统电池'
  },
  INDUSTRIAL_RECHARGEABLE: {
    value: '1.5',
    label: '工业电池（可充电）'
  },
  INDUSTRIAL_NON_RECHARGEABLE: {
    value: '1.6',
    label: '工业电池（不可充电）'
  },
  LMT_RECHARGEABLE: {
    value: '1.7',
    label: '轻型交通运输工具（可充电）'
  },
  SLI_RECHARGEABLE: {
    value: '1.8',
    label: '启动，照明，点火电池（可充电）'
  },
  PORTABLE_RECHARGEABLE_CONTAIN: {
    value: '2.1',
    label: '便携式电池（可充电）'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN: {
    value: '2.2',
    label: '便携式电池（不可充电）'
  },
  EV_LARGE_RECHARGEABLE_CONTAIN: {
    value: '2.3',
    label: '大型电动车（可充电）'
  },
  ENERGY_STORAGE_CONTAIN: {
    value: '2.4',
    label: '储能系统电池'
  },
  INDUSTRIAL_RECHARGEABLE_CONTAIN: {
    value: '2.5',
    label: '工业电池（可充电）'
  },
  INDUSTRIAL_NON_RECHARGEABLE_CONTAIN: {
    value: '2.6',
    label: '工业电池（不可充电）'
  },
  LMT_RECHARGEABLE_CONTAIN: {
    value: '2.7',
    label: '轻型交通运输工具（可充电）'
  },
  SLI_RECHARGEABLE_CONTAIN: {
    value: '2.8',
    label: '启动，照明，点火电池（可充电）'
  }
})

// 比利时电池法三级，产品小类
const belgiumBatteryTypeThree = new GenerateEnum({
  // ---------- 单一电池（SINGLE = 1） ----------,
  PORTABLE_RECHARGEABLE_LITHIUM_ION: {
    value: '1.1.1',
    label: '锂离子电池'
  },
  PORTABLE_RECHARGEABLE_LITHIUM_POLYMER: {
    value: '1.1.2',
    label: '锂聚合物电池'
  },
  PORTABLE_RECHARGEABLE_NICKEL_CADMIUM: {
    value: '1.1.3',
    label: '镍镉电池'
  },
  PORTABLE_RECHARGEABLE_NIMH_SPACE: {
    value: '1.1.4',
    label: '镍氢电池（航天用高压氢气电池）'
  },
  PORTABLE_RECHARGEABLE_NIMH_CIVIL: {
    value: '1.1.5',
    label: '镍氢电池（民用可充电镍氢电池）'
  },
  PORTABLE_RECHARGEABLE_WATER_BATTERY: {
    value: '1.1.6',
    label: '液态水电池'
  },
  PORTABLE_RECHARGEABLE_LEAD_ACID: {
    value: '1.1.7',
    label: '铅酸电池'
  },
  PORTABLE_RECHARGEABLE_ALL_BUTTON_CELLS: {
    value: '1.1.8',
    label: '所有纽扣电池'
  },
  PORTABLE_NON_RECHARGEABLE_CARBON_ZINC: {
    value: '1.2.1',
    label: '碳锌电池'
  },
  PORTABLE_NON_RECHARGEABLE_ZINC_AIR: {
    value: '1.2.2',
    label: '锌空气电池'
  },
  PORTABLE_NON_RECHARGEABLE_SILVER_OXIDE: {
    value: '1.2.3',
    label: '氧化银电池'
  },
  PORTABLE_NON_RECHARGEABLE_LITHIUM: {
    value: '1.2.4',
    label: '锂电池'
  },
  PORTABLE_NON_RECHARGEABLE_ALKALINE: {
    value: '1.2.5',
    label: '碱性锰电池'
  },
  PORTABLE_NON_RECHARGEABLE_ALL_BUTTON_CELLS: {
    value: '1.2.6',
    label: '所有纽扣电池'
  },
  EV_LARGE_RECHARGEABLE_LITHIUM_ION: {
    value: '1.3.1',
    label: '锂离子电池'
  },
  EV_LARGE_RECHARGEABLE_LEAD_ACID: {
    value: '1.3.2',
    label: '铅酸电池'
  },
  EV_LARGE_RECHARGEABLE_NIMH_CIVIL: {
    value: '1.3.3',
    label: '镍氢电池（民用可充电镍氢电池）'
  },
  ENERGY_STORAGE_RECHARGEABLE_LITHIUM: {
    value: '1.4.1',
    label: '可充电锂电池'
  },
  ENERGY_STORAGE_SALT_WATER: {
    value: '1.4.2',
    label: '盐水电池'
  },
  ENERGY_STORAGE_LEAD_ACID: {
    value: '1.4.3',
    label: '铅酸电池'
  },
  INDUSTRIAL_RECHARGEABLE_LEAD_ACID: {
    value: '1.5.1',
    label: '铅酸电池'
  },
  INDUSTRIAL_RECHARGEABLE_LITHIUM_ION: {
    value: '1.5.2',
    label: '锂离子电池'
  },
  INDUSTRIAL_RECHARGEABLE_LITHIUM_POLYMER: {
    value: '1.5.3',
    label: '锂聚合物电池'
  },
  INDUSTRIAL_RECHARGEABLE_NICKEL_CADMIUM: {
    value: '1.5.4',
    label: '镍镉电池'
  },
  INDUSTRIAL_RECHARGEABLE_NIMH_SPACE: {
    value: '1.5.5',
    label: '镍氢电池（航天用高压氢气电池）'
  },
  INDUSTRIAL_NON_RECHARGEABLE_LITHIUM: {
    value: '1.6.1',
    label: '锂电池'
  },
  INDUSTRIAL_NON_RECHARGEABLE_ZINC_AIR: {
    value: '1.6.2',
    label: '锌空气电池'
  },
  INDUSTRIAL_NON_RECHARGEABLE_CARBON_ZINC: {
    value: '1.6.3',
    label: '碳锌电池'
  },
  INDUSTRIAL_NON_RECHARGEABLE_ALKALINE: {
    value: '1.6.4',
    label: '碱性锰电池'
  },
  LMT_RECHARGEABLE_LITHIUM_ION: {
    value: '1.7.1',
    label: '锂离子电池'
  },
  LMT_RECHARGEABLE_LEAD_ACID: {
    value: '1.7.2',
    label: '铅酸电池'
  },
  LMT_RECHARGEABLE_NIMH_CIVIL: {
    value: '1.7.3',
    label: '镍氢电池（民用可充电镍氢电池）'
  },
  SLI_RECHARGEABLE_LITHIUM_ION: {
    value: '1.8.1',
    label: '锂离子电池'
  },
  SLI_RECHARGEABLE_LEAD_ACID: {
    value: '1.8.2',
    label: '铅酸电池'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_LITHIUM_ION: {
    value: '2.1.1',
    label: '锂离子电池'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_LITHIUM_POLYMER: {
    value: '2.1.2',
    label: '锂聚合物电池'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_NICKEL_CADMIUM: {
    value: '2.1.3',
    label: '镍镉电池'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_NIMH_SPACE: {
    value: '2.1.4',
    label: '镍氢电池（航天用高压氢气电池）'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_NIMH_CIVIL: {
    value: '2.1.5',
    label: '镍氢电池（民用可充电镍氢电池）'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_WATER_BATTERY: {
    value: '2.1.6',
    label: '液态水电池'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_LEAD_ACID: {
    value: '2.1.7',
    label: '铅酸电池'
  },
  PORTABLE_RECHARGEABLE_CONTAIN_ALL_BUTTON_CELLS: {
    value: '2.1.8',
    label: '所有纽扣电池'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN_CARBON_ZINC: {
    value: '2.2.1',
    label: '碳锌电池'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN_ZINC_AIR: {
    value: '2.2.2',
    label: '锌空气电池'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN_SILVER_OXIDE: {
    value: '2.2.3',
    label: '氧化银电池'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN_LITHIUM: {
    value: '2.2.4',
    label: '锂电池'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN_ALKALINE: {
    value: '2.2.5',
    label: '碱性锰电池'
  },
  PORTABLE_NON_RECHARGEABLE_CONTAIN_ALL_BUTTON_CELLS: {
    value: '2.2.6',
    label: '所有纽扣电池'
  },
  EV_LARGE_RECHARGEABLE_CONTAIN_LITHIUM_ION: {
    value: '2.3.1',
    label: '锂离子电池'
  },
  EV_LARGE_RECHARGEABLE_CONTAIN_LEAD_ACID: {
    value: '2.3.2',
    label: '铅酸电池'
  },
  EV_LARGE_RECHARGEABLE_CONTAIN_NIMH_CIVIL: {
    value: '2.3.3',
    label: '镍氢电池（民用可充电镍氢电池）'
  },
  ENERGY_STORAGE_CONTAIN_RECHARGEABLE_LITHIUM: {
    value: '2.4.1',
    label: '可充电锂电池'
  },
  ENERGY_STORAGE_CONTAIN_SALT_WATER: {
    value: '2.4.2',
    label: '盐水电池'
  },
  ENERGY_STORAGE_CONTAIN_LEAD_ACID: {
    value: '2.4.3',
    label: '铅酸电池'
  },
  INDUSTRIAL_RECHARGEABLE_CONTAIN_LEAD_ACID: {
    value: '2.5.1',
    label: '铅酸电池'
  },
  INDUSTRIAL_RECHARGEABLE_CONTAIN_LITHIUM_ION: {
    value: '2.5.2',
    label: '锂离子电池'
  },
  INDUSTRIAL_RECHARGEABLE_CONTAIN_LITHIUM_POLYMER: {
    value: '2.5.3',
    label: '锂聚合物电池'
  },
  INDUSTRIAL_RECHARGEABLE_CONTAIN_NICKEL_CADMIUM: {
    value: '2.5.4',
    label: '镍镉电池'
  },
  INDUSTRIAL_RECHARGEABLE_CONTAIN_NIMH_SPACE: {
    value: '2.5.5',
    label: '镍氢电池（航天用高压氢气电池）'
  },
  INDUSTRIAL_NON_RECHARGEABLE_CONTAIN_LITHIUM: {
    value: '2.6.1',
    label: '锂电池'
  },
  INDUSTRIAL_NON_RECHARGEABLE_CONTAIN_ZINC_AIR: {
    value: '2.6.2',
    label: '锌空气电池'
  },
  INDUSTRIAL_NON_RECHARGEABLE_CONTAIN_CARBON_ZINC: {
    value: '2.6.3',
    label: '碳锌电池'
  },
  INDUSTRIAL_NON_RECHARGEABLE_CONTAIN_ALKALINE: {
    value: '2.6.4',
    label: '碱性锰电池'
  },
  LMT_RECHARGEABLE_CONTAIN_LITHIUM_ION: {
    value: '2.7.1',
    label: '锂离子电池'
  },
  LMT_RECHARGEABLE_CONTAIN_LEAD_ACID: {
    value: '2.7.2',
    label: '铅酸电池'
  },
  LMT_RECHARGEABLE_CONTAIN_NIMH_CIVIL: {
    value: '2.7.3',
    label: '镍氢电池（民用可充电镍氢电池）'
  },
  SLI_RECHARGEABLE_CONTAIN_LITHIUM_ION: {
    value: '2.8.1',
    label: '锂离子电池'
  },
  SLI_RECHARGEABLE_CONTAIN_LEAD_ACID: {
    value: '2.8.2',
    label: '铅酸电池'
  }
})

const belgiumThreeTree = belgiumBatteryTypeThree.enumArray
const belgiumSecondTree = generateTreeByTwoArr(belgiumBatteryTypeSecond.enumArray, belgiumThreeTree)
// 比利时电池法，树结构
const belgiumBatteryTypeTree = generateTreeByTwoArr(belgiumBatteryTypeFirst.enumArray, belgiumSecondTree)

/**
 * 荷兰WEEE产品类型枚举
 */
const NETHERLANDS_WEEE_PRODUCT_TYPE = new GenerateEnum({
  TEMP_EXCHANGER: {
    value: '1',
    label: '热或冷交换设备'
  },
  SCREEN: {
    value: '2',
    label: '屏幕、显示器以及屏幕面积超过 100 cm² 的设备'
  },
  BULB: {
    value: '3',
    label: '灯具'
  },
  LARGE_DEVICE: {
    value: '4',
    label: '大型设备（外部尺寸超过50厘米）'
  },
  SMALL_DEVICE: {
    value: '5',
    label: '小型设备（外部尺寸不超过50厘米）'
  },
  SMALL_IT_TELECOM: {
    value: '6',
    label: '小型 IT 和电信设备（外部尺寸不超过 50 厘米）'
  }
})

/**
 * 荷兰WEEE产品分类枚举
 */
const NETHERLANDS_WEEE_PRODUCT_SUB_TYPE = new GenerateEnum({
  // ====================== 1. 热或冷交换设备 ======================
  HOUSEHOLD_REFRIGERATION_AND_FREEZING: {
    value: '1.1',
    label: '冷藏和冷冻设备（家用）'
  },
  TUMBLE_DRYER_WITH_HEATPUMP: {
    value: '1.2',
    label: '滚筒式烘干机（带热泵）'
  },
  AIR_CONDITIONING_BULK: {
    value: '1.3',
    label: '空调设备（散装）'
  },
  AIR_CONDITIONING_BUILTIN_AND_HEATPUMP: {
    value: '1.4',
    label: '空调设备（内置）和热泵'
  },
  PROFESSIONAL_REFRIGERATION_FREEZERS: {
    value: '1.5',
    label: '冷藏和冷冻设备（专业）'
  },
  MACHINES_REFRIGERATION: {
    value: '1.6',
    label: '机器（冷藏）'
  },

  // ====================== 2. 屏幕、显示器及大面积显示设备 ======================
  TVS_AND_MONITORS_FLAT: {
    value: '2.1',
    label: '电视和显示器（平板）'
  },
  MONITORS_FLAT_SCREEN: {
    value: '2.2',
    label: '显示器（平板屏幕）'
  },
  LAPTOPS: {
    value: '2.3',
    label: '笔记本电脑'
  },
  TABLETS_AND_NAVIGATION: {
    value: '2.4',
    label: '平板电脑和导航系统'
  },

  // ====================== 3. 灯具 ======================
  LED_LAMPS: {
    value: '3.1',
    label: 'LED 灯（包括 LED TL）'
  },
  ENERGY_SAVING_AND_GAS_DISCHARGE_LAMPS: {
    value: '3.2',
    label: '节能灯和气体放电灯'
  },
  FLUORESCENT_LAMPS_EXCEPT_LED: {
    value: '3.3',
    label: '荧光灯（LED荧光灯除外）'
  },

  // ====================== 4. 大型设备（外部尺寸超过50厘米） ======================
  HOUSEHOLD_RANGE_HOOD: {
    value: '4.1',
    label: '家用抽油烟机'
  },
  BARBECUE_GRILL_COOKING_TRAYS_OVER_50CM: {
    value: '4.2',
    label: '烧烤架、烤架和烹饪盘（>50 厘米）- 家用'
  },
  MICROWAVES_OVENS_OVER_50CM: {
    value: '4.3',
    label: '微波炉和烤箱（>50 厘米）- 家用'
  },
  HOUSEHOLD_STOVES: {
    value: '4.4',
    label: '家用炉灶'
  },
  HOUSEHOLD_DISHWASHERS: {
    value: '4.5',
    label: '家用洗碗机'
  },
  WASHING_MACHINES: {
    value: '4.6',
    label: '洗衣机'
  },
  TUMBLE_DRYERS_NO_HEATPUMP: {
    value: '4.7',
    label: '滚筒式烘干机（不带热泵）'
  },
  HOUSEHOLD_KITCHEN_CARE_APPLIANCES_OVER_50CM: {
    value: '4.8',
    label: '家用、厨房和护理器具（>50厘米）'
  },
  VACUUM_CLEANERS_FLOOR_CARE_OVER_50CM: {
    value: '4.9',
    label: '吸尘器和地板清洁剂（>50厘米）'
  },
  BOILERS_WATER_HEATERS_GEYSERS_OVER_50CM: {
    value: '4.10',
    label: '锅炉、热水器和间歇泉（>50 厘米）'
  },
  SUN_BEDS: {
    value: '4.11',
    label: '日光浴床'
  },
  VENTILATION_RECIRCULATION_AIR_HANDLING_OVER_150M3: {
    value: '4.12',
    label: '通风、再循环和空气处理装置 (>50 厘米 | >150 立方米/小时)'
  },
  VENTILATION_RECIRCULATION_AIR_HANDLING_LE_150M3: {
    value: '4.13',
    label: '通风、再循环和空气处理装置（>50 厘米 | 150 立方米/小时）'
  },
  VENTILATION_CIRCULATION_HEATING_LOOSE: {
    value: '4.14',
    label: '通风、循环和加热设备（>50 厘米 | 松散）'
  },
  HEATING_WATER_HEATING_BUILT_IN: {
    value: '4.15',
    label: '供暖和热水设备（> 50 厘米 | 内置）'
  },
  COMMERCIAL_KITCHEN_EQUIPMENT_NON_REFRIGERATED: {
    value: '4.16',
    label: '商用厨房设备（非冷藏）'
  },
  MACHINES_NON_REFRIGERATED: {
    value: '4.17',
    label: '机器（非冷藏）'
  },
  TEXTILE_PROCESSING_EQUIPMENT_OVER_50CM: {
    value: '4.18',
    label: '纺织加工设备（>50厘米）'
  },
  ELECTRIC_MUSICAL_INSTRUMENTS_OVER_50CM: {
    value: '4.19',
    label: '电动乐器（>50厘米）'
  },
  ELECTRIC_TOYS_ENTERTAINMENT_SPORTS_OVER_50CM: {
    value: '4.20',
    label: '电动玩具、娱乐和运动设备（>50厘米）'
  },
  MEDICAL_EQUIPMENT_OVER_50CM: {
    value: '4.21',
    label: '医疗设备（>50厘米）'
  },
  MEASURING_CONTROL_EQUIPMENT_OVER_50CM: {
    value: '4.22',
    label: '测量和控制设备（>50厘米）'
  },
  AUDIO_VIDEO_EQUIPMENT_OVER_50CM: {
    value: '4.23',
    label: '音频和视频设备（>50厘米）'
  },
  IT_OFFICE_EQUIPMENT_HOME_OVER_50CM: {
    value: '4.24',
    label: '信息技术和办公设备（>50 厘米 | 家用）'
  },
  IT_OFFICE_EQUIPMENT_PROFESSIONAL_OVER_50CM: {
    value: '4.25',
    label: '信息技术及办公设备（>50 厘米 | 专业）'
  },
  FLUORESCENT_ENERGY_GAS_LAMPS_OVER_750G: {
    value: '4.26',
    label: '荧光灯、节能灯和气体放电灯灯具（>750 克）'
  },
  LAMPS_WITH_INTEGRATED_LED_OVER_750G: {
    value: '4.27',
    label: '带集成 LED 的灯具（>750 克）'
  },
  INTERCHANGEABLE_LED_LAMPS_OVER_750G: {
    value: '4.28',
    label: '可互换 LED 灯具（>750 克）'
  },
  POWER_TOOLS_OVER_50CM: {
    value: '4.29',
    label: '电动工具（>50厘米）'
  },
  SOLAR_PANELS: {
    value: '4.30',
    label: '太阳能电池板'
  },
  E_BIKES_UNAPPROVED: {
    value: '4.31',
    label: '电动自行车（未经型式核准）'
  },
  OPEN_OSCILLOSCOPE_EQUIPMENT_OVER_50CM: {
    value: '4.32',
    label: '开放式示波器设备（> 50 厘米 | 无主要电气功能）'
  },

  // ====================== 5. 小型设备（外部尺寸不超过50厘米） ======================
  BARBECUE_GRILL_COOKING_TRAYS_UNDER_50CM: {
    value: '5.1',
    label: '烧烤架、烤架和烹饪盘（<= 50 厘米）'
  },
  MICROWAVES_OVENS_UNDER_50CM: {
    value: '5.2',
    label: '微波炉和烤箱（<= 50 厘米）'
  },
  HOUSEHOLD_KITCHEN_CARE_APPLIANCES_UNDER_50CM: {
    value: '5.3',
    label: '家用、厨房和护理器具（<= 50 厘米）'
  },
  VACUUM_CLEANERS_FLOOR_CARE_UNDER_50CM: {
    value: '5.4',
    label: '吸尘器和地板清洁剂（<= 50 厘米）'
  },
  BOILERS_WATER_HEATERS_GEYSERS_UNDER_50CM: {
    value: '5.5',
    label: '锅炉、热水器和间歇泉（<= 50 厘米）'
  },
  VENTILATION_RECIRCULATION_AIR_HANDLING_LE_150M3_UNDER_50CM: {
    value: '5.6',
    label: '通风、再循环和空气处理装置（<= 50 厘米 | <= 150 立方米/小时）'
  },
  VENTILATION_RECIRCULATION_AIR_HANDLING_GT_150M3_UNDER_50CM: {
    value: '5.7',
    label: '通风、再循环和空气处理装置（<= 50 厘米 | > 150 立方米/小时）'
  },
  VENTILATION_CIRCULATION_HEATING_LOOSE_UNDER_50CM: {
    value: '5.8',
    label: '通风、循环和加热设备（<= 50 厘米 | 松散）'
  },
  HEATING_WATER_HEATING_BUILT_IN_UNDER_50CM: {
    value: '5.9',
    label: '供暖和热水设备（<=50厘米|内置）'
  },
  TEXTILE_PROCESSING_EQUIPMENT_UNDER_50CM: {
    value: '5.10',
    label: '纺织加工设备（<= 50 厘米）'
  },
  ELECTRONIC_MUSICAL_INSTRUMENTS_UNDER_50CM: {
    value: '5.11',
    label: '电子乐器（<= 50 厘米）'
  },
  GAMING_CONSOLES: {
    value: '5.12',
    label: '游戏机'
  },
  ELECTRIC_TOYS_ENTERTAINMENT_SPORTS_UNDER_50CM: {
    value: '5.13',
    label: '电动玩具、娱乐和运动设备（<= 50 厘米）'
  },
  MEDICAL_EQUIPMENT_UNDER_50CM: {
    value: '5.14',
    label: '医疗设备（<= 50 厘米）'
  },
  MEASURING_CONTROL_EQUIPMENT_UNDER_50CM: {
    value: '5.15',
    label: '测量和控制设备，包括探测器、传感器和开关（<= 50 厘米）'
  },
  AUDIO_VIDEO_EQUIPMENT_UNDER_50CM: {
    value: '5.16',
    label: '音频和视频设备（<= 50 厘米）'
  },
  FLUORESCENT_ENERGY_GAS_LAMPS_UNDER_750G: {
    value: '5.17',
    label: '荧光灯、节能灯和气体放电灯灯具（<= 750 克）'
  },
  LAMPS_WITH_INTEGRATED_LED_UNDER_750G: {
    value: '5.18',
    label: '带集成 LED 的灯具（<= 750 克）'
  },
  INTERCHANGEABLE_LED_LAMPS_UNDER_750G: {
    value: '5.19',
    label: '可互换 LED 灯具（<= 750 克）'
  },
  POWER_TOOLS_UNDER_50CM: {
    value: '5.20',
    label: '电动工具（<= 50 厘米）'
  },
  OPEN_OSCILLOSCOPE_EQUIPMENT_UNDER_50CM: {
    value: '5.21',
    label: '开放式示波器设备（<= 50 厘米 | 无主要电气功能）'
  },

  // ====================== 6. 小型 IT 和电信设备（外部尺寸不超过 50 厘米） ======================
  MOBILE_PHONES: {
    value: '6.1',
    label: '移动电话'
  },
  DESKTOP_COMPUTERS_UNDER_50CM: {
    value: '6.2',
    label: '台式电脑（<= 50 厘米）'
  },
  PRINTERS_SCANNERS_UNDER_50CM: {
    value: '6.3',
    label: '打印机和扫描仪（<= 50 厘米）'
  },
  IT_OFFICE_EQUIPMENT_HOME_UNDER_50CM: {
    value: '6.4',
    label: '信息技术和办公设备（<= 50 厘米 | 家用）'
  },
  IT_OFFICE_EQUIPMENT_PROFESSIONAL_UNDER_50CM: {
    value: '6.5',
    label: '信息技术及办公设备（<= 50 厘米 | 专业）'
  }
})

function generateTreeByTwoArr(parentArr, childrenArr) {
  return parentArr.map((item) => {
    const children = childrenArr
      .filter((child) => child.value && child.value.startsWith(item.value + '.'))
      .map((child) => {
        return {
          ...child
        }
      })

    return {
      ...item,
      children
    }
  })
}

// 荷兰WEEE，树结构
const netherlandsWeeeTypeTree = generateTreeByTwoArr(NETHERLANDS_WEEE_PRODUCT_TYPE.enumArray, NETHERLANDS_WEEE_PRODUCT_SUB_TYPE.enumArray)

/**
 * 比利时WEEE产品类型枚举
 */
const BELGIUM_WEEE_PRODUCT_TYPE_FIRST = new GenerateEnum({
  TEMPERATURE_EXCHANGE_EQUIPMENT: {
    value: '1',
    label: '温度交换设备'
  },
  SCREEN_MONITORS_LARGE_SCREEN: {
    value: '2',
    label: '屏幕、显示器以及屏幕面积大于 100 cm² 的设备'
  },
  LIGHTING_EQUIPMENT: {
    value: '3',
    label: '灯'
  },
  LARGE_EQUIPMENT: {
    value: '4',
    label: '大型设备（任何外部尺寸> 50厘米）'
  },
  SMALL_EQUIPMENT: {
    value: '5',
    label: '小型设备（外部尺寸≤50厘米）'
  },
  SMALL_IT_TELECOM_EQUIPMENT: {
    value: '6',
    label: '小型IT和电信设备（外部尺寸≤50厘米）'
  }
})

const BELGIUM_WEEE_PRODUCT_TYPE_SECOND = new GenerateEnum({
  // ---------- 单一电池（SINGLE = 1） ----------,
  TEMPERATURE_HOME_APPLIANCE: {
    value: '1.1',
    label: '家用电器'
  },
  TEMPERATURE_INDUSTRIAL_APPLIANCE: {
    value: '1.2',
    label: '工业电器'
  },
  SCREEN_HOME_APPLIANCE: {
    value: '2.1',
    label: '家用电器'
  },
  SCREEN_INDUSTRIAL_APPLIANCE: {
    value: '2.2',
    label: '工业电器'
  },
  LIGHT_HOME_APPLIANCE: {
    value: '3.1',
    label: '家用电器'
  },
  LARGE_HOME_APPLIANCE: {
    value: '4.1',
    label: '家用电器'
  },
  LARGE_INDUSTRIAL_APPLIANCE: {
    value: '4.2',
    label: '工业电器'
  },
  SMALL_HOME_APPLIANCE: {
    value: '5.1',
    label: '家用电器'
  },
  SMALL_INDUSTRIAL_APPLIANCE: {
    value: '5.2',
    label: '工业电器'
  },
  SMALL_IT_HOME_APPLIANCE: {
    value: '6.1',
    label: '家用电器'
  },
  SMALL_IT_INDUSTRIAL_APPLIANCE: {
    value: '6.2',
    label: '工业电器'
  }
})

const BELGIUM_WEEE_PRODUCT_TYPE_THIRD = new GenerateEnum({
  // ---------- 单一电池（SINGLE = 1） ----------,
  TEMPERATURE_HOME_INSERT_COMPRESSOR: {
    value: '1.1.1',
    label: '制冷用温度交换设备（插入式、带压缩机或吸收系统）'
  },
  TEMPERATURE_HOME_OIL_HEATER: {
    value: '1.1.2',
    label: '油汀式电暖器'
  },
  TEMPERATURE_HOME_LARGE_WHITE_GOODS: {
    value: '1.1.3',
    label: '配有热泵的大型白色家电（如冰箱、洗衣机等）'
  },
  TEMPERATURE_INDUSTRIAL_EXCHANGE_EQUIP: {
    value: '1.2.1',
    label: '专业用途的热交换设备（插电或非插电式，带压缩机或吸收系统）'
  },
  SCREEN_HOME_BATTERY_SCREEN: {
    value: '2.1.1',
    label: '电池屏幕'
  },
  SCREEN_HOME_MONITOR: {
    value: '2.1.2',
    label: '显示器'
  },
  SCREEN_HOME_AV_LARGE: {
    value: '2.1.3',
    label: '屏幕面积大于 100 平方厘米的音视频设备'
  },
  SCREEN_HOME_ICT_LARGE: {
    value: '2.1.4',
    label: '屏幕面积大于 100 平方厘米的信息与通信技术设备（ICT设备）'
  },
  SCREEN_INDUSTRIAL_MONITOR: {
    value: '2.2.1',
    label: '专业用途的显示器和信息显示板'
  },
  LIGHT_HOME_GAS_DISCHARGE: {
    value: '3.1.1',
    label: '气体放电灯'
  },
  LIGHT_HOME_REPLACEABLE_LED: {
    value: '3.1.2',
    label: '改装（可更换）LED 灯'
  },
  LARGE_HOME_WHITE_TEXTILE: {
    value: '4.1.1',
    label: '大型白色家电 – 纺织品 > 50 cm'
  },
  LARGE_HOME_WHITE_KITCHEN: {
    value: '4.1.2',
    label: '大型白色家电 – 厨房 > 50 cm'
  },
  LARGE_HOME_KITCHEN_CARE_NON_MEDICAL: {
    value: '4.1.3',
    label: '家用、厨房和护理设备（非医疗）> 50 cm'
  },
  LARGE_HOME_BOILER: {
    value: '4.1.4',
    label: '锅炉 > 50 cm'
  },
  LARGE_HOME_HEAT_STORAGE: {
    value: '4.1.5',
    label: '储热器 > 50 cm'
  },
  LARGE_HOME_SOLARIUM: {
    value: '4.1.6',
    label: '日光浴床和日光浴室 > 50 cm'
  },
  LARGE_HOME_VACUUM_CLEANER: {
    value: '4.1.7',
    label: '干湿两用真空吸尘器和地板清洁器 > 50 cm'
  },
  LARGE_HOME_TEXTILE_PROCESSING: {
    value: '4.1.8',
    label: '纺织加工设备 > 50 cm'
  },
  LARGE_HOME_IRONING: {
    value: '4.1.9',
    label: '熨烫设备 > 50 cm'
  },
  LARGE_HOME_COOLING: {
    value: '4.1.10',
    label: '冷却设备（第 1 类设备除外）> 50 cm'
  },
  LARGE_HOME_HVAC_WATER_TREATMENT: {
    value: '4.1.11',
    label: '通风、空调、供暖和水处理设备（第 1 类设备除外）'
  },
  LARGE_HOME_AUDIO_VIDEO: {
    value: '4.1.12',
    label: '音频和视频设备 > 50 厘米'
  },
  LARGE_HOME_ELECTRIC_MUSICAL: {
    value: '4.1.13',
    label: '电动乐器 > 50 厘米'
  },
  LARGE_HOME_BATTERY_CHARGER: {
    value: '4.1.14',
    label: '电池充电器和电源板 > 50 厘米'
  },
  LARGE_HOME_CARTRIDGE: {
    value: '4.1.15',
    label: '墨盒 > 50 厘米'
  },
  LARGE_HOME_EV_CHARGER: {
    value: '4.1.16',
    label: '电动汽车充电站 > 50 厘米'
  },
  LARGE_HOME_UPS: {
    value: '4.1.17',
    label: '不间断电源 (UPS) 和电源转换器 > 50 厘米'
  },
  LARGE_HOME_LIGHTING: {
    value: '4.1.18',
    label: '灯具 > 50 厘米'
  },
  LARGE_HOME_TOOLS_GARDEN: {
    value: '4.1.19',
    label: '电气和电子工具、园艺工具、水族箱和池塘配件以及测量和控制仪器（园艺）工具（长度> 50厘米）'
  },
  LARGE_HOME_TOYS_GAMES: {
    value: '4.1.20',
    label: '休闲设备、玩具、游戏机及配件 > 50 厘米'
  },
  LARGE_HOME_SPORT_EQUIPMENT: {
    value: '4.1.21',
    label: '运动器材 > 50 厘米'
  },
  LARGE_HOME_EBIKE: {
    value: '4.1.22',
    label: '电动两轮车 > 50 厘米'
  },
  LARGE_HOME_MEDICAL_AID: {
    value: '4.1.23',
    label: '家用医疗辅助器具 > 50 厘米'
  },
  LARGE_HOME_ICT_OFFICE: {
    value: '4.1.24',
    label: 'ICT 和办公设备 > 50 厘米'
  },
  LARGE_INDUSTRIAL_WHITE_GOODS: {
    value: '4.2.1',
    label: '专业专用大型白色家电、纺织、餐饮和护理设备（非医疗）'
  },
  LARGE_INDUSTRIAL_CLEANING_IRONING_TEXTILE: {
    value: '4.2.2',
    label: '专业专用清洁、熨烫和纺织加工设备，> 50 厘米'
  },
  LARGE_INDUSTRIAL_HVAC_WATER_TREATMENT: {
    value: '4.2.3',
    label: '专业专用通风、空调、供暖和水处理设备（第一类除外）'
  },
  LARGE_INDUSTRIAL_AUDIO_VIDEO: {
    value: '4.2.4',
    label: '专业专用音频、视频和特效设备，> 50 厘米'
  },
  LARGE_INDUSTRIAL_EV_CHARGER: {
    value: '4.2.5',
    label: '专业专用电动汽车充电站，> 50 厘米'
  },
  LARGE_INDUSTRIAL_UPS: {
    value: '4.2.6',
    label: '专业专用不间断电源 (UPS) 和电源转换器，> 50 厘米'
  },
  LARGE_INDUSTRIAL_LIGHTING: {
    value: '4.2.7',
    label: '专业专用灯具，> 50 厘米'
  },
  LARGE_INDUSTRIAL_TOOLS_GARDEN: {
    value: '4.2.8',
    label: '专业专用电气和电子工具、园艺工具、水族箱和池塘配件以及汽车测试和测量设备'
  },
  LARGE_INDUSTRIAL_MEDICAL_LAB: {
    value: '4.2.9',
    label: '医疗、兽医、专供专业用途的畜牧和实验室设备 > 50 厘米'
  },
  LARGE_INDUSTRIAL_MEASUREMENT_CONTROL: {
    value: '4.2.10',
    label: '专供专业用途的测量和控制设备 > 50 厘米'
  },
  LARGE_INDUSTRIAL_VENDING_MACHINE: {
    value: '4.2.11',
    label: '自动售货机（非制冷） > 50 厘米'
  },
  LARGE_INDUSTRIAL_HOT_DRINKS_VENDING: {
    value: '4.2.12',
    label: '热饮自动售货机 > 50 厘米'
  },
  LARGE_INDUSTRIAL_ELECTRO_MECH: {
    value: '4.2.13',
    label: '专业电气和电子机械及装置 > 50 厘米'
  },
  LARGE_INDUSTRIAL_ICT_OFFICE: {
    value: '4.2.14',
    label: '专供专业用途的 ICT 和办公设备 > 50 厘米'
  },
  SMALL_HOME_MINI_WASHING_MACHINE: {
    value: '5.1.1',
    label: '迷你洗衣机 ≤ 50 厘米'
  },
  SMALL_HOME_LARGE_WHITE_KITCHEN: {
    value: '5.1.2',
    label: '大型白色家电 - 厨房 ≤ 50 厘米'
  },
  SMALL_HOME_KITCHEN_CARE_NON_MEDICAL: {
    value: '5.1.3',
    label: '家用、厨房和护理设备（非医疗）≤ 50 厘米'
  },
  SMALL_HOME_BOILER: {
    value: '5.1.4',
    label: '锅炉 ≤ 50 厘米'
  },
  SMALL_HOME_VACUUM_CLEANER: {
    value: '5.1.5',
    label: '干湿两用真空吸尘器和地板清洁器 ≤ 50 厘米'
  },
  SMALL_HOME_TEXTILE_PROCESSING: {
    value: '5.1.6',
    label: '纺织加工设备 ≤ 50 厘米'
  },
  SMALL_HOME_IRONING: {
    value: '5.1.7',
    label: '熨烫设备 ≤ 50 厘米'
  },
  SMALL_HOME_COOLING: {
    value: '5.1.8',
    label: '制冷设备（第 1 类器具除外）≤ 50 厘米'
  },
  SMALL_HOME_HVAC_WATER_TREATMENT: {
    value: '5.1.9',
    label: '通风、空调、供暖和水处理设备（第1类设备除外）≤50厘米'
  },
  SMALL_HOME_AUDIO_VIDEO: {
    value: '5.1.10',
    label: '音频和视频设备 ≤ 50 厘米'
  },
  SMALL_HOME_ELECTRIC_MUSICAL: {
    value: '5.1.11',
    label: '电动乐器 ≤ 50 厘米'
  },
  SMALL_HOME_HEADPHONES: {
    value: '5.1.12',
    label: '耳机 ≤ 50 厘米'
  },
  SMALL_HOME_BATTERY_CHARGER: {
    value: '5.1.13',
    label: '电池充电器、电源适配器、线缆、电源板、插头 ≤ 50 厘米'
  },
  SMALL_HOME_CARTRIDGE: {
    value: '5.1.14',
    label: '墨盒 ≤ 50 厘米'
  },
  SMALL_HOME_EV_CHARGER: {
    value: '5.1.15',
    label: '电动汽车充电站 ≤ 50 厘米'
  },
  SMALL_HOME_UPS: {
    value: '5.1.16',
    label: '不间断电源 (UPS) 和电源转换器 ≤ 50 厘米'
  },
  SMALL_HOME_LIGHTING: {
    value: '5.1.17',
    label: '灯具 ≤ 50 厘米'
  },
  SMALL_HOME_TOOLS_GARDEN: {
    value: '5.1.18',
    label: '电气和电子工具、园艺工具、水族箱和池塘配件以及测量和控制仪器（园艺）工具≤50厘米'
  },
  SMALL_HOME_TOYS_GAMES: {
    value: '5.1.19',
    label: '休闲设备、玩具、游戏机及配件 ≤ 50 厘米'
  },
  SMALL_HOME_SPORT_EQUIPMENT: {
    value: '5.1.20',
    label: '运动器材及配件 ≤ 50 厘米'
  },
  SMALL_HOME_MEDICAL_AID: {
    value: '5.1.21',
    label: '家用医疗辅助器具 ≤ 50 厘米'
  },
  SMALL_HOME_SMOKE_HEAT_DETECTOR: {
    value: '5.1.22',
    label: '烟雾/热探测器（自主和非自主） ≤ 50 厘米'
  },
  SMALL_HOME_CO_DETECTOR: {
    value: '5.1.23',
    label: '自主式一氧化碳和气体探测器 ≤ 50 厘米'
  },
  SMALL_HOME_MEASUREMENT_CONTROL: {
    value: '5.1.24',
    label: '测量和控制设备 ≤ 50 厘米'
  },
  SMALL_HOME_THERMOSTATS: {
    value: '5.1.25',
    label: '房间和时钟恒温器及节能装置 ≤ 50 厘米'
  },
  SMALL_HOME_SMALL_INSTALLATION: {
    value: '5.1.26',
    label: '小型电气安装材料和家庭自动化 ≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_WHITE_GOODS: {
    value: '5.2.1',
    label: '专业专用大型白色家电、纺织、餐饮和护理设备（非医疗）≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_CLEANING_IRONING_TEXTILE: {
    value: '5.2.2',
    label: '专业专用清洁、熨烫和纺织加工设备 ≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_HVAC_WATER_TREATMENT: {
    value: '5.2.3',
    label: '专业专用通风、空调、供暖和水处理设备（第一类除外）'
  },
  SMALL_INDUSTRIAL_AUDIO_VIDEO: {
    value: '5.2.4',
    label: '专业专用音频、视频和特效设备 ≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_EV_CHARGER: {
    value: '5.2.5',
    label: '专业专用电动汽车充电站 ≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_UPS: {
    value: '5.2.6',
    label: '专业专用不间断电源 (UPS) 和电源转换器 ≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_LIGHTING: {
    value: '5.2.7',
    label: '专业专用灯具 ≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_TOOLS_GARDEN: {
    value: '5.2.8',
    label: '专业专用电气和电子工具、园艺工具、水族箱和池塘配件以及汽车测试和测量设备 ≤ 50 厘米'
  },
  SMALL_INDUSTRIAL_MEDICAL_LAB: {
    value: '5.2.9',
    label: '专用医疗、兽医、畜牧和实验室设备（≤ 50 厘米）'
  },
  SMALL_INDUSTRIAL_MEASUREMENT_CONTROL: {
    value: '5.2.10',
    label: '专用测量和控制设备（≤ 50 厘米）'
  },
  SMALL_INDUSTRIAL_VENDING_MACHINE: {
    value: '5.2.11',
    label: '自动售货机（非制冷）（≤ 50 厘米）'
  },
  SMALL_INDUSTRIAL_CO_DETECTOR: {
    value: '5.2.12',
    label: '非自主式 CO 和气体探测器（≤ 50 厘米）'
  },
  SMALL_INDUSTRIAL_CAMERA_SYSTEM: {
    value: '5.2.13',
    label: '倒车摄像头、盲点摄像头、泊车辅助系统'
  },
  SMALL_IT_HOME_SCREEN_AV: {
    value: '6.1.1',
    label: 'ICT 和办公设备 ≤ 50 厘米'
  },
  SMALL_IT_HOME_ICT: {
    value: '6.1.2',
    label: '家用（火灾）报警系统、门禁和对讲系统 ≤ 50 厘米'
  },
  SMALL_IT_INDUSTRIAL_ICT: {
    value: '6.2.2',
    label: '专业用途的 ICT 和办公设备 ≤ 50 厘米'
  },
  SMALL_IT_INDUSTRIAL_FIRE_ALARM: {
    value: '6.2.3',
    label: '专业用途的（火灾）报警系统、门禁和对讲系统'
  }
})

// 比利时WEEE，树结构
const belgiumWEEEthreeTree = BELGIUM_WEEE_PRODUCT_TYPE_THIRD.enumArray
const belgiumWEEEsecondTree = generateTreeByTwoArr(BELGIUM_WEEE_PRODUCT_TYPE_SECOND.enumArray, belgiumWEEEthreeTree)
const belgiumWeeeTypeTree = generateTreeByTwoArr(BELGIUM_WEEE_PRODUCT_TYPE_FIRST.enumArray, belgiumWEEEsecondTree)

/*CLOTHING("1", "衣服"),
    HOME_TEXTILES("2", "家纺");*/
const netherlandsTextileTypeEnum = new GenerateEnum({
  CLOTHING: {
    value: '1',
    label: '${"key": "1991386027975159816", "name": "衣服"}'
  },
  HOME_TEXTILES: {
    value: '2',
    label: '${"key": "1991386027975159817", "name": "家纺"}'
  }
})

/**
 * 纺织品子分类枚举
 */
const netherlandsTextileSubTypeEnum = new GenerateEnum({
  // ====================== 1. 服装 Clothing ======================
  CONSUMER_CLOTHING: {
    value: '1.1',
    label: '${"key": "1991386027979354112", "name": "消费品服装"}',
    parent: '1'
  },
  WORKWEAR: {
    value: '1.2',
    label: '${"key": "1991386027979354113", "name": "工作服"}',
    parent: '1'
  },

  // ====================== 2. 家纺 Home textiles ======================
  BED_LINEN: {
    value: '2.1',
    label: '${"key": "1991386027979354114", "name": "床单"}',
    parent: '2'
  },
  TABLE_LINEN: {
    value: '2.2',
    label: '${"key": "1991386027979354115", "name": "桌布"}',
    parent: '2'
  },
  HOUSEHOLD_LINEN: {
    value: '2.3',
    label: '${"key": "1991386027979354116", "name": "家用亚麻制品（例如毛巾和茶巾）"}',
    parent: '2'
  }
})

// 荷兰纺织，树结构
const netherlandsTextileTypeTree = transformLangByTree(generateTreeByTwoArr(netherlandsTextileTypeEnum.enumArray, netherlandsTextileSubTypeEnum.enumArray), 'label', 'name')

function transformLangByTree(tree, langKey, newKey) {
  const nodeList = []
  nodeList.push(...tree)

  while (nodeList.length) {
    const node = nodeList.shift()
    const children = node.children

    if (children && children.length) {
      nodeList.push(...children)
    }

    node[newKey] = getConversionAfterName(node[langKey])
  }

  return tree
}

// 授权代表产品系列证书列表
const AUTHORIZED_REPRESENTATIVE_CERTIFACATION = [
  {
    value: 'CC001',
    label: getLabelText({
      key: 'remote.enumerate.PSECircular',
      text: 'PSE圆形'
    })
  },
  {
    value: 'CC002',
    label: getLabelText({
      key: 'remote.enumerate.PSEDiamond',
      text: 'PSE菱形'
    })
  }
]

export {
  LZ_ATTRIBATE_TEXT,
  getAttributeVal,
  getPriceSymbol,
  BATTERY_WEIGHT_LIST,
  TAX_TYPE_LIST,
  BATTERY_TYPE_INFO,
  BATTERY_TYPE_OPTIONS,
  taxCountryList,
  serviceItems,
  ES_W3E_LIST2,
  ES_BATTERY_LIST,
  ES_BATTERY_SPEC,
  FR_APP_TYPE,
  FR_INTEGRATE_MODE,
  FrBatteryEnum,
  keepGrain,
  genderArr,
  taxPeriodArr,
  phoneReg,
  emailReg,
  applyEoriObj,
  vatTerminationOptions,
  payMentLabel,
  authorizeMTD,
  BATTERY_TYPE_LIST,
  DECLARE_TYPE_OPTIONS,
  shareholderIdCardType,
  OtherInfoTypeEnum,
  shareholderProveFileType,
  shareholderProveFileType1,
  shareholderProveOtherFileType,
  orderSourceArr,
  legalEntityCardTypeMap,
  advCountryList,
  vatTaxStatusList,
  newEprTaxStatusList,
  taxDeclaraData,
  taxRuleList,
  spinRange,
  baseRuleList,
  WORK_MARK_STATUS,
  WORK_MARK_STATUS_MAP,
  WORK_MARK_STATUS_LIST,
  exampleList,
  registeredUrbanAreaObj,
  weeeProductType,
  applyTypeObj,
  imgObjList,
  batchOperationDeclare,
  businessTypes_4kyx,
  LZ_ATTRIBATE,
  CzechCountryList,
  standardList,
  standardMap,
  userStandardList,
  primaryServiceList,
  renewalServiceList,
  countryList,
  options,
  selectOptions,
  selectVatTerminationOptions,
  taxPeriodList,
  serviceInformationTaxPeriodList,
  EPR_REPORT_UPLOAD_STATUS,
  DECLARE_PERIOD_MAP,
  DECLARE_PERIOD,
  COUNTRYLIST,
  serviceContryList,
  IPR_ORDER_TYPE_LIST,
  orderTypeStatus,
  taxRuleObj,
  spinProduct,
  ruleStatus,
  MERCH_LABEL_OPTIONS,
  selectSearch,
  enum_9s6q,
  enum_k6u9,
  payTypeList,
  salesPlatformArr,
  CityDistrict,
  dualUser,
  companyObj,
  businessStyleObj,
  businessStyle,
  businessScopeArr,
  cType,
  letterArr,
  wwwConfigcountryList,
  nodeData,
  serviceProgress,
  TASK_ENUM,
  TAG_STATE,
  TAG_STATE_MAP,
  ruleList,
  zeroSaleUrl,
  zeroSaleUrl2,
  imgList,
  BATTERY_WEIGHT_INFO,
  BATTERY_WEIGHT_MAP,
  EPR_SERVICE_OPTIONS,
  validatorIdentifyNumber,
  EPR_SERVICE_COUNTRY,
  serverTypeCopyList,
  standardServiceTypeList,
  search_country_list,
  designCountryList,
  iprUserCountryList,
  couponModules,
  couponType,
  PACKAGETYPE,
  SPAIN_PACKAGETYPE,
  SWEDEM_PACKAGETYPE,
  vipTypeEnum,
  manualVerificationModule,
  configStatusModule,
  memberCenterShow,
  equityList,
  artificialNameVerification,
  couponStatusModules,
  couponStatus,
  italy_material_list,
  hlBatteryCategoryOptions,
  hlBatterySubCategoryOptions,
  IT_BATTERY_LIST,
  IT_W3E_LIST,
  POLAND_BATTERY,
  SWEDEN_BATTERY,
  IRELAND_BATTERY,
  POLAND_WEEE,
  SWEDEN_WEEE,
  IRELAND_WEEE,
  netherlandsPackageEnum,
  belgiumPackageEnum,
  netherlandsBatteryTypeTree,
  belgiumBatteryTypeTree,
  netherlandsWeeeTypeTree,
  belgiumWeeeTypeTree,
  netherlandsTextileTypeEnum,
  netherlandsTextileSubTypeEnum,
  netherlandsTextileTypeTree,
  POLAND_PACKAGING,
  AUTHORIZED_REPRESENTATIVE_CERTIFACATION,
  NB_TEST_CATEGORY_OPTIONS,
  NB_TEST_COUNTRY_OPTIONS,
  NB_TEST_PLATFORM_OPTIONS,
  NB_TEST_BRAND_OPTIONS,
  NB_TEST_SOURCE_TYPE,
  NB_TEST_SOURCE_TYPE_OPTIONS,
  NB_TEST_CATEGORY_VALUE,
  NB_TEST_COUNTRY_VALUE,
  NB_TEST_PLATFORM_VALUE,
  NB_TEST_BASIC_INFO_FIELD_CONFIG,
  NB_TEST_BASIC_INFO_COUNTRY_LIST_FIELD,
  parseNbTestBasicInfoFormData,
  getNbTestBasicInfoCountryList,
  getNbTestBasicInfoDisplayList
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/common/product.js